// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Entity/WizardAddEntity.css */
/* 4-step expert wizard - Full screen layout */

/* ===================== FULL PAGE LAYOUT ===================== */

.wizard-add-entity {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #F8FAFC;
  overflow: hidden;
}

/* ===================== FULLPAGE EDIT MODE ===================== */

.wizard-add-entity.fullpage {
  position: fixed;
  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */
  left: 228px;  /* After sidebar (220px) + lanes padding (8px) */
  right: 8px;   /* Same margin as lanes-container */
  bottom: 8px;  /* Same margin as lanes-container */
  z-index: 1100;
  border-radius: 10px;
  border: 1px solid #BDC3C7;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.wizard-add-entity.fullpage .wizard-body {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.wizard-add-entity .wizard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  flex-shrink: 0;
}

.wizard-add-entity .wizard-header.edit-mode .header-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.wizard-add-entity .wizard-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.wizard-add-entity .wizard-header .legal-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
}

.wizard-add-entity .wizard-header .tax-badge {
  background: rgba(255,255,255,0.15);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.wizard-add-entity .wizard-header .activity-badge {
  font-size: 12px;
  opacity: 0.85;
}

.wizard-add-entity .wizard-header .header-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.wizard-add-entity .wizard-header .btn-save {
  background: white;
  color: #D97706;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .wizard-header .btn-save:hover {
  background: #FEF3C7;
}

.wizard-add-entity .wizard-header .btn-save.saving {
  opacity: 0.7;
  cursor: wait;
}

.wizard-add-entity .wizard-header .btn-save.success {
  background: #10B981;
  color: white;
}

.wizard-add-entity .wizard-header .btn-close {
  background: rgba(255,255,255,0.2);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-add-entity .wizard-header .btn-close:hover {
  background: rgba(255,255,255,0.3);
}

.wizard-add-entity .wizard-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
}

/* ===================== TOPBAR ===================== */

.wizard-add-entity .entity-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  flex-shrink: 0;
  gap: 16px;
}

.wizard-add-entity .entity-topbar h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}

/* Steps indicator */
.wizard-add-entity .steps-indicator {
  display: flex;
  gap: 8px;
}

.wizard-add-entity .step-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  background: rgba(255,255,255,0.15);
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .step-indicator:hover {
  background: rgba(255,255,255,0.25);
}

.wizard-add-entity .step-indicator.active {
  background: white;
}

.wizard-add-entity .step-indicator.active .step-num {
  background: #F59E0B;
  color: white;
}

.wizard-add-entity .step-indicator.active .step-label {
  color: #D97706;
  font-weight: 600;
}

.wizard-add-entity .step-indicator.done {
  background: rgba(16, 185, 129, 0.3);
}

.wizard-add-entity .step-indicator.done .step-num {
  background: #10B981;
}

.wizard-add-entity .step-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: white;
}

.wizard-add-entity .step-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255,255,255,0.9);
}

.wizard-add-entity .topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wizard-add-entity .save-btn {
  padding: 6px 16px;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .save-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.35);
}

.wizard-add-entity .save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wizard-add-entity .close-btn {
  background: rgba(255,255,255,0.2);
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 18px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-add-entity .close-btn:hover {
  background: rgba(255,255,255,0.3);
}

/* ===================== BODY ===================== */

.wizard-add-entity .entity-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* ===================== STEP CONTENT ===================== */

.wizard-add-entity .step-content {
  width: 100%;
  animation: fadeInStep 0.3s ease-out;
}

@keyframes fadeInStep {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===================== IDENTITY STEP ===================== */

.wizard-add-entity .identity-step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wizard-add-entity .form-row-flex {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.wizard-add-entity .flex-1 { flex: 1 1; }
.wizard-add-entity .flex-2 { flex: 2 1; }
.wizard-add-entity .flex-3 { flex: 3 1; }

.wizard-add-entity .form-section {
  background: white;
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .form-section h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 12px 0;
}

.wizard-add-entity .input-name {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
}

.wizard-add-entity .form-section.flex-2,
.wizard-add-entity .form-section.flex-3 {
  min-width: 0; /* Permet au flex item de shrink */
  overflow: hidden;
}

.wizard-add-entity .input-name:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Creation Date */
.wizard-add-entity .creation-date-group {
  margin-top: 12px;
}

.wizard-add-entity .input-date {
  width: 160px;
  max-width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  box-sizing: border-box;
}

.wizard-add-entity .input-date:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Code postal pour CFE avec détection ville */
.wizard-add-entity .postal-with-city {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wizard-add-entity .input-postal {
  width: 80px;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  text-align: center;
  background: white;
}

.wizard-add-entity .input-postal:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-entity .detected-city {
  font-size: 13px;
  color: #059669;
  font-weight: 500;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateX(-5px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Legal Form Grid */
.wizard-add-entity .legal-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
}

.wizard-add-entity .legal-form-card {
  padding: 10px 12px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  background: white;
}

.wizard-add-entity .legal-form-card:hover {
  border-color: #F59E0B;
  background: #FFFBEB;
}

.wizard-add-entity .legal-form-card.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
}

.wizard-add-entity .lf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.wizard-add-entity .lf-label {
  font-size: 14px;
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-entity .lf-manager {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
}

.wizard-add-entity .lf-manager.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .lf-manager.as {
  background: #D1FAE5;
  color: #047857;
}

.wizard-add-entity .lf-manager.none {
  background: #F1F5F9;
  color: #94A3B8;
}

.wizard-add-entity .lf-desc {
  font-size: 10px;
  color: #64748B;
  line-height: 1.3;
}

.wizard-add-entity .gerant-option {
  margin-top: 10px;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 6px;
}

.wizard-add-entity .gerant-option label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #475569;
  cursor: pointer;
}

/* Tax Regime Options */
.wizard-add-entity .regime-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-add-entity .regime-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .regime-option:hover {
  border-color: #F59E0B;
}

.wizard-add-entity .regime-option.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
}

.wizard-add-entity .regime-icon {
  font-size: 18px;
}

.wizard-add-entity .regime-label {
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .regime-desc {
  font-size: 10px;
  color: #64748B;
}

.wizard-add-entity .recommended-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Activity Chips */
.wizard-add-entity .activity-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.wizard-add-entity .chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 20px;
  background: white;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .chip:hover {
  border-color: #F59E0B;
  color: #D97706;
}

.wizard-add-entity .chip.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
  color: #D97706;
  font-weight: 600;
}

.wizard-add-entity .chip-icon {
  font-size: 14px;
}

/* Form Group */
.wizard-add-entity .form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wizard-add-entity .form-group label {
  font-size: 11px;
  font-weight: 500;
  color: #64748B;
}

/* Input with suffix wrapper */
.wizard-add-entity .input-suffix-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}

.wizard-add-entity .input-suffix-wrapper input {
  flex: 1 1;
  padding: 8px 10px;
  border: none;
  font-size: 13px;
  min-width: 60px;
}

.wizard-add-entity .input-suffix-wrapper input:focus {
  outline: none;
}

.wizard-add-entity .input-suffix-wrapper .suffix {
  padding: 8px 10px;
  background: #F8FAFC;
  font-size: 11px;
  color: #64748B;
  white-space: nowrap;
}

.wizard-add-entity .input-suffix-wrapper.large input {
  padding: 12px 14px;
  font-size: 16px;
  font-weight: 500;
}

.wizard-add-entity .input-suffix-wrapper.large .suffix {
  padding: 12px 14px;
  font-size: 13px;
}

/* Fiscal Year Options */
.wizard-add-entity .fiscal-year-options {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.wizard-add-entity .fy-btn {
  padding: 6px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .fy-btn:hover {
  border-color: #F59E0B;
}

.wizard-add-entity .fy-btn.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
  color: #D97706;
  font-weight: 600;
}

.wizard-add-entity .fy-custom-input {
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
  width: 70px;
  text-align: center;
  box-sizing: border-box;
}

/* APE Search */
.wizard-add-entity .ape-group {
  position: relative;
  min-width: 200px;
}

.wizard-add-entity .ape-search-wrapper {
  position: relative;
}

.wizard-add-entity .ape-search-wrapper input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
}

.wizard-add-entity .ape-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 100;
}

.wizard-add-entity .ape-option {
  padding: 8px 10px;
  font-size: 11px;
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.wizard-add-entity .ape-option:hover {
  background: #FEF3C7;
}

.wizard-add-entity .ape-option strong {
  color: #D97706;
  margin-right: 6px;
}

.wizard-add-entity .ape-selected {
  display: inline-block;
  margin-top: 6px;
  padding: 3px 8px;
  background: #FEF3C7;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #D97706;
}

/* ===================== CHARGES STEP ===================== */

.wizard-add-entity .charges-step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Mode Selector (Simplifié / Détaillé) */
.wizard-add-entity .mode-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .mode-toggle.large {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: #F1F5F9;
  border-radius: 10px;
}

.wizard-add-entity .mode-toggle.large button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .mode-toggle.large button:hover {
  color: #1E293B;
}

.wizard-add-entity .mode-toggle.large button.active {
  background: white;
  color: #D97706;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.wizard-add-entity .mode-icon {
  font-size: 16px;
}

.wizard-add-entity .mode-hint {
  font-size: 12px;
  color: #94A3B8;
}

/* Section icon */
.wizard-add-entity .section-icon {
  margin-right: 6px;
}

/* PCG Badge - numéro de compte comptable */
.wizard-add-entity .pcg-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  margin-right: 6px;
  background: linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%);
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #64748B;
  font-family: monospace;
}

.wizard-add-entity .pcg-badge.small {
  padding: 1px 4px;
  margin-right: 4px;
  font-size: 9px;
}

.wizard-add-entity h4 .pcg-badge {
  margin-left: 4px;
}

.wizard-add-entity h5 .pcg-badge {
  vertical-align: middle;
}

/* Simple row (mode simplifié) */
.wizard-add-entity .simple-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.wizard-add-entity .simple-calc {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 14px;
  background: #F8FAFC;
  border-radius: 6px;
  min-width: 140px;
}

.wizard-add-entity .simple-calc .calc-label {
  font-size: 10px;
  color: #64748B;
}

.wizard-add-entity .simple-calc .calc-value {
  font-size: 16px;
  font-weight: 700;
  color: #D97706;
}

/* ACRE toggle (mode simplifié) */
.wizard-add-entity .acre-toggle {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .checkbox-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.wizard-add-entity .checkbox-inline input {
  width: 16px;
  height: 16px;
}

.wizard-add-entity .checkbox-inline span {
  font-size: 13px;
  color: #1E293B;
}

.wizard-add-entity .checkbox-inline .hint {
  font-size: 11px;
  color: #16A34A;
  font-style: italic;
}

/* Employees switch */
.wizard-add-entity .employees-switch {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
}

.wizard-add-entity .switch-option {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
}

.wizard-add-entity .employees-row {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .small-input {
  width: 60px;
  padding: 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
}

/* Charge type selector */
.wizard-add-entity .charge-type-selector {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.wizard-add-entity .charge-type-option {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.wizard-add-entity .charge-type-option .option-label {
  font-size: 13px;
  color: #475569;
}

.wizard-add-entity .charge-input-large {
  max-width: 280px;
}

/* Dividend slider */
.wizard-add-entity .dividend-slider {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wizard-add-entity .dividend-slider input[type="range"] {
  flex: 1 1;
  max-width: 200px;
  height: 6px;
  appearance: none;
  background: #E2E8F0;
  border-radius: 3px;
  outline: none;
}

.wizard-add-entity .dividend-slider input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #F59E0B;
  border-radius: 50%;
  cursor: pointer;
}

.wizard-add-entity .dividend-value {
  font-size: 18px;
  font-weight: 700;
  color: #D97706;
  min-width: 50px;
}

.wizard-add-entity .dividend-hint {
  font-size: 12px;
  color: #94A3B8;
}

/* Detail tabs */
.wizard-add-entity .detail-tabs {
  display: flex;
  gap: 8px;
  padding: 4px;
  background: #F1F5F9;
  border-radius: 10px;
  margin-bottom: 16px;
}

.wizard-add-entity .detail-tabs button {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .detail-tabs button:hover {
  color: #1E293B;
}

.wizard-add-entity .detail-tabs button.active {
  background: white;
  color: #D97706;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.wizard-add-entity .tab-icon {
  font-size: 14px;
}

.wizard-add-entity .tab-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Employees details grid (mode détaillé) */
.wizard-add-entity .employees-details-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .centered-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
}

.wizard-add-entity .employees-summary {
  grid-column: span 3;
  background: #F8FAFC;
  border-radius: 8px;
  padding: 12px;
  margin-top: 8px;
}

.wizard-add-entity .employees-summary .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
}

.wizard-add-entity .employees-summary .summary-row span {
  color: #64748B;
}

.wizard-add-entity .employees-summary .summary-row strong {
  color: #1E293B;
}

.wizard-add-entity .employees-summary .summary-row .negative {
  color: #DC2626;
}

.wizard-add-entity .employees-summary .summary-row.total {
  border-top: 1px solid #E2E8F0;
  padding-top: 10px;
  margin-top: 4px;
}

.wizard-add-entity .employees-summary .summary-row.total strong {
  color: #D97706;
  font-size: 15px;
}

/* Advanced options grid */
.wizard-add-entity .advanced-options-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wizard-add-entity .advanced-options-grid .option-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  background: #F8FAFC;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .advanced-options-grid .option-toggle:hover {
  background: #F1F5F9;
}

.wizard-add-entity .advanced-options-grid .option-toggle input {
  margin-top: 2px;
}

.wizard-add-entity .option-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wizard-add-entity .option-name {
  font-size: 13px;
  font-weight: 500;
  color: #1E293B;
}

.wizard-add-entity .option-desc {
  font-size: 11px;
  color: #64748B;
}

/* CIR amount input */
.wizard-add-entity .cir-amount-input {
  margin-left: 26px;
  padding: 12px;
  background: #FEF3C7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.wizard-add-entity .cir-amount-input label {
  font-size: 12px;
  color: #64748B;
}

.wizard-add-entity .cir-amount-input .input-suffix-wrapper {
  max-width: 150px;
}

.wizard-add-entity .cir-calc {
  font-size: 13px;
  font-weight: 600;
  color: #10B981;
}

/* Dividend input row (mode détaillé) */
.wizard-add-entity .dividend-input-row {
  max-width: 250px;
}

/* Info banner */
.wizard-add-entity .info-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  border-radius: 8px;
  font-size: 12px;
  color: #1E40AF;
}

.wizard-add-entity .info-banner .info-icon {
  font-size: 14px;
}

/* Entity Summary Bar */
.wizard-add-entity .entity-summary-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: white;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .legal-badge {
  padding: 4px 10px;
  background: #F59E0B;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
}

.wizard-add-entity .entity-summary-bar .entity-name {
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .tax-badge {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.wizard-add-entity .tax-badge.is {
  background: #3B82F6;
  color: white;
}

.wizard-add-entity .tax-badge.ir {
  background: #10B981;
  color: white;
}

.wizard-add-entity .manager-badge {
  padding: 3px 8px;
  background: #E0E7FF;
  color: #4338CA;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

/* Manager Type Tag */
.wizard-add-entity .manager-type-tag {
  margin-left: 8px;
  padding: 2px 8px;
  background: #E0E7FF;
  color: #4338CA;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

/* Manager Remuneration Grid */
.wizard-add-entity .manager-remu-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: end;
}

.wizard-add-entity .manager-remu-grid > .form-group {
  flex: 1 1;
  min-width: 120px;
  max-width: 180px;
}

.wizard-add-entity .manager-remu-grid > .months-group {
  flex: 0 0 70px;
  min-width: 60px;
}

.wizard-add-entity .months-group select {
  width: 100%;
  padding: 8px 4px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
}

.wizard-add-entity .manager-calc-result {
  background: #F8FAFC;
  border-radius: 8px;
  padding: 12px 16px;
  flex: 0 0 auto;
  min-width: 170px;
}

.wizard-add-entity .calc-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 12px;
}

.wizard-add-entity .calc-row span {
  color: #64748B;
}

.wizard-add-entity .calc-row strong {
  color: #1E293B;
}

.wizard-add-entity .calc-row .negative {
  color: #DC2626;
}

.wizard-add-entity .calc-row.total {
  border-top: 1px solid #E2E8F0;
  margin-top: 4px;
  padding-top: 8px;
}

.wizard-add-entity .calc-row.total strong {
  color: #D97706;
  font-size: 14px;
}

/* Section Header with Toggle */
.wizard-add-entity .section-header-with-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.wizard-add-entity .section-header-with-toggle h4 {
  margin: 0;
}

.wizard-add-entity .mode-toggle {
  display: flex;
  background: #F1F5F9;
  border-radius: 6px;
  overflow: hidden;
}

.wizard-add-entity .mode-toggle button {
  padding: 6px 14px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .mode-toggle button.active {
  background: white;
  color: #D97706;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

/* Simplified Charges */
.wizard-add-entity .simplified-charges {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wizard-add-entity .charge-mode-selector {
  display: flex;
  gap: 16px;
}

.wizard-add-entity .charge-mode-selector label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #475569;
  cursor: pointer;
}

.wizard-add-entity .simplified-input {
  max-width: 300px;
}

/* Detailed Charges */
.wizard-add-entity .detailed-charges {
  max-height: 300px;
  overflow-y: auto;
}

.wizard-add-entity .charges-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wizard-add-entity .charge-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 6px;
  transition: all 0.15s;
}

.wizard-add-entity .charge-line.enabled {
  background: #FEF3C7;
}

.wizard-add-entity .charge-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.wizard-add-entity .charge-toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.wizard-add-entity .charge-icon {
  font-size: 14px;
}

.wizard-add-entity .charge-label {
  font-size: 12px;
  color: #475569;
}

.wizard-add-entity .charge-value-input {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .charge-value-input select {
  padding: 4px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
  background: white;
}

.wizard-add-entity .charge-value-input input {
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

/* Collapsed Section */
.wizard-add-entity .collapsed-section {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
}

.wizard-add-entity .collapsed-section summary {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
}

.wizard-add-entity .collapsed-section summary:hover {
  color: #D97706;
}

.wizard-add-entity .advanced-options {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wizard-add-entity .option-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.wizard-add-entity .option-toggle input {
  width: 16px;
  height: 16px;
}

.wizard-add-entity .option-toggle span {
  font-size: 13px;
  color: #1E293B;
}

.wizard-add-entity .option-desc {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .sub-option {
  margin-left: 24px;
  padding: 10px;
  background: #F8FAFC;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.wizard-add-entity .sub-option label {
  font-size: 12px;
  color: #64748B;
}

.wizard-add-entity .sub-option .input-suffix-wrapper {
  max-width: 150px;
}

.wizard-add-entity .calc-hint {
  font-size: 11px;
  color: #10B981;
  font-weight: 500;
}

/* Advanced Options Inline */
.wizard-add-entity .advanced-options-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  margin-top: 0;
}

.wizard-add-entity .advanced-options-inline label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-add-entity .cir-inline-input {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-add-entity .cir-inline-input label {
  font-size: 12px;
  color: #64748B;
}

.wizard-add-entity .cir-inline-input .input-suffix-wrapper {
  max-width: 120px;
}

/* Dividend Input */
.wizard-add-entity .dividend-input {
  max-width: 250px;
}

/* ===================== CA STEP ===================== */

.wizard-add-entity .ca-step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wizard-add-entity .source-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.wizard-add-entity .add-source-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 2px dashed #CBD5E1;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .add-source-btn:hover {
  border-color: #F59E0B;
  background: #FFFBEB;
  color: #D97706;
}

.wizard-add-entity .add-source-btn .btn-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: white;
}

/* Sources List */
.wizard-add-entity .sources-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wizard-add-entity .empty-sources {
  padding: 40px;
  text-align: center;
  color: #94A3B8;
  font-size: 14px;
}

.wizard-add-entity .source-card {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
}

.wizard-add-entity .source-card.expanded {
  border-color: #F59E0B;
}

.wizard-add-entity .source-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.wizard-add-entity .source-header:hover {
  background: #FAFAFA;
}

.wizard-add-entity .source-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: white;
}

.wizard-add-entity .source-type {
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  min-width: 100px;
}

.wizard-add-entity .source-label {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 12px;
  background: transparent;
}

.wizard-add-entity .source-label:hover,
.wizard-add-entity .source-label:focus {
  border-color: #E2E8F0;
  background: white;
  outline: none;
}

.wizard-add-entity .source-date {
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  width: 130px;
}

.wizard-add-entity .date-sep {
  color: #94A3B8;
  font-size: 12px;
}

.wizard-add-entity .expand-icon {
  font-size: 10px;
  color: #94A3B8;
  padding: 0 6px;
}

.wizard-add-entity .remove-btn {
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  font-size: 16px;
  color: #94A3B8;
  cursor: pointer;
  border-radius: 4px;
}

.wizard-add-entity .remove-btn:hover {
  background: #FEE2E2;
  color: #DC2626;
}

/* Exercices Table */
.wizard-add-entity .exercices-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
}

.wizard-add-entity .exercices-table thead {
  background: #F8FAFC;
}

.wizard-add-entity .exercices-table th {
  padding: 10px 12px;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .exercices-table td {
  padding: 10px 12px;
  font-size: 12px;
  border-bottom: 1px solid #F1F5F9;
}

.wizard-add-entity .exercices-table td strong {
  color: #1E293B;
}

.wizard-add-entity .exercices-table .periode {
  color: #64748B;
  font-size: 11px;
}

.wizard-add-entity .ca-input {
  display: flex;
  align-items: center;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}

.wizard-add-entity .ca-input input {
  flex: 1 1;
  padding: 6px 10px;
  border: none;
  font-size: 13px;
  text-align: right;
  width: 100px;
}

.wizard-add-entity .ca-input input:focus {
  outline: none;
}

.wizard-add-entity .ca-input span {
  padding: 6px 10px;
  background: #F8FAFC;
  font-size: 11px;
  color: #64748B;
}

/* ===================== SUMMARY STEP ===================== */

.wizard-add-entity .summary-step {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wizard-add-entity .summary-header {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .entity-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.wizard-add-entity .entity-info h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-entity .badge {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
}

.wizard-add-entity .badge.legal {
  background: #F59E0B;
  color: white;
}

.wizard-add-entity .badge.tax.is {
  background: #3B82F6;
  color: white;
}

.wizard-add-entity .badge.tax.ir {
  background: #10B981;
  color: white;
}

.wizard-add-entity .entity-details {
  font-size: 12px;
  color: #64748B;
}

/* Exercices Grid */
.wizard-add-entity .exercices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.wizard-add-entity .exercice-card {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
}

.wizard-add-entity .exercice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
}

.wizard-add-entity .ex-label {
  font-size: 14px;
  font-weight: 700;
}

.wizard-add-entity .ex-dates {
  font-size: 10px;
  opacity: 0.9;
}

.wizard-add-entity .year-badge {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
  margin-left: 6px;
}

.wizard-add-entity .year-badge.first {
  background: rgba(255,255,255,0.3);
  color: white;
}

.wizard-add-entity .year-badge.second {
  background: rgba(255,255,255,0.2);
  color: rgba(255,255,255,0.9);
}

/* Tags d'exonération */
.wizard-add-entity .tag-exo {
  display: inline-block;
  padding: 1px 5px;
  margin-left: 6px;
  background: #DCFCE7;
  color: #16A34A;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .tag-reduc {
  display: inline-block;
  padding: 1px 5px;
  margin-left: 6px;
  background: #FEF3C7;
  color: #D97706;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .exercice-body {
  padding: 12px 14px;
}

.wizard-add-entity .pl-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 12px;
  color: #64748B;
}

.wizard-add-entity .pl-row.indent {
  padding-left: 12px;
  font-size: 11px;
}

.wizard-add-entity .pl-row .neg {
  color: #DC2626;
}

.wizard-add-entity .pl-row.sub-total {
  border-top: 1px dashed #E2E8F0;
  padding-top: 6px;
  margin-top: 4px;
}

.wizard-add-entity .pl-row.total {
  border-top: 1px solid #E2E8F0;
  padding-top: 8px;
  margin-top: 6px;
}

.wizard-add-entity .pl-row.total strong {
  font-size: 14px;
  color: #D97706;
}

.wizard-add-entity .exercice-footer {
  padding: 8px 14px;
  background: #F8FAFC;
  border-top: 1px solid #E2E8F0;
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .empty-summary {
  padding: 40px;
  text-align: center;
  color: #94A3B8;
}

/* Summary Sections */
.wizard-add-entity .summary-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
  margin-bottom: 12px;
}

.wizard-add-entity .summary-section h4 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #F1F5F9;
  padding-bottom: 8px;
}

.wizard-add-entity .summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.wizard-add-entity .summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wizard-add-entity .summary-item.wide {
  grid-column: span 2;
}

.wizard-add-entity .summary-label {
  font-size: 11px;
  color: #94A3B8;
  font-weight: 500;
}

.wizard-add-entity .summary-value {
  font-size: 14px;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.wizard-add-entity .summary-value.highlight {
  color: #059669;
  font-size: 16px;
}

.wizard-add-entity .summary-value.negative {
  color: #DC2626;
}

.wizard-add-entity .summary-value.total {
  color: #D97706;
  font-size: 16px;
}

/* Manager badge in summary */
.wizard-add-entity .badge.manager {
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 700;
  border-radius: 4px;
}

.wizard-add-entity .badge.manager.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .badge.manager.as {
  background: #D1FAE5;
  color: #047857;
}

.wizard-add-entity .badge.manager.none {
  background: #F1F5F9;
  color: #94A3B8;
}

/* Mode badge */
.wizard-add-entity .badge.mode {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.wizard-add-entity .badge.mode.simplified {
  background: #E0E7FF;
  color: #4338CA;
}

.wizard-add-entity .badge.mode.detailed {
  background: #FEF3C7;
  color: #D97706;
}

/* Option badge */
.wizard-add-entity .badge.option {
  padding: 4px 10px;
  background: #ECFDF5;
  color: #059669;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.wizard-add-entity .summary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Sources summary list */
.wizard-add-entity .sources-summary-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-add-entity .source-summary-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: #F8FAFC;
  border-radius: 8px;
}

.wizard-add-entity .source-summary-item .source-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: white;
  flex-shrink: 0;
}

.wizard-add-entity .source-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wizard-add-entity .source-info strong {
  font-size: 13px;
  color: #1E293B;
}

.wizard-add-entity .source-dates {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .source-exercices {
  font-size: 10px;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .no-sources-warning {
  padding: 16px;
  background: #FEF3C7;
  border-radius: 8px;
  color: #D97706;
  font-size: 12px;
  text-align: center;
}

/* Exercices preview section */
.wizard-add-entity .summary-section.exercices-preview h4 {
  color: #D97706;
}

/* Summary action button */
.wizard-add-entity .summary-action {
  margin-top: 20px;
  text-align: center;
}

.wizard-add-entity .create-entity-btn {
  padding: 14px 40px;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.wizard-add-entity .create-entity-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

.wizard-add-entity .create-entity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ===================== WIZARD FOOTER ===================== */

.wizard-add-entity .wizard-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: white;
  border-top: 1px solid #E2E8F0;
  flex-shrink: 0;
}

.wizard-add-entity .nav-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: #F1F5F9;
  color: #64748B;
}

.wizard-add-entity .nav-btn:hover:not(:disabled) {
  background: #E2E8F0;
}

.wizard-add-entity .nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.wizard-add-entity .nav-btn.primary {
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
}

.wizard-add-entity .nav-btn.primary:hover:not(:disabled) {
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
  transform: translateY(-1px);
}

.wizard-add-entity .step-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .step-warning {
  font-size: 11px;
  color: #D97706;
  background: #FEF3C7;
  padding: 4px 12px;
  border-radius: 4px;
  text-align: center;
}

.wizard-add-entity .step-dots {
  display: flex;
  gap: 6px;
}

.wizard-add-entity .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #E2E8F0;
  transition: all 0.2s;
}

.wizard-add-entity .dot.active {
  background: #F59E0B;
  transform: scale(1.3);
}

.wizard-add-entity .dot.done {
  background: #10B981;
}

/* ===================== RESPONSIVE ===================== */

@media (max-width: 900px) {
  .wizard-add-entity .form-row-flex {
    flex-direction: column;
  }

  .wizard-add-entity .manager-remu-grid {
    grid-template-columns: 1fr;
  }

  .wizard-add-entity .exercices-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .wizard-add-entity .entity-topbar {
    flex-direction: column;
    gap: 10px;
    padding: 10px 12px;
  }

  .wizard-add-entity .steps-indicator {
    order: -1;
    flex-wrap: wrap;
    justify-content: center;
  }

  .wizard-add-entity .source-header {
    flex-wrap: wrap;
  }

  .wizard-add-entity .source-date {
    width: 100%;
  }

  .wizard-add-entity .legal-form-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* ===================== ADDITIONAL STYLES FOR WIZARD ===================== */

/* Field hint */
.wizard-add-entity .field-hint {
  display: block;
  font-size: 11px;
  color: #94A3B8;
  margin-top: 4px;
  font-style: italic;
}

/* Source button with description */
.wizard-add-entity .add-source-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
}

.wizard-add-entity .add-source-btn .btn-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.wizard-add-entity .add-source-btn .btn-content strong {
  font-size: 13px;
}

.wizard-add-entity .add-source-btn .btn-content small {
  font-size: 10px;
  color: #94A3B8;
  font-weight: normal;
}

/* Charges column in table */
.wizard-add-entity .exercices-table .charges-col {
  text-align: right;
}

.wizard-add-entity .exercices-table .charge-value {
  color: #DC2626;
  font-size: 12px;
  font-weight: 500;
}

/* Action column */
.wizard-add-entity .exercices-table .action-col {
  text-align: center;
  width: 70px;
}

/* Detail button - gear icon */
.wizard-add-entity .td-detail {
  width: 40px;
  text-align: center;
}

.wizard-add-entity .detail-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.wizard-add-entity .detail-btn:hover {
  background: #E2E8F0;
  border-color: #CBD5E1;
}

.wizard-add-entity .detail-btn.has-detail {
  background: #DBEAFE;
  border-color: #3B82F6;
  color: #2563EB;
}

/* ===================== ACRE STYLES ===================== */

/* ACRE badge */
.wizard-add-entity .acre-badge {
  display: inline-block;
  padding: 2px 6px;
  background: #DCFCE7;
  color: #16A34A;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  margin-left: 4px;
}

/* ACRE option */
.wizard-add-entity .acre-option {
  margin-top: 12px;
  padding: 10px;
  background: #F0FDF4;
  border-radius: 6px;
  border: 1px solid #BBF7D0;
}

.wizard-add-entity .acre-option .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.wizard-add-entity .acre-option .option-hint {
  font-size: 11px;
  color: #16A34A;
  font-style: italic;
}

/* ===================== EMPLOYEES STYLES ===================== */

/* Employees section */
.wizard-add-entity .employees-toggle {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
}

.wizard-add-entity .radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.wizard-add-entity .employees-details {
  padding: 12px;
  background: #F8FAFC;
  border-radius: 6px;
  margin-top: 8px;
}

.wizard-add-entity .employees-calc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E8F0;
  font-size: 13px;
}

.wizard-add-entity .employees-calc strong {
  color: #D97706;
}

/* ===================== CHARGES OBLIGATOIRES ===================== */

/* Charges obligatoires */
.wizard-add-entity .charges-obligatoires .info-tag {
  font-size: 10px;
  color: #94A3B8;
  font-weight: normal;
  margin-left: 8px;
}

.wizard-add-entity .obligatory-charges-info {
  background: #F1F5F9;
  border-radius: 6px;
  padding: 12px;
}

.wizard-add-entity .charge-info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wizard-add-entity .charge-info-row .charge-label {
  flex: 1 1;
  font-size: 13px;
}

.wizard-add-entity .charge-info-row .charge-value {
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .charge-info-row .charge-note {
  font-size: 11px;
  color: #16A34A;
  font-style: italic;
}

/* ===================== FY CUSTOM WRAPPER ===================== */

.wizard-add-entity .fy-custom-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.wizard-add-entity .fy-selected-value {
  padding: 4px 8px;
  background: #FEF3C7;
  color: #D97706;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

/* ===================== HIGHLIGHT DYNAMIQUE ===================== */

/* Titre actif (pour sections à sélection) - flèche + jaune sur le titre uniquement */
.wizard-add-entity .title-active {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 8px;
  background: #FEF3C7;
  border-radius: 6px;
  color: #D97706 !important;
  font-weight: 700 !important;
}

.wizard-add-entity .title-active::before {
  content: '→';
  font-size: 16px;
  color: #F59E0B;
  animation: bounce-arrow 1s ease-in-out infinite;
}

/* Highlight dynamique - champ input actif (nom, date, capital) - JAUNE FORT */
.wizard-add-entity .field-active {
  position: relative;
  background: #FEF3C7 !important;
  border-radius: 8px;
  padding: 12px;
  margin: -12px;
  margin-bottom: 0;
}

.wizard-add-entity .field-active::before {
  content: '→';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #F59E0B;
  font-weight: bold;
  animation: bounce-arrow 1s ease-in-out infinite;
}

.wizard-add-entity .field-active label,
.wizard-add-entity .field-active h4 {
  color: #D97706 !important;
  font-weight: 700 !important;
}

.wizard-add-entity .field-active input,
.wizard-add-entity .field-active select {
  border-color: #F59E0B !important;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.3) !important;
  background: white !important;
}

/* Animation flèche */
@keyframes bounce-arrow {
  0%, 100% { transform: translateY(-50%) translateX(0); }
  50% { transform: translateY(-50%) translateX(5px); }
}

/* Champ input rempli - JAUNE LÉGER pour montrer qu'il est rempli */
.wizard-add-entity .field-filled {
  position: relative;
}

.wizard-add-entity .field-filled::after {
  content: '✓';
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 14px;
  color: #16A34A;
  font-weight: bold;
}

.wizard-add-entity .field-filled label,
.wizard-add-entity .field-filled h4 {
  color: #92400E;
}

.wizard-add-entity .field-filled input,
.wizard-add-entity .field-filled select {
  background: #FEF9C3;
  border-color: #FCD34D;
}

/* ===================== FY CUSTOM INPUT ===================== */

.wizard-add-entity .fy-format-hint {
  font-size: 11px;
  color: #94A3B8;
}

/* ===================== MANAGERS TABLE (Step 2) ===================== */

.wizard-add-entity .managers-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .managers-table table {
  width: 100%;
  border-collapse: collapse;
}

.wizard-add-entity .managers-table th {
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.wizard-add-entity .managers-table td {
  padding: 10px;
  border-bottom: 1px solid #F1F5F9;
  vertical-align: middle;
}

.wizard-add-entity .managers-table .td-role {
  min-width: 100px;
}

.wizard-add-entity .managers-table .role-label {
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .managers-table .select-months {
  width: 60px;
  padding: 6px 4px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}

.wizard-add-entity .managers-table .input-percent {
  width: 50px;
  text-align: center;
}

.wizard-add-entity .managers-table .td-status {
  min-width: 120px;
}

.wizard-add-entity .managers-table .status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.wizard-add-entity .managers-table .status-badge.tns {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .managers-table .status-badge.as {
  background: #D1FAE5;
  color: #047857;
}

.wizard-add-entity .managers-table .td-actions {
  width: 40px;
  text-align: center;
}

.wizard-add-entity .btn-remove-manager {
  width: 24px;
  height: 24px;
  border: none;
  background: #FEE2E2;
  color: #DC2626;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .btn-remove-manager:hover {
  background: #DC2626;
  color: white;
}

.wizard-add-entity .btn-add-manager {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border: 2px dashed #CBD5E1;
  border-radius: 6px;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .btn-add-manager:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

.wizard-add-entity .btn-add-manager.modal-add {
  margin-top: 12px;
  width: 100%;
  justify-content: center;
}

.wizard-add-entity .sarl-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px;
  background: #EFF6FF;
  border-radius: 6px;
  font-size: 12px;
  color: #1E40AF;
}

.wizard-add-entity .sarl-info .info-icon {
  font-size: 14px;
}

/* Compact input suffix wrapper */
.wizard-add-entity .input-suffix-wrapper.compact {
  max-width: 130px;
}

.wizard-add-entity .input-suffix-wrapper.compact input {
  padding: 6px 8px;
  font-size: 13px;
}

.wizard-add-entity .input-suffix-wrapper.compact .suffix {
  padding: 6px 8px;
  font-size: 11px;
}

/* ===================== OPTIONS SECTION (Step 2) ===================== */

.wizard-add-entity .options-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.wizard-add-entity .option-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  background: #F8FAFC;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  min-width: 150px;
}

.wizard-add-entity .option-card:hover {
  background: #F1F5F9;
}

.wizard-add-entity .option-card input[type="checkbox"] {
  margin-top: 2px;
  width: 16px;
  height: 16px;
}

.wizard-add-entity .option-card.tva-option {
  cursor: default;
}

.wizard-add-entity .option-card .select-tva {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  margin-top: 4px;
}

/* ===================== ADVANCED OPTIONS SECTION ===================== */

.wizard-add-entity .advanced-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

/* ===================== CHARGES SECTION (Step 2) ===================== */

.wizard-add-entity .charges-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .charges-simplified,
.wizard-add-entity .charges-detailed {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wizard-add-entity .charge-subsection {
  padding: 12px;
  background: #F8FAFC;
  border-radius: 8px;
}

.wizard-add-entity .charge-subsection h5 {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

/* ===================== EMPLOYEE PROFILES TABLE ===================== */

.wizard-add-entity .employee-profiles-table {
  margin-top: 12px;
  overflow-x: auto;
}

.wizard-add-entity .employee-profiles-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.wizard-add-entity .employee-profiles-table th {
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  text-align: left;
  background: #F1F5F9;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .employee-profiles-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #F1F5F9;
  vertical-align: middle;
}

.wizard-add-entity .employee-profiles-table .input-profile-name {
  width: 100%;
  min-width: 100px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
}

.wizard-add-entity .employee-profiles-table .input-date {
  width: 110px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
}

.wizard-add-entity .employee-profiles-table .input-headcount {
  width: 50px;
  padding: 6px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
}

.wizard-add-entity .employee-profiles-table .prorata-cell {
  text-align: center;
  white-space: nowrap;
}

.wizard-add-entity .employee-profiles-table .prorata-value {
  display: inline-block;
  padding: 4px 8px;
  background: #EFF6FF;
  color: #1E40AF;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.wizard-add-entity .employee-profiles-table .ongoing-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #16A34A;
  cursor: pointer;
}

.wizard-add-entity .employee-profiles-table .ongoing-label input {
  width: 14px;
  height: 14px;
}

.wizard-add-entity .employee-profiles-table .end-date-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .employee-profiles-table .btn-ongoing {
  width: 24px;
  height: 24px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  background: #F8FAFC;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-add-entity .employee-profiles-table .btn-ongoing:hover {
  background: #D1FAE5;
  border-color: #16A34A;
  color: #16A34A;
}

.wizard-add-entity .employee-profiles-table .btn-remove-profile {
  width: 24px;
  height: 24px;
  border: none;
  background: #FEE2E2;
  color: #DC2626;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.wizard-add-entity .employee-profiles-table .btn-remove-profile:hover {
  background: #DC2626;
  color: white;
}

.wizard-add-entity .employee-profiles-table .row-add td {
  padding: 8px;
  background: #F8FAFC;
}

.wizard-add-entity .employee-profiles-table .btn-add-profile {
  width: 100%;
  padding: 8px;
  border: 2px dashed #CBD5E1;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
}

.wizard-add-entity .employee-profiles-table .btn-add-profile:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

/* Step hints */
.wizard-add-entity .step-hints {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.wizard-add-entity .hint-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
}

.wizard-add-entity .hint-item.hint-action {
  background: #EFF6FF;
  color: #1E40AF;
}

.wizard-add-entity .hint-item.hint-warning {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .hint-icon {
  font-size: 14px;
}

/* Exercice badge */
.wizard-add-entity .exercice-badge {
  display: inline-block;
  padding: 2px 6px;
  margin-left: 6px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .exercice-badge.ex-1 {
  background: #DCFCE7;
  color: #16A34A;
}

.wizard-add-entity .exercice-badge.ex-2 {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .exercice-badge.ex-3 {
  background: #E0E7FF;
  color: #4338CA;
}

/* Highlight input for CA */
.wizard-add-entity .highlight-input {
  border-color: #F59E0B !important;
  background: #FFFBEB !important;
}

.wizard-add-entity .highlight-input input {
  background: transparent;
}

/* Needs CA row indicator */
.wizard-add-entity .exercices-table tr.needs-ca {
  background: #FFFBEB;
}

/* Empty hint */
.wizard-add-entity .empty-hint {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #D97706;
}

/* Source hint */
.wizard-add-entity .source-hint {
  padding: 12px 14px;
  background: #F8FAFC;
  font-size: 12px;
  color: #64748B;
  font-style: italic;
}

/* ===================== SUMMARY MULTI-MANAGERS ===================== */

.wizard-add-entity .summary-manager-row {
  margin-bottom: 8px;
}

.wizard-add-entity .manager-separator {
  border: none;
  border-top: 1px dashed #E2E8F0;
  margin: 12px 0;
}

.wizard-add-entity .summary-option-tag {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .summary-label .badge {
  margin-left: 8px;
  vertical-align: middle;
}

/* JEI tag styling */
.wizard-add-entity .tag-jei {
  display: inline-block;
  padding: 1px 5px;
  margin-left: 6px;
  background: #E0E7FF;
  color: #4338CA;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

/* ===================== NEW STEP 3: REVENUS (PRODUITS/CHARGES) ===================== */

/* Header avec dates */
.wizard-add-entity .ca-dates-header {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.wizard-add-entity .ca-dates-header.needs-end-date {
  border: 2px solid #F59E0B;
  background: #FFFBEB;
}

.wizard-add-entity .ca-dates-header .date-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wizard-add-entity .ca-dates-header .date-field.highlight {
  position: relative;
}

.wizard-add-entity .ca-dates-header .date-field label {
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
}

.wizard-add-entity .ca-dates-header .date-field label .required {
  color: #F59E0B;
  font-weight: 700;
}

.wizard-add-entity .ca-dates-header .date-field .field-hint {
  font-size: 10px;
  color: #D97706;
  font-style: italic;
}

.wizard-add-entity .source-date.pulse {
  animation: pulse-border 1.5s ease-in-out infinite;
}

@keyframes pulse-border {
  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }
  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }
}

.wizard-add-entity .empty-sources.waiting {
  background: #FFFBEB;
  border: 1px dashed #F59E0B;
}

.wizard-add-entity .empty-sources .arrow-up {
  font-size: 24px;
  color: #F59E0B;
  display: block;
  margin-bottom: 8px;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

.wizard-add-entity .exercices-count-badge {
  padding: 5px 10px;
  background: #F59E0B;
  color: white;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
}

/* ===================== FORMAT PRODUITS / CHARGES ===================== */

.wizard-add-entity .exercices-pc-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wizard-add-entity .exercice-pc-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  overflow: hidden;
}

/* Header exercice */
.wizard-add-entity .pc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-bottom: 1px solid #F59E0B;
}

.wizard-add-entity .pc-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.wizard-add-entity .pc-title strong {
  font-size: 13px;
  color: #92400E;
}

.wizard-add-entity .pc-periode {
  font-size: 11px;
  color: #B45309;
}

.wizard-add-entity .badge-year {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .badge-year.first {
  background: #D97706;
  color: white;
}

.wizard-add-entity .badge-year.second {
  background: #F59E0B;
  color: white;
}

.wizard-add-entity .badge-opt {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  background: #92400E;
  color: white;
}

.wizard-add-entity .badge-opt.jei {
  background: #7C3AED;
}

.wizard-add-entity .view-toggle {
  padding: 4px 10px;
  border: 1px solid #D97706;
  border-radius: 4px;
  background: white;
  color: #D97706;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .view-toggle:hover {
  background: #D97706;
  color: white;
}

/* Corps Produits/Charges */
.wizard-add-entity .pc-body {
  padding: 8px;
}

.wizard-add-entity .pc-section {
  margin-bottom: 6px;
  border-radius: 6px;
  overflow: hidden;
}

.wizard-add-entity .pc-section:last-child {
  margin-bottom: 0;
}

.wizard-add-entity .pc-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
}

.wizard-add-entity .pc-section.produits .pc-section-header {
  background: #F0FDF4;
  border-color: #86EFAC;
}

.wizard-add-entity .pc-section.charges .pc-section-header {
  background: #FEF3C7;
  border-color: #FCD34D;
}

.wizard-add-entity .pc-section.resultat .pc-section-header {
  background: #EFF6FF;
  border-color: #93C5FD;
}

.wizard-add-entity .pc-section.resultat.negative .pc-section-header {
  background: #FEF2F2;
  border-color: #FCA5A5;
}

.wizard-add-entity .pc-icon {
  font-size: 14px;
}

.wizard-add-entity .pc-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  flex: 1 1;
}

.wizard-add-entity .pc-total {
  font-size: 13px;
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-entity .pc-total.neg {
  color: #B45309;
}

.wizard-add-entity .pc-section.resultat.negative .pc-total {
  color: #DC2626;
}

.wizard-add-entity .pc-settings {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: rgba(0,0,0,0.05);
  color: #64748B;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s;
}

.wizard-add-entity .pc-settings:hover {
  background: rgba(0,0,0,0.1);
  color: #1E293B;
}

/* Détails */
.wizard-add-entity .pc-details {
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-top: none;
  border-radius: 0 0 6px 6px;
  background: white;
}

.wizard-add-entity .pc-line {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.wizard-add-entity .pc-line.secondary {
  padding-left: 12px;
}

.wizard-add-entity .pc-line-label {
  font-size: 12px;
  color: #64748B;
  flex: 1 1;
}

.wizard-add-entity .pc-line-label-input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 12px;
  color: #64748B;
  padding: 2px 4px;
  margin: -2px -4px;
}

.wizard-add-entity .pc-line-label-input:focus {
  outline: none;
  background: #F8FAFC;
  border-radius: 3px;
}

.wizard-add-entity .pc-line-input {
  display: flex;
  align-items: center;
  gap: 2px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  padding: 3px 6px;
}

.wizard-add-entity .pc-line-input input {
  width: 70px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  padding: 0;
}

.wizard-add-entity .pc-line-input input:focus {
  outline: none;
}

.wizard-add-entity .pc-line-input span {
  font-size: 10px;
  color: #94A3B8;
}

.wizard-add-entity .pc-line-value {
  font-size: 12px;
  font-weight: 500;
  color: #B45309;
  min-width: 80px;
  text-align: right;
}

.wizard-add-entity .pc-line.readonly {
  opacity: 0.8;
}

.wizard-add-entity .pc-tag {
  display: inline-block;
  padding: 1px 4px;
  margin-left: 4px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .pc-tag.exo {
  background: #D1FAE5;
  color: #059669;
}

.wizard-add-entity .pc-tag.reduc {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .pc-remove {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 3px;
  background: #FEE2E2;
  color: #DC2626;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s;
}

.wizard-add-entity .pc-remove:hover {
  background: #FECACA;
}

.wizard-add-entity .pc-add-btn {
  display: block;
  width: 100%;
  padding: 5px;
  margin-top: 4px;
  border: 1px dashed #CBD5E1;
  border-radius: 4px;
  background: transparent;
  color: #64748B;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .pc-add-btn:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

/* Input inline en mode simplifié */
.wizard-add-entity .pc-inline-input {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.wizard-add-entity .pc-inline-input input {
  width: 100px;
  padding: 4px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .pc-inline-input input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .pc-inline-input span {
  font-size: 11px;
  color: #64748B;
}

/* ===================== STEP 3 COMPACT FORMAT ===================== */

/* Résumé hypothèses Step 2 */
.wizard-add-entity .step2-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.wizard-add-entity .step2-summary .summary-label {
  font-size: 11px;
  color: #64748B;
  font-weight: 600;
}

.wizard-add-entity .step2-summary .summary-item {
  font-size: 11px;
  color: #374151;
}

.wizard-add-entity .step2-summary .summary-item strong {
  color: #1E293B;
}

.wizard-add-entity .step2-summary .summary-item em {
  color: #94A3B8;
  font-style: normal;
  margin-left: 2px;
}

.wizard-add-entity .step2-summary .summary-tag {
  padding: 2px 6px;
  background: #FEF3C7;
  color: #D97706;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .step2-summary .summary-tag.jei {
  background: #EDE9FE;
  color: #7C3AED;
}

.wizard-add-entity .step2-summary .summary-tag.tva {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .step2-summary .status-badge {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  margin-left: 2px;
}

.wizard-add-entity .step2-summary .status-badge.tns {
  background: #FEE2E2;
  color: #B91C1C;
}

.wizard-add-entity .step2-summary .status-badge.as {
  background: #DBEAFE;
  color: #1D4ED8;
}

/* Mode toggle button */
.wizard-add-entity .mode-toggle-btn {
  padding: 4px 10px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  background: white;
  color: #64748B;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .mode-toggle-btn:hover {
  border-color: #F59E0B;
  color: #D97706;
}

.wizard-add-entity .mode-toggle-btn.detailed {
  background: #FEF3C7;
  border-color: #F59E0B;
  color: #D97706;
}

/* Mode Selector Cards (Simplifié / Détaillé) */
.wizard-add-entity .mode-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.wizard-add-entity .mode-selector-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
}

.wizard-add-entity .mode-selector-cards {
  display: flex;
  gap: 6px;
}

.wizard-add-entity .mode-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}

.wizard-add-entity .mode-card:hover {
  border-color: #F59E0B;
  background: #FFFBEB;
}

.wizard-add-entity .mode-card.selected {
  border-color: #F59E0B;
  background: #FEF3C7;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
}

.wizard-add-entity .mode-card-icon {
  font-size: 16px;
}

.wizard-add-entity .mode-card-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
}

.wizard-add-entity .mode-card.selected .mode-card-label {
  color: #B45309;
}

/* Liste exercices compacte - grid layout horizontal */
.wizard-add-entity .exercices-compact-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  align-items: start;
}

/* Responsive: 2 columns on medium screens, 1 on small */
@media (max-width: 1200px) {
  .wizard-add-entity .exercices-compact-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .wizard-add-entity .exercices-compact-list {
    grid-template-columns: 1fr;
  }
}

.wizard-add-entity .exercice-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  overflow: hidden;
}

.wizard-add-entity .exercice-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-bottom: 1px solid #F59E0B;
}

.wizard-add-entity .exercice-header strong {
  font-size: 13px;
  color: #92400E;
}

.wizard-add-entity .exercice-header .periode {
  font-size: 10px;
  color: #B45309;
}

.wizard-add-entity .exercice-header .tag {
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .exercice-header .tag.y1 {
  background: #D97706;
  color: white;
}

.wizard-add-entity .exercice-header .tag.y2 {
  background: #F59E0B;
  color: white;
}

/* Corps exercice */
.wizard-add-entity .exercice-body {
  padding: 8px;
}

/* ============================================
   SECTION ROWS - Produits, Charges, Résultat
   ============================================ */

.wizard-add-entity .section-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 450px;
  padding: 7px 14px;
  border-radius: 5px;
  margin-bottom: 3px;
}

/* PRODUITS - Vert pâle (entrées +) */
.wizard-add-entity .section-row.produits {
  background: #ECFDF5;
  border: 1px solid #A7F3D0;
}

.wizard-add-entity .section-row.produits .section-label {
  color: #065F46;
}

.wizard-add-entity .section-row.produits .section-value {
  color: #059669;
}

/* CHARGES - Rose pâle (sorties -) */
.wizard-add-entity .section-row.charges {
  background: #FEF2F2;
  border: 1px solid #FECACA;
  margin-top: 6px;
}

.wizard-add-entity .section-row.charges .section-label {
  color: #991B1B;
}

.wizard-add-entity .section-row.charges .section-value {
  color: #DC2626;
}

.wizard-add-entity .section-row.charges.clickable {
  cursor: pointer;
  transition: all 0.15s ease;
}

.wizard-add-entity .section-row.charges.clickable:hover {
  background: #FEE2E2;
  border-color: #F87171;
}

.wizard-add-entity .section-row.charges .expand-hint {
  font-size: 10px;
  font-weight: 400;
  color: #9CA3AF;
  margin-left: 8px;
}

/* RÉSULTAT AVANT IS - Gris neutre */
.wizard-add-entity .section-row.resultat-avant-is {
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  margin-top: 6px;
}

/* IS - Ambre pâle (seul jaune = taxe) */
.wizard-add-entity .section-row.is-row {
  background: #FEF9C3;
  border: 1px solid #FDE047;
  padding: 8px 12px;
}

.wizard-add-entity .section-row.is-row .is-rate {
  font-size: 10px;
  color: #A16207;
  font-weight: 400;
  margin-left: 4px;
}

.wizard-add-entity .section-row.is-row .section-value {
  color: #A16207;
}

/* RÉSULTAT NET - Fort contraste */
.wizard-add-entity .section-row.resultat {
  margin-top: 6px;
}

.wizard-add-entity .section-row.resultat.pos {
  background: #D1FAE5;
  border: 2px solid #059669;
}

.wizard-add-entity .section-row.resultat.pos .section-value {
  color: #059669;
}

.wizard-add-entity .section-row.resultat.neg {
  background: #FEE2E2;
  border: 2px solid #DC2626;
}

.wizard-add-entity .section-row.resultat.neg .section-value {
  color: #DC2626;
}

/* ============================================
   SECTION LABELS & VALUES
   ============================================ */

.wizard-add-entity .section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .section-label .icon {
  width: 16px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  color: #6B7280;
  flex-shrink: 0;
}

.wizard-add-entity .section-label .pcg-num {
  display: inline-block;
  min-width: 24px;
  text-align: right;
  font-family: 'SF Mono', Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  flex-shrink: 0;
}

.wizard-add-entity .section-value {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
  text-align: right;
  white-space: nowrap;
}

.wizard-add-entity .section-value.neg {
  color: #DC2626;
}

.wizard-add-entity .section-value.pos {
  color: #059669;
}

/* ============================================
   LINE ROWS - Sous-lignes détail
   ============================================ */

.wizard-add-entity .line-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 430px;
  padding: 5px 14px 5px 20px;
  background: #FAFAFA;
  border-left: 3px solid transparent;
  margin-left: 20px;
  margin-bottom: 2px;
  border-radius: 4px;
}

.wizard-add-entity .line-row.ca {
  border-left-color: #10B981;
  background: #F0FDF4;
}

.wizard-add-entity .line-row.charge-line {
  border-left-color: #F87171;
  background: #FEF2F2;
}

.wizard-add-entity .line-row.sub {
  padding-left: 36px;
}

.wizard-add-entity .line-row.readonly {
  opacity: 0.7;
}

.wizard-add-entity .line-label {
  font-size: 13px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .line-label .pcg-num {
  display: inline-block;
  min-width: 36px;
  text-align: right;
  font-family: 'SF Mono', Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 700;
  color: #6B7280;
  flex-shrink: 0;
}

.wizard-add-entity .line-label .label-input {
  border: 1px solid transparent;
  background: transparent;
  font-size: 13px;
  color: #374151;
  padding: 3px 6px;
  width: 140px;
  border-radius: 4px;
}

.wizard-add-entity .line-label .label-input:hover {
  border-color: #E2E8F0;
  background: white;
}

.wizard-add-entity .line-label .label-input:focus {
  outline: none;
  border-color: #3B82F6;
  background: white;
}

.wizard-add-entity .line-label .mini-tag {
  padding: 2px 5px;
  background: #D1FAE5;
  color: #047857;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  margin-left: 4px;
}

.wizard-add-entity .line-label .mini-tag.exo {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .line-label .mini-tag.reduc {
  background: #FEF3C7;
  color: #B45309;
}

.wizard-add-entity .line-label .mini-tag.cvae {
  background: #EDE9FE;
  color: #6D28D9;
}

.wizard-add-entity .line-input {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .line-input input {
  width: 80px;
  padding: 5px 8px;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  background: white;
}

.wizard-add-entity .line-input input:hover {
  border-color: #9CA3AF;
}

.wizard-add-entity .line-input input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.wizard-add-entity .line-input span {
  font-size: 12px;
  color: #6B7280;
  font-weight: 500;
}

.wizard-add-entity .line-value {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.wizard-add-entity .line-value.neg {
  color: #DC2626;
}

/* Line value with button (charge lines) */
.wizard-add-entity .line-value-with-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .line-value-with-btn .neg {
  font-size: 13px;
  font-weight: 600;
  color: #DC2626;
}

/* Mini buttons */
.wizard-add-entity .mini-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  background: white;
  color: #6B7280;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.wizard-add-entity .mini-btn:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
}

.wizard-add-entity .mini-btn.info {
  color: #3B82F6;
  border-color: #BFDBFE;
}

.wizard-add-entity .mini-btn.info:hover {
  background: #EFF6FF;
  border-color: #3B82F6;
}

.wizard-add-entity .mini-btn.del {
  background: #FEF2F2;
  border-color: #FECACA;
  color: #DC2626;
}

.wizard-add-entity .mini-btn.del:hover {
  background: #FEE2E2;
  border-color: #F87171;
}

.wizard-add-entity .mini-btn.config {
  margin-left: 4px;
}

/* Add row */
.wizard-add-entity .add-row {
  display: flex;
  gap: 6px;
  padding: 4px 8px 4px 20px;
}

.wizard-add-entity .add-row.bottom {
  margin-top: 8px;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 0 0 8px 8px;
  border-top: 1px dashed #E2E8F0;
  justify-content: center;
}

.wizard-add-entity .add-row button {
  padding: 2px 8px;
  border: 1px dashed #CBD5E1;
  border-radius: 3px;
  background: transparent;
  color: #64748B;
  font-size: 10px;
  cursor: pointer;
}

.wizard-add-entity .add-row button:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

/* PCG Number - Default badge style (for tables, modals etc.)
   Note: section-label and line-label have their own pcg-num styles
   defined earlier for proper vertical alignment in exercice cards */
.wizard-add-entity .pcg-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 16px;
  padding: 0 4px;
  background: #E0E7FF;
  color: #4338CA;
  font-size: 9px;
  font-weight: 700;
  border-radius: 3px;
  margin-right: 4px;
}

/* Charge line clickable */
.wizard-add-entity .line-row.charge-line {
  background: transparent;
  border-radius: 3px;
  transition: background 0.15s;
}

.wizard-add-entity .line-row.charge-line.clickable {
  cursor: pointer;
}

.wizard-add-entity .line-row.charge-line.clickable:hover {
  background: #FEF3C7;
}

.wizard-add-entity .line-row.charge-line .line-label {
  font-size: 11px;
  color: #374151;
}

.wizard-add-entity .line-row.charge-line .line-value {
  font-size: 11px;
  font-weight: 600;
  color: #B45309;
}

/* Mini tags for CFE */
.wizard-add-entity .mini-tag {
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 8px;
  font-weight: 600;
  margin-left: 4px;
}

.wizard-add-entity .mini-tag.exo {
  background: #D1FAE5;
  color: #059669;
}

.wizard-add-entity .mini-tag.reduc {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .mini-tag.jei {
  background: #DBEAFE;
  color: #2563EB;
}

.wizard-add-entity .mini-tag.cvae {
  background: #FEE2E2;
  color: #DC2626;
}

/* ===================== CHARGE DETAIL MODALS ===================== */

.wizard-add-entity .charges-var-modal.wide {
  max-width: 720px;
}

/* ============================== */
/* MODAL - MODE TOGGLE            */
/* ============================== */

.wizard-add-entity .mode-toggle-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .mode-toggle-row .mode-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-entity .mode-toggle {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #F1F5F9;
  border-radius: 6px;
}

.wizard-add-entity .mode-toggle button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  color: #64748B;
  transition: all 0.15s;
}

.wizard-add-entity .mode-toggle button.active {
  background: white;
  color: #1E293B;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* ============================== */
/* SIMPLE GRID (Simplifié)        */
/* ============================== */

.wizard-add-entity .simple-grid {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
}

.wizard-add-entity .simple-grid .grid-row {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 16px;
  padding: 12px 16px;
  align-items: center;
  cursor: pointer;
  transition: background 0.15s;
}

.wizard-add-entity .simple-grid .grid-row:not(.header):hover {
  background: #F8FAFC;
}

.wizard-add-entity .simple-grid .grid-row.header {
  background: #F8FAFC;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  padding: 8px 16px;
  cursor: default;
}

.wizard-add-entity .simple-grid .grid-row.selected {
  background: #FFFBEB;
}

.wizard-add-entity .simple-grid .grid-row + .grid-row {
  border-top: 1px solid #E2E8F0;
}

.wizard-add-entity .simple-grid .col-type {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #334155;
}

.wizard-add-entity .simple-grid .col-type input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: #F59E0B;
}

.wizard-add-entity .simple-grid .col-value {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .simple-grid .col-value input {
  width: 100px;
  padding: 8px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .simple-grid .col-value input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .simple-grid .col-value input:disabled {
  background: #F8FAFC;
  color: #94A3B8;
}

.wizard-add-entity .simple-grid .col-value .unit {
  font-size: 12px;
  color: #64748B;
  min-width: 35px;
}

/* ============================== */
/* CHARGES TABLE (Détaillé)       */
/* ============================== */

.wizard-add-entity .charges-table {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
}

.wizard-add-entity .charges-table .table-header {
  display: grid;
  grid-template-columns: 28px 1fr 70px 100px;
  gap: 8px;
  padding: 8px 12px;
  background: #F8FAFC;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .charges-table .table-body {
  /* No max-height - avoid double scrollbar */
}

.wizard-add-entity .charges-table .table-row {
  display: grid;
  grid-template-columns: 28px 1fr 70px 100px;
  gap: 8px;
  padding: 8px 12px;
  align-items: center;
  border-top: 1px solid #F1F5F9;
  transition: background 0.1s;
}

.wizard-add-entity .charges-table .table-row:hover {
  background: #FAFBFC;
}

.wizard-add-entity .charges-table .table-row.enabled {
  background: #FFFBEB;
}

.wizard-add-entity .charges-table .col-check input {
  width: 16px;
  height: 16px;
  accent-color: #F59E0B;
  cursor: pointer;
}

.wizard-add-entity .charges-table .col-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #334155;
}

.wizard-add-entity .charges-table .col-label .icon {
  font-size: 14px;
}

.wizard-add-entity .charges-table .col-amount input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .charges-table .col-amount input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .charges-table .col-amount input:disabled {
  background: #F8FAFC;
  color: #CBD5E1;
}

.wizard-add-entity .charges-table .col-type select {
  width: 100%;
  padding: 6px 4px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
  background: white;
  cursor: pointer;
}

.wizard-add-entity .charges-table .col-type select:disabled {
  background: #F8FAFC;
  color: #CBD5E1;
}

/* ============================== */
/* TOOLTIP COMPONENT - PORTAL     */
/* ============================== */

/* Trigger inline */
.tooltip-trigger {
  display: inline-flex;
  align-items: center;
  cursor: help;
}

/* Portal tooltip - rendu dans body */
.tooltip-portal {
  pointer-events: none;
}

.tooltip-content-portal {
  background: #1E293B;
  color: white;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  white-space: normal;
  width: 220px;
  max-width: 280px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  text-align: left;
  animation: tooltipPortalFadeIn 0.15s ease;
}

.tooltip-content-portal::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1E293B;
}

@keyframes tooltipPortalFadeIn {
  from { opacity: 0; transform: translate(-50%, calc(-100% + 5px)); }
  to { opacity: 1; transform: translate(-50%, -100%); }
}

/* Help icon simple (sans pseudo-elements) */
.wizard-add-entity .help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 50%;
  background: #E2E8F0;
  color: #64748B;
  font-size: 10px;
  cursor: help;
  margin-left: 4px;
}

.wizard-add-entity .help-icon:hover {
  background: #F59E0B;
  color: white;
}

/* ============================== */
/* MODAL 63 IMPOTS - GRID STYLE   */
/* ============================== */

.wizard-add-entity .impots-table .table-header {
  grid-template-columns: 140px 1fr 180px 90px;
}

.wizard-add-entity .impots-table .table-row.impot-row {
  display: grid;
  grid-template-columns: 140px 1fr 180px 90px;
  gap: 12px;
  padding: 12px;
  align-items: start;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .impots-table .table-row.impot-row.disabled {
  opacity: 0.5;
  background: #F8FAFC;
}

.wizard-add-entity .impots-table .table-row.impot-row.is-row {
  background: #FEF3C7;
  border-color: #FCD34D;
}

.wizard-add-entity .impots-table .is-amount {
  color: #B45309;
}

.wizard-add-entity .impots-table .col-impot-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wizard-add-entity .impots-table .col-impot-label strong {
  font-size: 13px;
  color: #1E293B;
}

.wizard-add-entity .impots-table .impot-subtitle {
  font-size: 10px;
  color: #64748B;
}

.wizard-add-entity .impots-table .col-impot-hypothese {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix span {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .impots-table .col-impot-hypothese .hint {
  font-size: 9px;
  color: #94A3B8;
}

.wizard-add-entity .impots-table .col-impot-hypothese .stacked-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wizard-add-entity .impots-table .col-impot-hypothese .info-line {
  font-size: 10px;
  color: #64748B;
}

.wizard-add-entity .impots-table .col-impot-hypothese .not-applicable {
  font-size: 10px;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .impots-table .col-impot-calcul {
  text-align: center;
}

.wizard-add-entity .impots-table .calcul-formula {
  display: inline-block;
  padding: 4px 8px;
  background: #F1F5F9;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  color: #475569;
}

.wizard-add-entity .impots-table .calcul-formula.positive {
  background: #DCFCE7;
  color: #166534;
}

.wizard-add-entity .impots-table .calcul-formula.muted {
  background: #F8FAFC;
  color: #94A3B8;
}

.wizard-add-entity .impots-table .col-impot-montant {
  text-align: right;
}

.wizard-add-entity .impots-table .col-impot-montant strong {
  font-size: 14px;
  color: #1E293B;
}

/* Hypothesis inputs for CFE/CVAE */
.wizard-add-entity .impots-table .hypothesis-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-add-entity .impots-table .input-row {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wizard-add-entity .impots-table .input-row label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-entity .impots-table .input-row .input-with-suffix input {
  width: 70px;
}

/* Calcul stack for multi-line formulas */
.wizard-add-entity .impots-table .calcul-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wizard-add-entity .impots-table .calcul-note {
  font-size: 9px;
  color: #94A3B8;
  font-style: italic;
}

/* Info line muted */
.wizard-add-entity .impots-table .info-line.muted {
  color: #94A3B8;
  font-size: 9px;
}

/* Location tag in modal hint */
.wizard-add-entity .location-tag {
  margin-left: 8px;
  padding: 2px 8px;
  background: #E0F2FE;
  color: #0369A1;
  border-radius: 4px;
  font-size: 11px;
}

/* Impots rules help */
.wizard-add-entity .impot-rules-help {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
  background: #F8FAFC;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .impot-rules-help .rule-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 11px;
  color: #475569;
}

.wizard-add-entity .impot-rules-help .rule-icon {
  font-size: 14px;
}

.wizard-add-entity .impot-rules-help .rule-item strong {
  color: #1E293B;
}

/* Status tag with tooltip */
.wizard-add-entity .status-tag[title] {
  cursor: help;
  position: relative;
}

.wizard-add-entity .status-tag[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1E293B;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.wizard-add-entity .status-tag[title]:hover::before {
  content: '';
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1E293B;
  z-index: 10000;
}

/* Calculated field styling - make it visually distinct */
.wizard-add-entity .calculated-value {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #F1F5F9;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px dashed #CBD5E1;
}

.wizard-add-entity .calculated-value::before {
  content: '=';
  font-size: 10px;
  color: #94A3B8;
  font-weight: 600;
}

.wizard-add-entity .calculated-value strong {
  color: #475569;
}

/* Col charges and cout are calculated */
.wizard-add-entity .col-personnel-charges,
.wizard-add-entity .col-personnel-cout,
.wizard-add-entity .col-impot-montant {
  position: relative;
}

.wizard-add-entity .col-personnel-charges .charges-value,
.wizard-add-entity .col-personnel-cout strong,
.wizard-add-entity .col-impot-montant strong {
  background: #F8FAFC;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px dashed #E2E8F0;
}

.wizard-add-entity .col-personnel-charges .charges-value::before {
  content: '⟵ ';
  font-size: 9px;
  color: #94A3B8;
}

/* Modal legend for editable vs calculated */
.wizard-add-entity .modal-legend {
  display: flex;
  gap: 20px;
  padding: 10px 14px;
  background: #FEFCE8;
  border: 1px solid #FEF08A;
  border-radius: 6px;
  margin-top: 16px;
}

.wizard-add-entity .modal-legend .legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #78716C;
}

.wizard-add-entity .modal-legend .legend-input {
  width: 40px;
  height: 20px;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 3px;
}

.wizard-add-entity .modal-legend .legend-calc {
  width: 40px;
  height: 20px;
  background: #F8FAFC;
  border: 1px dashed #CBD5E1;
  border-radius: 3px;
}

/* ============================== */
/* MODAL 64 PERSONNEL - GRID STYLE*/
/* ============================== */

.wizard-add-entity .personnel-section {
  margin-bottom: 20px;
}

.wizard-add-entity .personnel-section .section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.wizard-add-entity .personnel-section .section-header h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .toggle-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #64748B;
  cursor: pointer;
}

.wizard-add-entity .toggle-checkbox input {
  width: 14px;
  height: 14px;
  accent-color: #F59E0B;
}

/* Personnel table grid */
.wizard-add-entity .personnel-table .table-header {
  grid-template-columns: 1fr 70px 110px 50px 110px 90px 36px;
}

.wizard-add-entity .personnel-table .table-row.personnel-row {
  display: grid;
  grid-template-columns: 1fr 70px 110px 50px 110px 90px 36px;
  gap: 8px;
  padding: 10px 12px;
  align-items: center;
  border-top: 1px solid #F1F5F9;
}

/* ===================== MANAGERS GRID - Professional Layout ===================== */

/* Managers grid container - fit content, don't stretch */
.wizard-add-entity .managers-grid {
  display: inline-block;
  min-width: 650px;
  max-width: 800px;
}

/* Managers grid - without SARL parts column (7 cols + actions) */
/* Fonction | Statut | Brut mensuel | Mois | Début rémuné | Charges | Coût annuel | Actions */
.wizard-add-entity .managers-grid .table-header {
  display: grid;
  grid-template-columns: 85px 48px 100px 50px 90px 90px 85px 26px;
  gap: 8px;
  padding: 8px 12px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.wizard-add-entity .managers-grid .table-row.personnel-row {
  display: grid;
  grid-template-columns: 85px 48px 100px 50px 90px 90px 85px 26px;
  gap: 8px;
  padding: 10px 12px;
  align-items: center;
  border-top: 1px solid #F1F5F9;
}

/* Managers grid - with SARL parts column (8 cols + actions) */
/* Fonction | Statut | Brut mensuel | Mois | Début rémuné | % parts | Charges | Coût annuel | Actions */
.wizard-add-entity .managers-grid.with-parts .table-header {
  grid-template-columns: 75px 46px 85px 44px 85px 52px 78px 78px 24px;
}

.wizard-add-entity .managers-grid.with-parts .table-row.personnel-row {
  grid-template-columns: 75px 46px 85px 44px 85px 52px 78px 78px 24px;
}

/* Managers grid - Add button row */
.wizard-add-entity .managers-grid .table-row.add-row {
  display: block;
  padding: 6px 12px 8px;
  border-top: 1px dashed #E2E8F0;
  background: transparent;
}

.wizard-add-entity .managers-grid .add-cell {
  text-align: left;
}

.wizard-add-entity .managers-grid .btn-add-manager {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  margin: 0;
  width: auto;
  border: 1px dashed #CBD5E1;
  border-radius: 4px;
  background: transparent;
  font-size: 12px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .managers-grid .btn-add-manager:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

.wizard-add-entity .managers-grid .btn-add-manager::before {
  content: '+';
  font-weight: 600;
  font-size: 14px;
}

/* Managers grid - Column styling */
.wizard-add-entity .managers-grid .col-personnel-role {
  display: flex;
  align-items: center;
}

.wizard-add-entity .managers-grid .col-personnel-role .role-name {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.wizard-add-entity .managers-grid .col-personnel-status {
  display: flex;
  justify-content: center;
}

.wizard-add-entity .managers-grid .status-tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.wizard-add-entity .managers-grid .status-tag.tns {
  background: #FEF3C7;
  color: #B45309;
}

.wizard-add-entity .managers-grid .status-tag.as {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .managers-grid .col-personnel-brut .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 3px;
}

.wizard-add-entity .managers-grid .col-personnel-brut input {
  width: 70px;
  padding: 5px 6px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .managers-grid .col-personnel-brut input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.wizard-add-entity .managers-grid .col-personnel-brut span {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .managers-grid .col-personnel-months {
  display: flex;
  justify-content: center;
}

.wizard-add-entity .managers-grid .select-months {
  width: 48px;
  padding: 5px 2px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  background: white;
  cursor: pointer;
}

.wizard-add-entity .managers-grid .select-months:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .managers-grid .col-personnel-salary-start {
  display: flex;
  justify-content: center;
}

.wizard-add-entity .managers-grid .col-personnel-salary-start input {
  width: 100%;
  max-width: 85px;
  padding: 5px 4px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
  text-align: center;
  background: white;
}

.wizard-add-entity .managers-grid .col-personnel-salary-start input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.wizard-add-entity .managers-grid .col-personnel-salary-start input.locked,
.wizard-add-entity .managers-grid .col-personnel-salary-start input:disabled {
  background: #F1F5F9;
  color: #64748B;
  cursor: not-allowed;
  border-color: #CBD5E1;
}

.wizard-add-entity .managers-grid .col-personnel-parts {
  display: flex;
  justify-content: center;
}

.wizard-add-entity .managers-grid .col-personnel-parts .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 2px;
}

.wizard-add-entity .managers-grid .col-personnel-parts input {
  width: 36px;
  padding: 5px 4px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .managers-grid .col-personnel-parts input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .managers-grid .col-personnel-parts span {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .managers-grid .col-personnel-charges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}

.wizard-add-entity .managers-grid .charges-value {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #DC2626;
  font-weight: 500;
}

.wizard-add-entity .managers-grid .charges-rate {
  font-size: 9px;
  color: #94A3B8;
}

.wizard-add-entity .managers-grid .non-remunere {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .managers-grid .tag-reduction {
  display: inline-block;
  padding: 1px 4px;
  background: #DCFCE7;
  color: #166534;
  font-size: 8px;
  font-weight: 600;
  border-radius: 2px;
}

.wizard-add-entity .managers-grid .col-personnel-cout {
  display: flex;
  justify-content: flex-end;
}

.wizard-add-entity .managers-grid .col-personnel-cout strong {
  font-size: 12px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .managers-grid .col-personnel-actions {
  display: flex;
  justify-content: center;
}

.wizard-add-entity .managers-grid .btn-remove {
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 4px;
  background: #FEE2E2;
  color: #DC2626;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .managers-grid .btn-remove:hover {
  background: #FECACA;
}

.wizard-add-entity .personnel-table .col-personnel-parts {
  text-align: center;
}

.wizard-add-entity .personnel-table .col-personnel-parts .input-with-suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.wizard-add-entity .personnel-table .col-personnel-parts input {
  width: 40px;
  padding: 4px 6px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .personnel-table .col-personnel-parts input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .personnel-table .col-personnel-parts span {
  font-size: 11px;
  color: #64748B;
}

/* ===================== EMPLOYEES GRID - Professional Layout ===================== */

/* Employees grid container */
.wizard-add-entity .employees-grid {
  display: inline-block;
  min-width: 620px;
  max-width: 800px;
}

/* Employees grid - detailed mode (8 cols + actions) */
/* Profil | Brut | Mois | Nb | Début | Fin | Charges | Coût | Actions */
.wizard-add-entity .employees-grid .table-header {
  display: grid;
  grid-template-columns: minmax(90px, 140px) 90px 48px 40px 90px 90px 85px 90px 28px;
  gap: 6px;
  padding: 8px 12px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.wizard-add-entity .employees-grid .table-row.personnel-row {
  display: grid;
  grid-template-columns: minmax(90px, 140px) 90px 48px 40px 90px 90px 85px 90px 28px;
  gap: 6px;
  padding: 10px 12px;
  align-items: center;
  border-top: 1px solid #F1F5F9;
}

/* Employees grid - Add button row */
.wizard-add-entity .employees-grid .table-row.add-row {
  display: block;
  padding: 6px 12px 8px;
  border-top: 1px dashed #E2E8F0;
}

.wizard-add-entity .employees-grid .add-cell {
  text-align: left;
}

.wizard-add-entity .employees-grid .btn-add-profile {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px dashed #CBD5E1;
  border-radius: 4px;
  background: transparent;
  font-size: 12px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .employees-grid .btn-add-profile:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

.wizard-add-entity .employees-grid .btn-add-profile::before {
  content: '+';
  font-weight: 600;
  font-size: 14px;
}

.wizard-add-entity .employees-grid .col-emp-name .input-name {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
}

.wizard-add-entity .employees-grid .col-emp-name .input-name:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .employees-grid .col-emp-brut .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .employees-grid .col-emp-brut input {
  width: 65px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .employees-grid .col-emp-brut input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .employees-grid .col-emp-brut span {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .employees-grid .col-emp-start,
.wizard-add-entity .employees-grid .col-emp-end {
  display: flex;
  align-items: center;
}

.wizard-add-entity .employees-grid .input-date {
  width: 100%;
  padding: 5px 6px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 11px;
}

.wizard-add-entity .employees-grid .input-date:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .employees-grid .ongoing-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #64748B;
  cursor: pointer;
}

.wizard-add-entity .employees-grid .ongoing-label input {
  width: 14px;
  height: 14px;
  accent-color: #F59E0B;
}

.wizard-add-entity .employees-grid .end-date-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .employees-grid .btn-ongoing {
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  background: #F8FAFC;
  color: #64748B;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.wizard-add-entity .employees-grid .btn-ongoing:hover {
  background: #F1F5F9;
  border-color: #F59E0B;
  color: #F59E0B;
}

.wizard-add-entity .employees-grid .col-emp-count {
  text-align: center;
}

.wizard-add-entity .employees-grid .col-emp-prorata {
  text-align: center;
}

.wizard-add-entity .employees-grid .prorata-value {
  font-size: 11px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-entity .employees-grid .col-emp-charges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.wizard-add-entity .employees-grid .col-emp-cout {
  text-align: right;
}

.wizard-add-entity .employees-grid .col-emp-cout strong {
  font-size: 12px;
  color: #1E293B;
}

.wizard-add-entity .employees-grid .col-emp-actions {
  text-align: center;
}

.wizard-add-entity .personnel-table .col-personnel-role .role-name {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.wizard-add-entity .personnel-table .col-personnel-status {
  text-align: center;
}

.wizard-add-entity .personnel-table .status-tag {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.wizard-add-entity .personnel-table .status-tag.tns {
  background: #FEF3C7;
  color: #B45309;
}

.wizard-add-entity .personnel-table .status-tag.as {
  background: #DBEAFE;
  color: #1D4ED8;
}

.wizard-add-entity .personnel-table .col-personnel-brut .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .personnel-table .col-personnel-brut input {
  width: 75px;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .personnel-table .col-personnel-brut input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.wizard-add-entity .personnel-table .col-personnel-brut span {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .personnel-table .months-input,
.wizard-add-entity .personnel-table .count-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.wizard-add-entity .personnel-table .months-input:focus,
.wizard-add-entity .personnel-table .count-input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .personnel-table .col-personnel-charges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.wizard-add-entity .personnel-table .charges-value {
  font-size: 12px;
  color: #DC2626;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .personnel-table .charges-rate {
  font-size: 9px;
  color: #94A3B8;
}

.wizard-add-entity .personnel-table .non-remunere {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .personnel-table .tag-reduction {
  display: inline-block;
  padding: 1px 4px;
  background: #DCFCE7;
  color: #166534;
  font-size: 8px;
  font-weight: 600;
  border-radius: 3px;
}

.wizard-add-entity .personnel-table .col-personnel-cout {
  text-align: right;
}

.wizard-add-entity .personnel-table .col-personnel-cout strong {
  font-size: 13px;
  color: #1E293B;
}

.wizard-add-entity .personnel-table .col-personnel-count {
  text-align: center;
}

/* Header controls - toggle + mode buttons */
.wizard-add-entity .personnel-section .header-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Mode toggle compact for inline use */
.wizard-add-entity .mode-toggle.compact {
  display: flex;
  gap: 0;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .mode-toggle.compact button {
  padding: 4px 10px;
  font-size: 10px;
  border: none;
  background: #F8FAFC;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s ease;
}

.wizard-add-entity .mode-toggle.compact button:hover {
  background: #F1F5F9;
}

.wizard-add-entity .mode-toggle.compact button.active {
  background: #F59E0B;
  color: white;
  font-weight: 600;
}

/* Detailed personnel table grid */
.wizard-add-entity .personnel-table.detailed .table-header {
  grid-template-columns: 1fr 110px 50px 60px 100px 100px 36px;
}

.wizard-add-entity .personnel-table.detailed .table-row.personnel-row {
  grid-template-columns: 1fr 110px 50px 60px 100px 100px 36px;
}

.wizard-add-entity .personnel-table .col-personnel-name {
  min-width: 0;
}

.wizard-add-entity .personnel-table .col-personnel-name .input-name {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 12px;
  color: #334155;
}

.wizard-add-entity .personnel-table .col-personnel-name .input-name:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
}

.wizard-add-entity .personnel-table .col-personnel-name .input-name::placeholder {
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .personnel-table .col-personnel-actions {
  text-align: center;
}

.wizard-add-entity .personnel-table .btn-remove {
  width: 24px;
  height: 24px;
  border: none;
  background: #FEE2E2;
  color: #DC2626;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: all 0.15s ease;
}

.wizard-add-entity .personnel-table .btn-remove:hover {
  background: #FECACA;
}

.wizard-add-entity .personnel-table .empty-row {
  display: block !important;
  text-align: center;
  padding: 16px 12px;
}

.wizard-add-entity .personnel-table .empty-message {
  color: #94A3B8;
  font-size: 12px;
  font-style: italic;
}

.wizard-add-entity .personnel-table .add-row {
  display: block !important;
  padding: 8px 12px;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .personnel-table .add-cell {
  text-align: center;
}

.wizard-add-entity .btn-add-employee {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border: 1px dashed #CBD5E1;
  background: transparent;
  color: #64748B;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.wizard-add-entity .btn-add-employee:hover {
  border-color: #F59E0B;
  color: #F59E0B;
  background: #FFFBEB;
}

.wizard-add-entity .no-data.muted {
  color: #94A3B8;
  font-style: italic;
}

/* ============================== */
/* MODAL TOTAL                    */
/* ============================== */

.wizard-add-entity .modal-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px;
  background: #FEF2F2;
  border-radius: 8px;
  border: 1px solid #FECACA;
}

.wizard-add-entity .modal-total span {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

.wizard-add-entity .modal-total strong {
  font-size: 15px;
  color: #DC2626;
}

.wizard-add-entity .charges-var-modal .modal-header .pcg-badge {
  background: linear-gradient(135deg, #6366F1, #4F46E5);
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);
}

.wizard-add-entity .charge-detail-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #F8FAFC;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .charge-detail-section:last-of-type {
  margin-bottom: 0;
}

.wizard-add-entity .charge-detail-section h5 {
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #E2E8F0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .charge-detail-section.muted {
  opacity: 0.6;
  background: #FAFBFC;
}

.wizard-add-entity .charge-detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.wizard-add-entity .charge-detail-table th {
  text-align: left;
  padding: 6px 8px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  font-weight: 600;
  color: #64748B;
}

.wizard-add-entity .charge-detail-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #F1F5F9;
  color: #374151;
}

.wizard-add-entity .charge-detail-table td.neg {
  color: #B45309;
}

.wizard-add-entity .charge-detail-table td.total {
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-entity .charge-detail-table td.no-data {
  text-align: center;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .charge-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 6px;
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .charge-summary-row strong {
  color: #1E293B;
}

.wizard-add-entity p.no-data {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
  padding: 8px;
  text-align: center;
}

/* CFE Info */
.wizard-add-entity .cfe-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wizard-add-entity .cfe-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 4px;
  font-size: 12px;
}

.wizard-add-entity .cfe-row.exoneration {
  background: #D1FAE5;
}

.wizard-add-entity .cfe-row.reduction {
  background: #FEF3C7;
}

.wizard-add-entity .cfe-row.total {
  background: #E0E7FF;
  font-weight: 600;
}

.wizard-add-entity .cfe-row strong.positive {
  color: #059669;
}

.wizard-add-entity p.info-text {
  font-size: 10px;
  color: #64748B;
  margin: 12px 0 0 0;
  line-height: 1.4;
}

.wizard-add-entity .modal-footer .footer-hint {
  font-size: 10px;
  color: #94A3B8;
}

/* ===================== FORMAT PCG (Plan Comptable Général) ===================== */

/* Toggle global mode */
.wizard-add-entity .global-mode-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #D97706;
  border-radius: 6px;
  background: white;
  color: #D97706;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.wizard-add-entity .global-mode-toggle:hover {
  background: #FFFBEB;
}

.wizard-add-entity .global-mode-toggle.detailed {
  background: #FEF3C7;
  border-color: #F59E0B;
}

.wizard-add-entity .global-mode-toggle .override-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #F59E0B;
  border-radius: 50%;
  border: 2px solid white;
}

/* Liste exercices PCG */
.wizard-add-entity .exercices-pcg-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wizard-add-entity .exercice-pcg-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

/* Header exercice PCG */
.wizard-add-entity .pcg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-bottom: 2px solid #F59E0B;
}

.wizard-add-entity .pcg-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.wizard-add-entity .pcg-title strong {
  font-size: 14px;
  color: #92400E;
}

.wizard-add-entity .pcg-periode {
  font-size: 11px;
  color: #B45309;
  background: rgba(255,255,255,0.5);
  padding: 2px 6px;
  border-radius: 4px;
}

/* Corps PCG */
.wizard-add-entity .pcg-body {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Classe comptable (6 ou 7) */
.wizard-add-entity .pcg-classe {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .pcg-classe-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #F8FAFC;
}

.wizard-add-entity .pcg-classe.produits .pcg-classe-header {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  border-bottom: 1px solid #86EFAC;
}

.wizard-add-entity .pcg-classe.charges .pcg-classe-header {
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-bottom: 1px solid #FCD34D;
}

.wizard-add-entity .pcg-classe-num {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #64748B;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.wizard-add-entity .pcg-classe.produits .pcg-classe-num {
  color: #059669;
}

.wizard-add-entity .pcg-classe.charges .pcg-classe-num {
  color: #D97706;
}

.wizard-add-entity .pcg-classe-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  flex: 1 1;
}

.wizard-add-entity .pcg-classe-total {
  font-size: 14px;
  font-weight: 700;
  color: #059669;
}

.wizard-add-entity .pcg-classe-total.neg {
  color: #D97706;
}

.wizard-add-entity .pcg-detail-btn {
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 6px;
  background: rgba(255,255,255,0.7);
  color: #64748B;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-detail-btn:hover {
  background: white;
  color: #1E293B;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Compte PCG (60, 61-62, 63, 64, 70...) */
.wizard-add-entity .pcg-compte {
  border-top: 1px solid #E2E8F0;
}

.wizard-add-entity .pcg-compte:first-of-type {
  border-top: none;
}

.wizard-add-entity .pcg-compte-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #FAFAFA;
}

.wizard-add-entity .pcg-compte.readonly .pcg-compte-header {
  padding: 6px 12px;
}

.wizard-add-entity .pcg-compte-num {
  font-size: 10px;
  font-weight: 700;
  color: #94A3B8;
  background: white;
  padding: 2px 5px;
  border-radius: 3px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .pcg-compte-label {
  font-size: 12px;
  color: #64748B;
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .pcg-compte-total {
  font-size: 12px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-entity .pcg-compte.readonly .pcg-compte-total {
  color: #B45309;
}

/* Tags exonération/réduction */
.wizard-add-entity .pcg-tag {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .pcg-tag.exo {
  background: #D1FAE5;
  color: #059669;
}

.wizard-add-entity .pcg-tag.reduc {
  background: #FEF3C7;
  color: #D97706;
}

/* Détails compte */
.wizard-add-entity .pcg-compte-details {
  padding: 8px 12px;
  background: white;
  border-top: 1px solid #F1F5F9;
}

.wizard-add-entity .pcg-ligne {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
}

.wizard-add-entity .pcg-ligne.secondaire {
  padding-left: 16px;
  border-left: 2px solid #E2E8F0;
  margin-left: 8px;
}

.wizard-add-entity .pcg-ligne-label-input {
  flex: 1 1;
  min-width: 120px;
  border: none;
  background: transparent;
  font-size: 12px;
  color: #374151;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-ligne-label-input::placeholder {
  color: #9CA3AF;
  font-style: italic;
}

.wizard-add-entity .pcg-ligne-label-input:hover {
  background: #F8FAFC;
}

.wizard-add-entity .pcg-ligne-label-input:focus {
  outline: none;
  background: #FEF3C7;
}

.wizard-add-entity .pcg-ligne-input {
  display: flex;
  align-items: center;
  gap: 3px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 5px;
  padding: 4px 8px;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-ligne-input:focus-within {
  border-color: #F59E0B;
  background: white;
}

.wizard-add-entity .pcg-ligne-input input {
  width: 80px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  color: #1E293B;
}

.wizard-add-entity .pcg-ligne-input input:focus {
  outline: none;
}

.wizard-add-entity .pcg-ligne-input span {
  font-size: 10px;
  color: #94A3B8;
}

.wizard-add-entity .pcg-ligne-label {
  font-size: 12px;
  color: #64748B;
  flex: 1 1;
}

.wizard-add-entity .pcg-ligne-value {
  font-size: 12px;
  font-weight: 500;
  color: #B45309;
  min-width: 80px;
  text-align: right;
}

.wizard-add-entity .pcg-ligne.readonly {
  opacity: 0.85;
}

/* Boutons actions */
.wizard-add-entity .pcg-config-btn {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: #F1F5F9;
  color: #64748B;
  cursor: pointer;
  font-size: 11px;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-config-btn:hover {
  background: #E2E8F0;
  color: #1E293B;
}

.wizard-add-entity .pcg-remove-btn {
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 4px;
  background: #FEE2E2;
  color: #DC2626;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-remove-btn:hover {
  background: #FECACA;
}

.wizard-add-entity .pcg-add-btn {
  display: block;
  width: 100%;
  padding: 6px;
  margin-top: 6px;
  border: 1px dashed #CBD5E1;
  border-radius: 5px;
  background: transparent;
  color: #64748B;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-add-btn:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

/* Mode simplifié */
.wizard-add-entity .pcg-compte-simple {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: white;
}

.wizard-add-entity .pcg-compte-simple input {
  flex: 1 1;
  max-width: 150px;
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  transition: all 0.15s;
}

.wizard-add-entity .pcg-compte-simple input:focus {
  outline: none;
  border-color: #F59E0B;
}

.wizard-add-entity .pcg-compte-simple span {
  font-size: 12px;
  color: #64748B;
}

.wizard-add-entity .pcg-compte-summary {
  padding: 6px 12px;
  background: white;
}

.wizard-add-entity .pcg-summary-hint {
  font-size: 11px;
  color: #9CA3AF;
  font-style: italic;
}

/* Résultat */
.wizard-add-entity .pcg-resultat {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  border-radius: 8px;
  border: 1px solid #93C5FD;
}

.wizard-add-entity .pcg-resultat.negative {
  background: linear-gradient(135deg, #FEF2F2 0%, #FECACA 100%);
  border-color: #FCA5A5;
}

.wizard-add-entity .pcg-resultat.positive {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  border-color: #86EFAC;
}

.wizard-add-entity .pcg-resultat-label {
  font-size: 16px;
  font-weight: 700;
  color: #64748B;
}

.wizard-add-entity .pcg-resultat-text {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  flex: 1 1;
}

.wizard-add-entity .pcg-resultat-value {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-entity .pcg-resultat.negative .pcg-resultat-value {
  color: #DC2626;
}

.wizard-add-entity .pcg-resultat.positive .pcg-resultat-value {
  color: #059669;
}

/* Grid table des exercices */
.wizard-add-entity .exercices-grid-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.wizard-add-entity .exercices-grid-table .exercices-table {
  width: 100%;
  border-collapse: collapse;
}

.wizard-add-entity .exercices-grid-table thead tr {
  background: #F1F5F9;
}

.wizard-add-entity .exercices-grid-table th {
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .exercices-grid-table th.col-amount,
.wizard-add-entity .exercices-grid-table th.col-charges {
  text-align: right;
  width: 130px;
}

.wizard-add-entity .exercices-grid-table th.col-actions {
  width: 100px;
  text-align: right;
}

/* Ligne exercice principale */
.wizard-add-entity .exercice-row {
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .exercice-row:hover {
  background: #E2E8F0;
}

.wizard-add-entity .exercice-row td {
  padding: 12px;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .exercice-row .expand-icon {
  display: inline-block;
  width: 16px;
  font-size: 10px;
  color: #94A3B8;
  margin-right: 8px;
}

.wizard-add-entity .exercice-row strong {
  font-size: 14px;
  color: #1E293B;
}

.wizard-add-entity .exercice-row .periode-small {
  font-size: 11px;
  color: #94A3B8;
  margin-left: 8px;
}

.wizard-add-entity .exercice-row .year-badge {
  display: inline-block;
  padding: 2px 6px;
  margin-left: 8px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .year-badge.first {
  background: #DCFCE7;
  color: #16A34A;
}

.wizard-add-entity .year-badge.second {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .exercice-row .option-tag {
  display: inline-block;
  padding: 2px 6px;
  margin-left: 6px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
}

.wizard-add-entity .option-tag.acre {
  background: #D1FAE5;
  color: #059669;
}

.wizard-add-entity .option-tag.jei {
  background: #E0E7FF;
  color: #4338CA;
}

.wizard-add-entity .exercice-row .col-amount {
  text-align: right;
}

.wizard-add-entity .exercice-row .col-amount strong {
  font-size: 13px;
}

.wizard-add-entity .exercice-row .charge-total {
  font-size: 12px;
  color: #DC2626;
}

.wizard-add-entity .exercice-row .col-charges {
  text-align: right;
}

.wizard-add-entity .resultat-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.wizard-add-entity .resultat-badge.positive {
  background: #DCFCE7;
  color: #16A34A;
}

.wizard-add-entity .resultat-badge.negative {
  background: #FEE2E2;
  color: #DC2626;
}

/* Sous-lignes */
.wizard-add-entity .subrow {
  background: white;
}

.wizard-add-entity .subrow td {
  padding: 10px 12px;
  border-bottom: 1px solid #F1F5F9;
}

.wizard-add-entity .subrow-indent {
  display: inline-block;
  width: 24px;
}

.wizard-add-entity .subrow-icon {
  font-size: 14px;
  margin-right: 8px;
}

.wizard-add-entity .subrow-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}

.wizard-add-entity .subrow-detail {
  font-size: 10px;
  color: #94A3B8;
  margin-left: 8px;
}

.wizard-add-entity .subrow-detail.charges-var {
  color: #DC2626;
}

.wizard-add-entity .subrow-detail .tag-exo {
  display: inline-block;
  padding: 1px 5px;
  margin-left: 4px;
  background: #D1FAE5;
  color: #059669;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
}

/* Ligne charges globales */
.wizard-add-entity .charges-globales-row {
  background: #FFFBEB;
}

.wizard-add-entity .charges-globales-row td {
  border-left: 3px solid #F59E0B;
}

/* Ligne CA principal */
.wizard-add-entity .ca-principal-row {
  background: #EFF6FF;
}

.wizard-add-entity .ca-principal-row td {
  border-left: 3px solid #3B82F6;
}

/* Ligne CA secondaire */
.wizard-add-entity .ca-secondaire-row {
  background: #FAFAFA;
}

.wizard-add-entity .ca-secondaire-row td {
  border-left: 3px solid #94A3B8;
}

.wizard-add-entity .inline-label-input {
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  padding: 2px 4px;
  margin: -2px -4px;
  width: 160px;
}

.wizard-add-entity .inline-label-input:focus {
  outline: none;
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #3B82F6;
}

/* Colonnes montant/charges */
.wizard-add-entity .subrow .col-amount {
  text-align: right;
}

.wizard-add-entity .subrow .col-charges {
  text-align: right;
}

.wizard-add-entity .subrow .charge-value {
  font-size: 12px;
  font-weight: 500;
}

.wizard-add-entity .subrow .charge-value.negative {
  color: #DC2626;
}

/* Actions */
.wizard-add-entity .subrow .col-actions {
  text-align: right;
  white-space: nowrap;
}

.wizard-add-entity .subrow .detail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: #F1F5F9;
  color: #64748B;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s;
}

.wizard-add-entity .subrow .detail-btn:hover {
  background: #E2E8F0;
  color: #1E293B;
}

.wizard-add-entity .subrow .detail-btn.has-config {
  background: #FEF3C7;
  color: #D97706;
}

.wizard-add-entity .subrow .remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: #FEE2E2;
  color: #DC2626;
  cursor: pointer;
  font-size: 14px;
  margin-left: 4px;
  transition: all 0.15s;
}

.wizard-add-entity .subrow .remove-btn:hover {
  background: #FECACA;
}

/* Ligne ajouter */
.wizard-add-entity .add-row td {
  padding: 8px 12px 12px;
  border-bottom: none;
}

.wizard-add-entity .add-subrow-btn {
  display: block;
  width: calc(100% - 24px);
  margin-left: 24px;
  padding: 8px;
  border: 1px dashed #CBD5E1;
  border-radius: 6px;
  background: transparent;
  color: #64748B;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-entity .add-subrow-btn:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

/* Charges variables modal */
.wizard-add-entity .charges-var-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
  padding: 40px 20px;
  overflow-y: auto;
  animation: fadeIn 0.2s ease;
}

.wizard-add-entity .charges-var-modal {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.25s ease;
  margin: auto;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.wizard-add-entity .charges-var-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E2E8F0;
  background: linear-gradient(to bottom, #FAFBFC, #F8FAFC);
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.wizard-add-entity .charges-var-modal .modal-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .charges-var-modal .modal-header .close-btn {
  background: #F1F5F9;
  border: none;
  font-size: 18px;
  color: #64748B;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.wizard-add-entity .charges-var-modal .modal-header .close-btn:hover {
  background: #E2E8F0;
  color: #334155;
}

.wizard-add-entity .charges-var-modal .modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.wizard-add-entity .charges-var-modal .modal-hint {
  font-size: 13px;
  color: #64748B;
  margin: 0 0 20px;
  line-height: 1.5;
  padding: 12px 14px;
  background: #F8FAFC;
  border-radius: 8px;
  border-left: 3px solid #F59E0B;
}

.wizard-add-entity .charges-var-config {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wizard-add-entity .config-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wizard-add-entity .config-row label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  min-width: 60px;
}

.wizard-add-entity .config-row select {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 13px;
  background: white;
}

.wizard-add-entity .config-row .input-with-suffix {
  flex: 1 1;
  display: flex;
  align-items: center;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  overflow: hidden;
}

.wizard-add-entity .config-row .input-with-suffix input {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  font-size: 14px;
}

.wizard-add-entity .config-row .input-with-suffix input:focus {
  outline: none;
}

.wizard-add-entity .config-row .input-with-suffix span {
  padding: 8px 12px;
  background: #F1F5F9;
  font-size: 13px;
  color: #64748B;
}

.wizard-add-entity .preview-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  background: #F1F5F9;
  border-radius: 6px;
  font-size: 13px;
}

.wizard-add-entity .preview-row span {
  color: #64748B;
}

.wizard-add-entity .preview-row strong {
  color: #DC2626;
}

.wizard-add-entity .charges-var-modal .modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FAFBFC;
  border-radius: 0 0 16px 16px;
  flex-shrink: 0;
}

.wizard-add-entity .charges-var-modal .modal-footer .footer-hint {
  font-size: 11px;
  color: #94A3B8;
  font-style: italic;
}

.wizard-add-entity .charges-var-modal .btn-save {
  padding: 10px 24px;
  background: linear-gradient(135deg, #F59E0B, #D97706);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.wizard-add-entity .charges-var-modal .btn-save:hover {
  background: linear-gradient(135deg, #D97706, #B45309);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.wizard-add-entity .charges-var-modal .footer-buttons {
  display: flex;
  gap: 10px;
}

.wizard-add-entity .charges-var-modal .btn-cancel {
  padding: 10px 24px;
  background: #F1F5F9;
  color: #475569;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-entity .charges-var-modal .btn-cancel:hover {
  background: #E2E8F0;
  border-color: #CBD5E1;
}

/* ===================== STEP 3 IMPROVEMENTS ===================== */

/* Products add row - positioned after products, before charges */
.wizard-add-entity .add-row.products-add {
  padding: 4px 12px 8px;
  margin: 0;
  justify-content: flex-start;
  gap: 4px;
  border-bottom: 1px solid #E2E8F0;
  background: #FAFBFC;
}

.wizard-add-entity .add-row.products-add button {
  padding: 2px 6px;
  font-size: 9px;
}

/* Expand hint for clickable sections in simplified mode */
.wizard-add-entity .expand-hint {
  font-size: 9px;
  color: #94A3B8;
  font-weight: 400;
  margin-left: 8px;
  font-style: italic;
}

.wizard-add-entity .section-row.clickable {
  cursor: pointer;
  transition: background 0.15s;
}

.wizard-add-entity .section-row.clickable:hover {
  background: #F1F5F9;
}

/* Secondary button in modals */
.wizard-add-entity .charges-var-modal .btn-secondary {
  padding: 8px 16px;
  background: transparent;
  color: #64748B;
  border: 1px solid #CBD5E1;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-right: 10px;
}

.wizard-add-entity .charges-var-modal .btn-secondary:hover {
  background: #F1F5F9;
  border-color: #94A3B8;
  color: #334155;
}

/* Modal footer with multiple buttons */
.wizard-add-entity .charges-var-modal .modal-footer {
  justify-content: space-between;
  align-items: center;
}

/* Summary table in charge modal */
.wizard-add-entity .charge-detail-table.summary {
  width: 100%;
  margin: 16px 0;
}

.wizard-add-entity .charge-detail-table.summary th:first-child,
.wizard-add-entity .charge-detail-table.summary td:first-child {
  width: 80px;
}

/* Formula column in table */
.wizard-add-entity .charge-detail-table td.formula {
  color: #94A3B8;
  font-size: 11px;
  font-style: italic;
}

/* Highlight rows */
.wizard-add-entity .charge-detail-table tr.highlight {
  background: #F0FDF4;
}

.wizard-add-entity .charge-detail-table tr.highlight.positive td {
  color: #059669;
}

/* Muted section */
.wizard-add-entity .charge-detail-section.muted {
  opacity: 0.6;
}

.wizard-add-entity .charge-detail-section.muted h5 {
  color: #94A3B8;
}

/* Info text */
.wizard-add-entity .info-text {
  font-size: 11px;
  color: #64748B;
  margin: 12px 0 0;
  padding: 8px;
  background: #F8FAFC;
  border-radius: 4px;
  border-left: 2px solid #CBD5E1;
}

/* Line value with button */
.wizard-add-entity .line-value-with-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.wizard-add-entity .line-value-with-btn .neg {
  color: #DC2626;
}

.wizard-add-entity .mini-btn.info {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid #CBD5E1;
  border-radius: 50%;
  background: #F8FAFC;
  color: #64748B;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.wizard-add-entity .mini-btn.info:hover {
  background: #F59E0B;
  border-color: #F59E0B;
  color: white;
}

/* Charges config row in modal */
.wizard-add-entity .charges-config-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #F8FAFC;
  border-radius: 6px;
  margin-bottom: 8px;
}

.wizard-add-entity .charges-config-row .config-label {
  flex: 1 1;
  font-size: 12px;
  color: #334155;
}

.wizard-add-entity .charges-config-row .config-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .charges-config-row .config-inputs select {
  padding: 4px 6px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 11px;
  background: white;
}

.wizard-add-entity .charges-config-row .config-inputs input {
  width: 60px;
  padding: 4px 6px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .charges-config-row .config-inputs .suffix {
  font-size: 11px;
  color: #64748B;
  min-width: 14px;
}

.wizard-add-entity .charges-config-row .config-result {
  font-size: 12px;
  font-weight: 600;
  color: #DC2626;
  min-width: 80px;
  text-align: right;
}

/* Charge total row */
.wizard-add-entity .charge-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  margin-top: 20px;
  background: linear-gradient(135deg, #FEF2F2, #FEE2E2);
  border-radius: 10px;
  border: 1px solid #FECACA;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.08);
}

.wizard-add-entity .charge-total-row span {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

.wizard-add-entity .charge-total-row strong {
  font-size: 15px;
  font-weight: 700;
}

.wizard-add-entity .charge-total-row strong.neg {
  color: #DC2626;
}

/* Reset button for overrides */
.wizard-add-entity .reset-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  background: #F8FAFC;
  color: #64748B;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.wizard-add-entity .reset-btn:hover {
  background: #FEF2F2;
  border-color: #FECACA;
  color: #DC2626;
}

/* Override hint */
.wizard-add-entity .override-hint {
  font-size: 10px;
  color: #94A3B8;
  margin-top: 4px;
  padding-left: 12px;
  font-style: italic;
}

/* Compact table */
.wizard-add-entity .charge-detail-table.compact {
  font-size: 11px;
  margin-bottom: 8px;
}

.wizard-add-entity .charge-detail-table.compact th,
.wizard-add-entity .charge-detail-table.compact td {
  padding: 4px 8px;
}

/* Compact charge summary row */
.wizard-add-entity .charge-summary-row.compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #F8FAFC;
  border-radius: 4px;
  font-size: 11px;
  margin-bottom: 8px;
}

.wizard-add-entity .charge-summary-row.compact strong {
  color: #334155;
}

/* Editable override inputs */
.wizard-add-entity .charges-config-row.editable {
  background: #FFFBEB;
  border: 1px solid #FCD34D;
}

.wizard-add-entity .charges-config-row .config-inputs input.editable-override {
  width: 100px;
  background: white;
  border: 2px solid #F59E0B;
}

.wizard-add-entity .charges-config-row .config-inputs input.editable-override:focus {
  outline: none;
  border-color: #D97706;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.wizard-add-entity .charges-config-row .config-inputs input.editable-override::placeholder {
  color: #9CA3AF;
  font-size: 10px;
}

/* Auto hint badge */
.wizard-add-entity .auto-hint {
  font-size: 9px;
  color: #059669;
  background: #D1FAE5;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
}

/* Edit hint text */
.wizard-add-entity .edit-hint {
  font-size: 10px;
  color: #6B7280;
  margin-top: 6px;
  padding: 6px 8px;
  background: #F9FAFB;
  border-radius: 4px;
  font-style: italic;
}

/* ============================== */
/* MODAL EDITING STYLES           */
/* ============================== */

/* CFE Base Edit (Modal 63) */
.wizard-add-entity .cfe-base-edit {
  padding: 12px;
  background: #FEF3C7;
  border: 1px solid #FCD34D;
  border-radius: 6px;
  margin-bottom: 16px;
}

.wizard-add-entity .cfe-base-edit label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #92400E;
  margin-bottom: 8px;
}

.wizard-add-entity .cfe-base-edit .input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .cfe-base-edit .input-row input {
  width: 120px;
  padding: 8px 12px;
  border: 2px solid #F59E0B;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  text-align: right;
}

.wizard-add-entity .cfe-base-edit .input-row input:focus {
  outline: none;
  border-color: #D97706;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.wizard-add-entity .cfe-base-edit .suffix {
  font-size: 14px;
  color: #92400E;
  font-weight: 500;
}

.wizard-add-entity .cfe-base-edit .field-hint {
  font-size: 10px;
  color: #B45309;
  margin-top: 6px;
}

/* CFE Calculation display */
.wizard-add-entity .cfe-calculation {
  padding: 12px;
  background: #F0FDF4;
  border: 1px solid #86EFAC;
  border-radius: 6px;
}

.wizard-add-entity .cfe-calculation h6 {
  font-size: 11px;
  font-weight: 600;
  color: #166534;
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Charge Lines Edit (Modal 61-62) */
.wizard-add-entity .charge-lines-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-add-entity .charge-line-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  background: #F8FAFC;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .charge-line-edit.enabled {
  background: #FFFBEB;
  border-color: #FCD34D;
}

.wizard-add-entity .charge-line-edit.disabled {
  opacity: 0.6;
}

.wizard-add-entity .charge-line-edit .charge-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  cursor: pointer;
}

.wizard-add-entity .charge-line-edit .charge-toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.wizard-add-entity .charge-line-edit .charge-icon {
  font-size: 14px;
}

.wizard-add-entity .charge-line-edit .charge-name {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.wizard-add-entity .charge-line-edit .charge-value-edit {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.wizard-add-entity .charge-line-edit .charge-value-edit input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 12px;
  text-align: right;
}

.wizard-add-entity .charge-line-edit .charge-value-edit input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);
}

.wizard-add-entity .charge-line-edit .charge-value-edit select {
  padding: 6px 8px;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  font-size: 11px;
  background: white;
  cursor: pointer;
}

/* Simplified charge edit (Modal 61-62 simplified) */
.wizard-add-entity .simplified-charge-edit {
  padding: 12px;
  background: #F8FAFC;
  border-radius: 6px;
}

.wizard-add-entity .simplified-charge-edit .radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-size: 13px;
  color: #334155;
}

.wizard-add-entity .simplified-charge-edit .radio-option input[type="radio"] {
  width: 16px;
  height: 16px;
}

.wizard-add-entity .simplified-charge-edit .input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0 8px 24px;
}

.wizard-add-entity .simplified-charge-edit .input-row input {
  width: 100px;
  padding: 8px 10px;
  border: 2px solid #F59E0B;
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
}

.wizard-add-entity .simplified-charge-edit .input-row input:focus {
  outline: none;
  border-color: #D97706;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.wizard-add-entity .simplified-charge-edit .input-row .suffix {
  font-size: 12px;
  color: #64748B;
}

/* ============================== */
/* MODAL 64 - PERSONNEL           */
/* ============================== */

/* Manager list container */
.wizard-add-entity .managers-edit-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Manager edit card */
.wizard-add-entity .manager-edit-row {
  background: white;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  overflow: hidden;
}

.wizard-add-entity .manager-edit-row .manager-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #FFFBEB, #FEF3C7);
  border-bottom: 1px solid #FCD34D;
}

.wizard-add-entity .manager-edit-row .manager-role {
  font-size: 13px;
  font-weight: 600;
  color: #92400E;
}

.wizard-add-entity .manager-edit-row .status-badge {
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.wizard-add-entity .manager-edit-row .status-badge.tns {
  background: #DBEAFE;
  color: #1E40AF;
}

.wizard-add-entity .manager-edit-row .status-badge.as {
  background: #F3E8FF;
  color: #7C3AED;
}

.wizard-add-entity .manager-edit-row .manager-inputs {
  display: flex;
  gap: 16px;
  padding: 14px;
  flex-wrap: wrap;
}

.wizard-add-entity .manager-edit-row .input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wizard-add-entity .manager-edit-row .input-group label {
  font-size: 10px;
  font-weight: 500;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-entity .manager-edit-row .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .manager-edit-row .input-with-suffix input {
  width: 100px;
  padding: 8px 10px;
  border: 2px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  transition: border-color 0.15s;
}

.wizard-add-entity .manager-edit-row .input-with-suffix input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.wizard-add-entity .manager-edit-row .input-with-suffix span {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-entity .manager-edit-row .input-group input.small {
  width: 60px;
  padding: 8px 10px;
  border: 2px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.wizard-add-entity .manager-edit-row .input-group input.small:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.wizard-add-entity .manager-edit-row .manager-calc {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #F8FAFC;
  border-top: 1px solid #E2E8F0;
  flex-wrap: wrap;
}

.wizard-add-entity .manager-edit-row .calc-detail {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .manager-edit-row .tag-acre {
  font-size: 9px;
  padding: 2px 6px;
  background: #D1FAE5;
  color: #059669;
  border-radius: 3px;
  font-weight: 600;
}

.wizard-add-entity .manager-edit-row .manager-calc strong {
  font-size: 13px;
  color: #DC2626;
  margin-left: auto;
}

/* ============================== */
/* EMPLOYEES SECTION (Modal 64)   */
/* ============================== */

.wizard-add-entity .employees-edit {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wizard-add-entity .employees-edit .checkbox-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #F8FAFC;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.wizard-add-entity .employees-edit .checkbox-option:hover {
  background: #F1F5F9;
}

.wizard-add-entity .employees-edit .checkbox-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.wizard-add-entity .employees-edit .checkbox-option span {
  font-size: 13px;
  color: #334155;
}

.wizard-add-entity .employees-edit .employees-inputs {
  display: flex;
  gap: 16px;
  padding: 14px;
  background: #EFF6FF;
  border: 1px solid #93C5FD;
  border-radius: 8px;
  flex-wrap: wrap;
}

.wizard-add-entity .employees-edit .input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wizard-add-entity .employees-edit .input-group label {
  font-size: 10px;
  font-weight: 500;
  color: #1E40AF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-entity .employees-edit .input-with-suffix {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .employees-edit .input-with-suffix input {
  width: 100px;
  padding: 8px 10px;
  border: 2px solid #93C5FD;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  background: white;
}

.wizard-add-entity .employees-edit .input-with-suffix input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.wizard-add-entity .employees-edit .input-with-suffix span {
  font-size: 12px;
  color: #1E40AF;
  font-weight: 500;
}

.wizard-add-entity .employees-edit .input-group input.small {
  width: 60px;
  padding: 8px 10px;
  border: 2px solid #93C5FD;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background: white;
}

.wizard-add-entity .employees-edit .input-group input.small:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.wizard-add-entity .employees-edit .employees-calc {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #DBEAFE;
  border-radius: 6px;
  flex-wrap: wrap;
}

.wizard-add-entity .employees-edit .calc-formula {
  font-size: 11px;
  color: #1E40AF;
}

.wizard-add-entity .employees-edit .employees-calc strong {
  font-size: 13px;
  color: #1E40AF;
  margin-left: auto;
}

/* Legacy styles - keeping for compatibility */
.wizard-add-entity .employees-edit .field-group input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #93C5FD;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
  background: white;
}

.wizard-add-entity .employees-edit .field-group input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.wizard-add-entity .employees-edit .field-group .suffix {
  font-size: 11px;
  color: #1E40AF;
}

.wizard-add-entity .employees-edit .employees-calculated {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #93C5FD;
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .employees-edit .employees-calculated strong {
  color: #DC2626;
}

/* Editable amount fields */
.wizard-add-entity .editable-amount {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .editable-amount .amount-input {
  width: 80px;
  padding: 4px 6px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  background: #FFF;
}

.wizard-add-entity .editable-amount .amount-input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.wizard-add-entity .editable-amount .amount-input:disabled {
  background: #F1F5F9;
  color: #94A3B8;
}

.wizard-add-entity .editable-amount .currency {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-entity .editable-amount .btn-reset {
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: #FEF3C7;
  color: #D97706;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-add-entity .editable-amount .btn-reset:hover {
  background: #FDE68A;
}

.wizard-add-entity .calc-indicator {
  display: block;
  font-size: 9px;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* CA info in CFE */
.wizard-add-entity .impot-ca-info {
  display: block;
  font-size: 10px;
  color: #666;
  margin-top: 2px;
}

/* ===================== CHARGES SUMMARY TABLE ===================== */

.wizard-add-entity .charges-summary-table {
  width: 100%;
  border-collapse: collapse;
}

.wizard-add-entity .charges-summary-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #E5E7EB;
}

.wizard-add-entity .charges-summary-table td:first-child {
  color: #374151;
}

.wizard-add-entity .charges-summary-table td:last-child {
  text-align: right;
  font-weight: 500;
}

.wizard-add-entity .charges-summary-table td.neg {
  color: #DC2626;
}

.wizard-add-entity .charges-summary-table .total-row td {
  border-top: 2px solid #374151;
  border-bottom: none;
  padding-top: 12px;
}

/* ===================== FULLPAGE EDIT MODE - COMPACT LAYOUT ===================== */

/* Make rows more compact - no space-between, use max-width */
.wizard-add-entity.fullpage .exercice-card {
  max-width: 600px;
}

.wizard-add-entity.fullpage .section-row,
.wizard-add-entity.fullpage .line-row {
  justify-content: flex-start;
  gap: 12px;
}

.wizard-add-entity.fullpage .section-label,
.wizard-add-entity.fullpage .line-label {
  min-width: 140px;
  flex-shrink: 0;
}

.wizard-add-entity.fullpage .section-value,
.wizard-add-entity.fullpage .line-input,
.wizard-add-entity.fullpage .line-value-with-btn {
  min-width: 100px;
  text-align: right;
}

/* ===================== RESPONSIVE EDIT MODE ===================== */

@media (max-width: 768px) {
  .wizard-add-entity.fullpage {
    left: 8px;
    right: 8px;
    top: 120px;
    bottom: 8px;
  }

  .wizard-add-entity.fullpage .exercices-compact-list {
    grid-template-columns: 1fr;
  }
}

/* ===================== DIVIDEND SETTINGS INLINE (Step 1) ===================== */

.wizard-add-entity .dividend-settings-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);
  border: 1px solid #fcd34d;
  border-radius: 6px;
}

.wizard-add-entity .dividend-inline-label {
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
  white-space: nowrap;
}

.wizard-add-entity .dividend-inline-fields {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.wizard-add-entity .dividend-inline-field {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .dividend-inline-field .field-prefix,
.wizard-add-entity .dividend-inline-field .field-suffix {
  font-size: 12px;
  color: #78350f;
}

.wizard-add-entity .dividend-pct-input,
.wizard-add-entity .dividend-delay-input {
  width: 50px;
  padding: 4px 6px;
  border: 1px solid #d97706;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  background: white;
}

.wizard-add-entity .dividend-pct-input:focus,
.wizard-add-entity .dividend-delay-input:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.wizard-add-entity .dividend-field .suffix {
  padding: 6px 10px;
  background: #fef3c7;
  color: #92400e;
  font-size: 12px;
  font-weight: 500;
  border-left: 1px solid #d97706;
}

/* ===================== DIVIDEND ROW IN EXERCICE CARD ===================== */

.wizard-add-entity .dividendes-row {
  background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);
  border-radius: 6px;
  margin-top: 8px;
  padding: 8px 12px;
}

.wizard-add-entity .dividendes-row.overridden {
  border-left: 3px solid #f59e0b;
}

.wizard-add-entity .dividendes-row .section-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .dividendes-row .icon {
  font-size: 14px;
}

.wizard-add-entity .dividendes-label {
  font-size: 12px;
  font-weight: 500;
  color: #92400e;
}

.wizard-add-entity .dividend-pct-input-inline {
  width: 45px;
  padding: 2px 4px;
  border: 1px solid #d97706;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  background: white;
  margin-left: 8px;
}

.wizard-add-entity .dividend-pct-suffix {
  font-size: 11px;
  color: #78350f;
  margin-left: 2px;
}

.wizard-add-entity .dividend-value {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wizard-add-entity .dividend-amount {
  font-weight: 600;
  color: #92400e;
  font-size: 13px;
}

.wizard-add-entity .dividend-date {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .dividend-date-input {
  width: 130px;
  padding: 2px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 11px;
  background: white;
}

.wizard-add-entity .dividend-date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}

.wizard-add-entity .dividend-date-default {
  font-size: 11px;
  color: #78350f;
  font-style: italic;
}

/* Hide date input when default is shown */
.wizard-add-entity .dividend-date-input[value=""] {
  width: 24px;
  border: none;
  background: transparent;
}

.wizard-add-entity .dividend-date-input[value=""]::-webkit-calendar-picker-indicator {
  opacity: 0.4;
}

/* ===================== AFFECTATION DU RÉSULTAT ===================== */

/* Séparateur pointillé */
.wizard-add-entity .affectation-separator {
  border-top: 2px dashed #CBD5E1;
  margin: 10px 0 8px 0;
}

/* Ligne Affectation - Zone de configuration */
.wizard-add-entity .section-row.affectation-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 6px 8px 3px 8px;
}

.wizard-add-entity .section-row.affectation-row.overridden {
  border-left: 4px solid #3B82F6;
}

.wizard-add-entity .affectation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wizard-add-entity .affectation-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .affectation-text {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.wizard-add-entity .affectation-config {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
}

.wizard-add-entity .config-group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-entity .config-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-entity .config-suffix {
  font-size: 14px;
  color: #1E293B;
  font-weight: 700;
}

.wizard-add-entity .config-default {
  font-size: 12px;
  color: #64748B;
  font-style: italic;
}

.wizard-add-entity .affectation-date-input {
  width: 115px;
  padding: 5px 8px;
  border: 1px solid #D1D5DB;
  border-radius: 5px;
  font-size: 13px;
  background: white;
}

.wizard-add-entity .affectation-date-input:hover {
  border-color: #9CA3AF;
}

.wizard-add-entity .affectation-date-input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.wizard-add-entity .affectation-date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}

/* Hide date input when default is shown - show only calendar icon */
.wizard-add-entity .affectation-date-input[value=""] {
  width: 28px;
  padding: 5px;
  border: 1px dashed #D1D5DB;
  background: #FAFAFA;
}

.wizard-add-entity .affectation-pct-input {
  width: 55px;
  padding: 5px 8px;
  border: 2px solid #3B82F6;
  border-radius: 5px;
  font-size: 15px;
  text-align: center;
  background: #EFF6FF;
  font-weight: 700;
  color: #1E40AF;
}

.wizard-add-entity .affectation-pct-input:hover {
  background: #DBEAFE;
}

.wizard-add-entity .affectation-pct-input:focus {
  outline: none;
  border-color: #2563EB;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.wizard-add-entity .affectation-detail-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #CBD5E1;
  background: white;
  color: #64748B;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  transition: all 0.15s;
}

.wizard-add-entity .affectation-detail-btn:hover {
  background: #EFF6FF;
  border-color: #3B82F6;
  color: #3B82F6;
  transform: scale(1.1);
}

/* Ligne Dividendes résultat */
.wizard-add-entity .section-row.dividendes-result-row {
  display: grid;
  grid-template-columns: 1fr auto;
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  border: 1px solid #A7F3D0;
  border-left: 4px solid #10B981;
  border-radius: 6px;
  padding: 8px 14px;
  margin: 4px 8px 4px 20px;
  gap: 16px;
}

.wizard-add-entity .dividendes-result-row .section-label {
  color: #047857;
  font-weight: 600;
  font-size: 14px;
  gap: 8px;
}

.wizard-add-entity .dividendes-result-row .section-value {
  color: #047857;
  font-weight: 700;
  font-size: 15px;
}

.wizard-add-entity .tax-year-badge {
  font-size: 11px;
  padding: 3px 8px;
  background: #DBEAFE;
  color: #1D4ED8;
  border-radius: 10px;
  margin-left: 6px;
  font-weight: 600;
}

/* Ligne Report à nouveau */
.wizard-add-entity .section-row.report-nouveau-row {
  display: grid;
  grid-template-columns: 1fr auto;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-left: 3px solid #94A3B8;
  border-radius: 5px;
  padding: 6px 14px;
  margin: 0 8px 0 20px;
  gap: 16px;
}

.wizard-add-entity .report-nouveau-row .section-label {
  color: #64748B;
  font-weight: 500;
  font-size: 13px;
  gap: 6px;
}

.wizard-add-entity .report-nouveau-row .section-value {
  color: #475569;
  font-weight: 600;
  font-size: 14px;
}

.wizard-add-entity .report-hint {
  font-size: 10px;
  color: #94A3B8;
  margin-left: 6px;
  font-style: italic;
}

/* ===================== MODAL AFFECTATION DÉTAIL ===================== */

.wizard-add-entity .affectation-detail-modal {
  max-width: 450px;
  border-radius: 12px;
  overflow: hidden;
}

.wizard-add-entity .affectation-detail-modal .modal-header {
  background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
  padding: 16px 20px;
}

.wizard-add-entity .affectation-detail-modal .modal-header h4 {
  font-size: 16px;
  color: white;
  margin: 0;
}

.wizard-add-entity .affectation-detail-modal .modal-header .close-btn {
  color: white;
  opacity: 0.8;
}

.wizard-add-entity .affectation-detail-modal .modal-header .close-btn:hover {
  opacity: 1;
}

.wizard-add-entity .affectation-detail-modal .modal-body {
  padding: 20px;
}

.wizard-add-entity .affectation-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-entity .affectation-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.wizard-add-entity .affectation-section h5 {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-entity .section-hint {
  font-size: 13px;
  color: #64748B;
  margin: -8px 0 12px 0;
  font-style: italic;
}

.wizard-add-entity .affectation-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #F8FAFC;
  border-radius: 8px;
  padding: 8px;
}

.wizard-add-entity .affectation-detail-grid .detail-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 8px 12px;
  gap: 16px;
  background: white;
  border-radius: 6px;
}

.wizard-add-entity .affectation-detail-grid .detail-row.indent {
  padding-left: 24px;
  background: #FAFAFA;
  border-left: 2px solid #E2E8F0;
  margin-left: 8px;
}

.wizard-add-entity .affectation-detail-grid .detail-row.total {
  background: linear-gradient(135deg, #F1F5F9 0%, #E2E8F0 100%);
  border: 1px solid #CBD5E1;
  margin-top: 4px;
}

.wizard-add-entity .affectation-detail-grid .detail-row.total .detail-label {
  font-weight: 700;
}

.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  border: 1px solid #A7F3D0;
  border-left: 4px solid #10B981;
}

.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green .detail-label {
  color: #047857;
  font-weight: 600;
}

.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green .detail-value {
  color: #047857;
  font-weight: 700;
  font-size: 16px;
}

.wizard-add-entity .affectation-detail-grid .detail-row.sub-hint {
  padding: 4px 12px 4px 24px;
  background: transparent;
}

.wizard-add-entity .affectation-detail-grid .detail-label {
  font-size: 14px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
}

.wizard-add-entity .affectation-detail-grid .detail-label-small {
  font-size: 12px;
  color: #64748B;
  font-style: italic;
}

.wizard-add-entity .affectation-detail-grid .detail-value {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
  text-align: right;
}

.wizard-add-entity .affectation-detail-grid .detail-value.neg {
  color: #DC2626;
}

.wizard-add-entity .affectation-detail-grid .detail-value.pos {
  color: #059669;
}

.wizard-add-entity .affectation-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  border: 1px solid #BFDBFE;
  border-radius: 8px;
  margin-top: 16px;
}

.wizard-add-entity .affectation-note .note-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.wizard-add-entity .affectation-note span:last-child {
  font-size: 13px;
  color: #1E40AF;
  line-height: 1.5;
}

/* ==================== IS WARNING MODAL ==================== */
.is-warning-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.is-warning-modal {
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 520px;
  width: 90%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.is-warning-modal .warning-icon {
  font-size: 48px;
  text-align: center;
  margin-bottom: 16px;
}

.is-warning-modal h3 {
  font-size: 20px;
  font-weight: 700;
  color: #DC2626;
  text-align: center;
  margin: 0 0 16px 0;
}

.is-warning-modal p {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 12px 0;
}

.is-warning-modal .warning-detail {
  color: #6B7280;
}

.is-warning-modal .warning-list {
  margin: 12px 0 20px 0;
  padding-left: 24px;
}

.is-warning-modal .warning-list li {
  font-size: 13px;
  color: #6B7280;
  margin-bottom: 6px;
  line-height: 1.5;
}

.is-warning-modal .warning-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 20px;
}

.is-warning-modal .warning-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  accent-color: #DC2626;
  cursor: pointer;
}

.is-warning-modal .warning-checkbox span {
  font-size: 14px;
  font-weight: 500;
  color: #991B1B;
  line-height: 1.4;
}

.is-warning-modal .warning-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.is-warning-modal .btn-cancel {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  background: #F3F4F6;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.is-warning-modal .btn-cancel:hover {
  background: #E5E7EB;
  color: #374151;
}

.is-warning-modal .btn-confirm {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: #DC2626;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.is-warning-modal .btn-confirm:hover:not(:disabled) {
  background: #B91C1C;
}

.is-warning-modal .btn-confirm:disabled {
  background: #FCA5A5;
  cursor: not-allowed;
}

/* Lock indicator for IS selected on SCI/SNC */
.wizard-add-entity .regime-option.locked::after {
  content: '🔒';
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 12px;
}

.wizard-add-entity .regime-option.locked {
  position: relative;
  border-color: #F59E0B !important;
  background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Entity/WizardAddEntity.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,8CAA8C;;AAE9C,iEAAiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mEAAmE;;AAEnE;EACE,eAAe;EACf,UAAU,GAAG,kDAAkD;EAC/D,WAAW,GAAG,gDAAgD;EAC9D,UAAU,IAAI,mCAAmC;EACjD,WAAW,GAAG,mCAAmC;EACjD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qDAAqD;;AAErD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6DAA6D;;AAE7D;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,6BAA6B,SAAO,EAAE;AACtC,6BAA6B,SAAO,EAAE;AACtC,6BAA6B,SAAO,EAAE;;AAEtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY,EAAE,kCAAkC;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EAEX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;;AAE3D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,6EAA6E;;AAE7E,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4DAA4D;;AAE5D,eAAe;AACf;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iEAAiE;;AAEjE,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,qEAAqE;;AAErE,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oEAAoE;;AAEpE,qFAAqF;AACrF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,+CAA+C;AACjD;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,gCAAgC;EAChC,wDAAwD;EACxD,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,2CAA2C,EAAE;AACrD;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gEAAgE;;AAEhE;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wEAAwE;;AAExE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yEAAyE;;AAEzE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,yEAAyE;;AAEzE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wEAAwE;;AAExE;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,uEAAuE;;AAEvE;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uFAAuF;;AAEvF,sBAAsB;AACtB;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sEAAsE;;AAEtE,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;oEAEoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qEAAqE;;AAErE;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,6CAA6C,EAAE;EAClE,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,oFAAoF;;AAEpF,yDAAyD;AACzD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE,6FAA6F;AAC7F;EACE,aAAa;EACb,+DAA+D;EAC/D,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D,uGAAuG;AACvG;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qFAAqF;;AAErF,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD,uEAAuE;AACvE;EACE,aAAa;EACb,kFAAkF;EAClF,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kFAAkF;EAClF,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oFAAoF;;AAEpF,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,wDAAwD;EACxD,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oEAAoE;;AAEpE,iEAAiE;AACjE;EACE,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,sEAAsE;;AAEtE;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oFAAoF;;AAEpF,6DAA6D;AAC7D;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qEAAqE;;AAErE;EACE;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kFAAkF;;AAElF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,8EAA8E;;AAE9E;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,wEAAwE;;AAExE,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,+BAA+B;EAC/B,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,wEAAwE;AAC1E","sourcesContent":["/* src/components/Entity/WizardAddEntity.css */\n/* 4-step expert wizard - Full screen layout */\n\n/* ===================== FULL PAGE LAYOUT ===================== */\n\n.wizard-add-entity {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: #F8FAFC;\n  overflow: hidden;\n}\n\n/* ===================== FULLPAGE EDIT MODE ===================== */\n\n.wizard-add-entity.fullpage {\n  position: fixed;\n  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */\n  left: 228px;  /* After sidebar (220px) + lanes padding (8px) */\n  right: 8px;   /* Same margin as lanes-container */\n  bottom: 8px;  /* Same margin as lanes-container */\n  z-index: 1100;\n  border-radius: 10px;\n  border: 1px solid #BDC3C7;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.wizard-add-entity.fullpage .wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.wizard-add-entity .wizard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .wizard-header.edit-mode .header-identity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .wizard-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .wizard-header .legal-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.wizard-add-entity .wizard-header .tax-badge {\n  background: rgba(255,255,255,0.15);\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .wizard-header .activity-badge {\n  font-size: 12px;\n  opacity: 0.85;\n}\n\n.wizard-add-entity .wizard-header .header-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .wizard-header .btn-save {\n  background: white;\n  color: #D97706;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .wizard-header .btn-save:hover {\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .wizard-header .btn-save.saving {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.wizard-add-entity .wizard-header .btn-save.success {\n  background: #10B981;\n  color: white;\n}\n\n.wizard-add-entity .wizard-header .btn-close {\n  background: rgba(255,255,255,0.2);\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-add-entity .wizard-header .btn-close:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n.wizard-add-entity .wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n/* ===================== TOPBAR ===================== */\n\n.wizard-add-entity .entity-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  flex-shrink: 0;\n  gap: 16px;\n}\n\n.wizard-add-entity .entity-topbar h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Steps indicator */\n.wizard-add-entity .steps-indicator {\n  display: flex;\n  gap: 8px;\n}\n\n.wizard-add-entity .step-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  background: rgba(255,255,255,0.15);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .step-indicator:hover {\n  background: rgba(255,255,255,0.25);\n}\n\n.wizard-add-entity .step-indicator.active {\n  background: white;\n}\n\n.wizard-add-entity .step-indicator.active .step-num {\n  background: #F59E0B;\n  color: white;\n}\n\n.wizard-add-entity .step-indicator.active .step-label {\n  color: #D97706;\n  font-weight: 600;\n}\n\n.wizard-add-entity .step-indicator.done {\n  background: rgba(16, 185, 129, 0.3);\n}\n\n.wizard-add-entity .step-indicator.done .step-num {\n  background: #10B981;\n}\n\n.wizard-add-entity .step-num {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n}\n\n.wizard-add-entity .step-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(255,255,255,0.9);\n}\n\n.wizard-add-entity .topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wizard-add-entity .save-btn {\n  padding: 6px 16px;\n  background: rgba(255,255,255,0.2);\n  border: 1px solid rgba(255,255,255,0.4);\n  color: white;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .save-btn:hover:not(:disabled) {\n  background: rgba(255,255,255,0.35);\n}\n\n.wizard-add-entity .save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wizard-add-entity .close-btn {\n  background: rgba(255,255,255,0.2);\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-size: 18px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-add-entity .close-btn:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n/* ===================== BODY ===================== */\n\n.wizard-add-entity .entity-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n/* ===================== STEP CONTENT ===================== */\n\n.wizard-add-entity .step-content {\n  width: 100%;\n  animation: fadeInStep 0.3s ease-out;\n}\n\n@keyframes fadeInStep {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===================== IDENTITY STEP ===================== */\n\n.wizard-add-entity .identity-step {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wizard-add-entity .form-row-flex {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.wizard-add-entity .flex-1 { flex: 1; }\n.wizard-add-entity .flex-2 { flex: 2; }\n.wizard-add-entity .flex-3 { flex: 3; }\n\n.wizard-add-entity .form-section {\n  background: white;\n  border-radius: 10px;\n  padding: 14px 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .form-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  margin: 0 0 12px 0;\n}\n\n.wizard-add-entity .input-name {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 10px 14px;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n}\n\n.wizard-add-entity .form-section.flex-2,\n.wizard-add-entity .form-section.flex-3 {\n  min-width: 0; /* Permet au flex item de shrink */\n  overflow: hidden;\n}\n\n.wizard-add-entity .input-name:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Creation Date */\n.wizard-add-entity .creation-date-group {\n  margin-top: 12px;\n}\n\n.wizard-add-entity .input-date {\n  width: 160px;\n  max-width: 100%;\n  padding: 8px 10px;\n  font-size: 13px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  box-sizing: border-box;\n}\n\n.wizard-add-entity .input-date:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Code postal pour CFE avec détection ville */\n.wizard-add-entity .postal-with-city {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wizard-add-entity .input-postal {\n  width: 80px;\n  padding: 8px 10px;\n  font-size: 13px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-entity .input-postal:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-entity .detected-city {\n  font-size: 13px;\n  color: #059669;\n  font-weight: 500;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateX(-5px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n/* Legal Form Grid */\n.wizard-add-entity .legal-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 8px;\n}\n\n.wizard-add-entity .legal-form-card {\n  padding: 10px 12px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: white;\n}\n\n.wizard-add-entity .legal-form-card:hover {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .legal-form-card.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .lf-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.wizard-add-entity .lf-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-entity .lf-manager {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .lf-manager.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .lf-manager.as {\n  background: #D1FAE5;\n  color: #047857;\n}\n\n.wizard-add-entity .lf-manager.none {\n  background: #F1F5F9;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .lf-desc {\n  font-size: 10px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.wizard-add-entity .gerant-option {\n  margin-top: 10px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .gerant-option label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #475569;\n  cursor: pointer;\n}\n\n/* Tax Regime Options */\n.wizard-add-entity .regime-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-add-entity .regime-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .regime-option:hover {\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .regime-option.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .regime-icon {\n  font-size: 18px;\n}\n\n.wizard-add-entity .regime-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .regime-desc {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.wizard-add-entity .recommended-badge {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 600;\n  color: white;\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  border-radius: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n/* Activity Chips */\n.wizard-add-entity .activity-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.wizard-add-entity .chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 20px;\n  background: white;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .chip:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n}\n\n.wizard-add-entity .chip.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n  color: #D97706;\n  font-weight: 600;\n}\n\n.wizard-add-entity .chip-icon {\n  font-size: 14px;\n}\n\n/* Form Group */\n.wizard-add-entity .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wizard-add-entity .form-group label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n/* Input with suffix wrapper */\n.wizard-add-entity .input-suffix-wrapper {\n  display: flex;\n  align-items: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n}\n\n.wizard-add-entity .input-suffix-wrapper input {\n  flex: 1;\n  padding: 8px 10px;\n  border: none;\n  font-size: 13px;\n  min-width: 60px;\n}\n\n.wizard-add-entity .input-suffix-wrapper input:focus {\n  outline: none;\n}\n\n.wizard-add-entity .input-suffix-wrapper .suffix {\n  padding: 8px 10px;\n  background: #F8FAFC;\n  font-size: 11px;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.wizard-add-entity .input-suffix-wrapper.large input {\n  padding: 12px 14px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.wizard-add-entity .input-suffix-wrapper.large .suffix {\n  padding: 12px 14px;\n  font-size: 13px;\n}\n\n/* Fiscal Year Options */\n.wizard-add-entity .fiscal-year-options {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .fy-btn {\n  padding: 6px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: white;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .fy-btn:hover {\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .fy-btn.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n  color: #D97706;\n  font-weight: 600;\n}\n\n.wizard-add-entity .fy-custom-input {\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n  width: 70px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n/* APE Search */\n.wizard-add-entity .ape-group {\n  position: relative;\n  min-width: 200px;\n}\n\n.wizard-add-entity .ape-search-wrapper {\n  position: relative;\n}\n\n.wizard-add-entity .ape-search-wrapper input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .ape-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  z-index: 100;\n}\n\n.wizard-add-entity .ape-option {\n  padding: 8px 10px;\n  font-size: 11px;\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .ape-option:hover {\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .ape-option strong {\n  color: #D97706;\n  margin-right: 6px;\n}\n\n.wizard-add-entity .ape-selected {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 3px 8px;\n  background: #FEF3C7;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #D97706;\n}\n\n/* ===================== CHARGES STEP ===================== */\n\n.wizard-add-entity .charges-step {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Mode Selector (Simplifié / Détaillé) */\n.wizard-add-entity .mode-selector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: white;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .mode-toggle.large {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: #F1F5F9;\n  border-radius: 10px;\n}\n\n.wizard-add-entity .mode-toggle.large button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .mode-toggle.large button:hover {\n  color: #1E293B;\n}\n\n.wizard-add-entity .mode-toggle.large button.active {\n  background: white;\n  color: #D97706;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.wizard-add-entity .mode-icon {\n  font-size: 16px;\n}\n\n.wizard-add-entity .mode-hint {\n  font-size: 12px;\n  color: #94A3B8;\n}\n\n/* Section icon */\n.wizard-add-entity .section-icon {\n  margin-right: 6px;\n}\n\n/* PCG Badge - numéro de compte comptable */\n.wizard-add-entity .pcg-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  margin-right: 6px;\n  background: linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%);\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748B;\n  font-family: monospace;\n}\n\n.wizard-add-entity .pcg-badge.small {\n  padding: 1px 4px;\n  margin-right: 4px;\n  font-size: 9px;\n}\n\n.wizard-add-entity h4 .pcg-badge {\n  margin-left: 4px;\n}\n\n.wizard-add-entity h5 .pcg-badge {\n  vertical-align: middle;\n}\n\n/* Simple row (mode simplifié) */\n.wizard-add-entity .simple-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .simple-calc {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 14px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  min-width: 140px;\n}\n\n.wizard-add-entity .simple-calc .calc-label {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.wizard-add-entity .simple-calc .calc-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #D97706;\n}\n\n/* ACRE toggle (mode simplifié) */\n.wizard-add-entity .acre-toggle {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .checkbox-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .checkbox-inline input {\n  width: 16px;\n  height: 16px;\n}\n\n.wizard-add-entity .checkbox-inline span {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .checkbox-inline .hint {\n  font-size: 11px;\n  color: #16A34A;\n  font-style: italic;\n}\n\n/* Employees switch */\n.wizard-add-entity .employees-switch {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .switch-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.wizard-add-entity .employees-row {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .small-input {\n  width: 60px;\n  padding: 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* Charge type selector */\n.wizard-add-entity .charge-type-selector {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .charge-type-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charge-type-option .option-label {\n  font-size: 13px;\n  color: #475569;\n}\n\n.wizard-add-entity .charge-input-large {\n  max-width: 280px;\n}\n\n/* Dividend slider */\n.wizard-add-entity .dividend-slider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.wizard-add-entity .dividend-slider input[type=\"range\"] {\n  flex: 1;\n  max-width: 200px;\n  height: 6px;\n  -webkit-appearance: none;\n  appearance: none;\n  background: #E2E8F0;\n  border-radius: 3px;\n  outline: none;\n}\n\n.wizard-add-entity .dividend-slider input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #F59E0B;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.wizard-add-entity .dividend-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #D97706;\n  min-width: 50px;\n}\n\n.wizard-add-entity .dividend-hint {\n  font-size: 12px;\n  color: #94A3B8;\n}\n\n/* Detail tabs */\n.wizard-add-entity .detail-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 4px;\n  background: #F1F5F9;\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n.wizard-add-entity .detail-tabs button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .detail-tabs button:hover {\n  color: #1E293B;\n}\n\n.wizard-add-entity .detail-tabs button.active {\n  background: white;\n  color: #D97706;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.wizard-add-entity .tab-icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .tab-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Employees details grid (mode détaillé) */\n.wizard-add-entity .employees-details-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .centered-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.wizard-add-entity .employees-summary {\n  grid-column: span 3;\n  background: #F8FAFC;\n  border-radius: 8px;\n  padding: 12px;\n  margin-top: 8px;\n}\n\n.wizard-add-entity .employees-summary .summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  font-size: 13px;\n}\n\n.wizard-add-entity .employees-summary .summary-row span {\n  color: #64748B;\n}\n\n.wizard-add-entity .employees-summary .summary-row strong {\n  color: #1E293B;\n}\n\n.wizard-add-entity .employees-summary .summary-row .negative {\n  color: #DC2626;\n}\n\n.wizard-add-entity .employees-summary .summary-row.total {\n  border-top: 1px solid #E2E8F0;\n  padding-top: 10px;\n  margin-top: 4px;\n}\n\n.wizard-add-entity .employees-summary .summary-row.total strong {\n  color: #D97706;\n  font-size: 15px;\n}\n\n/* Advanced options grid */\n.wizard-add-entity .advanced-options-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-entity .advanced-options-grid .option-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .advanced-options-grid .option-toggle:hover {\n  background: #F1F5F9;\n}\n\n.wizard-add-entity .advanced-options-grid .option-toggle input {\n  margin-top: 2px;\n}\n\n.wizard-add-entity .option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wizard-add-entity .option-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1E293B;\n}\n\n.wizard-add-entity .option-desc {\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* CIR amount input */\n.wizard-add-entity .cir-amount-input {\n  margin-left: 26px;\n  padding: 12px;\n  background: #FEF3C7;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.wizard-add-entity .cir-amount-input label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.wizard-add-entity .cir-amount-input .input-suffix-wrapper {\n  max-width: 150px;\n}\n\n.wizard-add-entity .cir-calc {\n  font-size: 13px;\n  font-weight: 600;\n  color: #10B981;\n}\n\n/* Dividend input row (mode détaillé) */\n.wizard-add-entity .dividend-input-row {\n  max-width: 250px;\n}\n\n/* Info banner */\n.wizard-add-entity .info-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 16px;\n  background: #EFF6FF;\n  border: 1px solid #BFDBFE;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .info-banner .info-icon {\n  font-size: 14px;\n}\n\n/* Entity Summary Bar */\n.wizard-add-entity .entity-summary-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .legal-badge {\n  padding: 4px 10px;\n  background: #F59E0B;\n  color: white;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .entity-summary-bar .entity-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .tax-badge {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .tax-badge.is {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-entity .tax-badge.ir {\n  background: #10B981;\n  color: white;\n}\n\n.wizard-add-entity .manager-badge {\n  padding: 3px 8px;\n  background: #E0E7FF;\n  color: #4338CA;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* Manager Type Tag */\n.wizard-add-entity .manager-type-tag {\n  margin-left: 8px;\n  padding: 2px 8px;\n  background: #E0E7FF;\n  color: #4338CA;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* Manager Remuneration Grid */\n.wizard-add-entity .manager-remu-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: end;\n}\n\n.wizard-add-entity .manager-remu-grid > .form-group {\n  flex: 1;\n  min-width: 120px;\n  max-width: 180px;\n}\n\n.wizard-add-entity .manager-remu-grid > .months-group {\n  flex: 0 0 70px;\n  min-width: 60px;\n}\n\n.wizard-add-entity .months-group select {\n  width: 100%;\n  padding: 8px 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.wizard-add-entity .manager-calc-result {\n  background: #F8FAFC;\n  border-radius: 8px;\n  padding: 12px 16px;\n  flex: 0 0 auto;\n  min-width: 170px;\n}\n\n.wizard-add-entity .calc-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 0;\n  font-size: 12px;\n}\n\n.wizard-add-entity .calc-row span {\n  color: #64748B;\n}\n\n.wizard-add-entity .calc-row strong {\n  color: #1E293B;\n}\n\n.wizard-add-entity .calc-row .negative {\n  color: #DC2626;\n}\n\n.wizard-add-entity .calc-row.total {\n  border-top: 1px solid #E2E8F0;\n  margin-top: 4px;\n  padding-top: 8px;\n}\n\n.wizard-add-entity .calc-row.total strong {\n  color: #D97706;\n  font-size: 14px;\n}\n\n/* Section Header with Toggle */\n.wizard-add-entity .section-header-with-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .section-header-with-toggle h4 {\n  margin: 0;\n}\n\n.wizard-add-entity .mode-toggle {\n  display: flex;\n  background: #F1F5F9;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .mode-toggle button {\n  padding: 6px 14px;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .mode-toggle button.active {\n  background: white;\n  color: #D97706;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n/* Simplified Charges */\n.wizard-add-entity .simplified-charges {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wizard-add-entity .charge-mode-selector {\n  display: flex;\n  gap: 16px;\n}\n\n.wizard-add-entity .charge-mode-selector label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #475569;\n  cursor: pointer;\n}\n\n.wizard-add-entity .simplified-input {\n  max-width: 300px;\n}\n\n/* Detailed Charges */\n.wizard-add-entity .detailed-charges {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.wizard-add-entity .charges-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wizard-add-entity .charge-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .charge-line.enabled {\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .charge-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charge-toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charge-icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .charge-label {\n  font-size: 12px;\n  color: #475569;\n}\n\n.wizard-add-entity .charge-value-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .charge-value-input select {\n  padding: 4px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n}\n\n.wizard-add-entity .charge-value-input input {\n  width: 80px;\n  padding: 4px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n/* Collapsed Section */\n.wizard-add-entity .collapsed-section {\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n}\n\n.wizard-add-entity .collapsed-section summary {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n}\n\n.wizard-add-entity .collapsed-section summary:hover {\n  color: #D97706;\n}\n\n.wizard-add-entity .advanced-options {\n  padding: 0 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-entity .option-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .option-toggle input {\n  width: 16px;\n  height: 16px;\n}\n\n.wizard-add-entity .option-toggle span {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .option-desc {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .sub-option {\n  margin-left: 24px;\n  padding: 10px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wizard-add-entity .sub-option label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.wizard-add-entity .sub-option .input-suffix-wrapper {\n  max-width: 150px;\n}\n\n.wizard-add-entity .calc-hint {\n  font-size: 11px;\n  color: #10B981;\n  font-weight: 500;\n}\n\n/* Advanced Options Inline */\n.wizard-add-entity .advanced-options-inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  margin-top: 0;\n}\n\n.wizard-add-entity .advanced-options-inline label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-add-entity .cir-inline-input {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-add-entity .cir-inline-input label {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.wizard-add-entity .cir-inline-input .input-suffix-wrapper {\n  max-width: 120px;\n}\n\n/* Dividend Input */\n.wizard-add-entity .dividend-input {\n  max-width: 250px;\n}\n\n/* ===================== CA STEP ===================== */\n\n.wizard-add-entity .ca-step {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wizard-add-entity .source-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.wizard-add-entity .add-source-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: white;\n  border: 2px dashed #CBD5E1;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .add-source-btn:hover {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.wizard-add-entity .add-source-btn .btn-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: white;\n}\n\n/* Sources List */\n.wizard-add-entity .sources-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-entity .empty-sources {\n  padding: 40px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 14px;\n}\n\n.wizard-add-entity .source-card {\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .source-card.expanded {\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .source-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.wizard-add-entity .source-header:hover {\n  background: #FAFAFA;\n}\n\n.wizard-add-entity .source-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: white;\n}\n\n.wizard-add-entity .source-type {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  min-width: 100px;\n}\n\n.wizard-add-entity .source-label {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  font-size: 12px;\n  background: transparent;\n}\n\n.wizard-add-entity .source-label:hover,\n.wizard-add-entity .source-label:focus {\n  border-color: #E2E8F0;\n  background: white;\n  outline: none;\n}\n\n.wizard-add-entity .source-date {\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  width: 130px;\n}\n\n.wizard-add-entity .date-sep {\n  color: #94A3B8;\n  font-size: 12px;\n}\n\n.wizard-add-entity .expand-icon {\n  font-size: 10px;\n  color: #94A3B8;\n  padding: 0 6px;\n}\n\n.wizard-add-entity .remove-btn {\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: none;\n  font-size: 16px;\n  color: #94A3B8;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.wizard-add-entity .remove-btn:hover {\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n/* Exercices Table */\n.wizard-add-entity .exercices-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0;\n}\n\n.wizard-add-entity .exercices-table thead {\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .exercices-table th {\n  padding: 10px 12px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  text-align: left;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .exercices-table td {\n  padding: 10px 12px;\n  font-size: 12px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .exercices-table td strong {\n  color: #1E293B;\n}\n\n.wizard-add-entity .exercices-table .periode {\n  color: #64748B;\n  font-size: 11px;\n}\n\n.wizard-add-entity .ca-input {\n  display: flex;\n  align-items: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n}\n\n.wizard-add-entity .ca-input input {\n  flex: 1;\n  padding: 6px 10px;\n  border: none;\n  font-size: 13px;\n  text-align: right;\n  width: 100px;\n}\n\n.wizard-add-entity .ca-input input:focus {\n  outline: none;\n}\n\n.wizard-add-entity .ca-input span {\n  padding: 6px 10px;\n  background: #F8FAFC;\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* ===================== SUMMARY STEP ===================== */\n\n.wizard-add-entity .summary-step {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wizard-add-entity .summary-header {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .entity-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.wizard-add-entity .entity-info h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-entity .badge {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .badge.legal {\n  background: #F59E0B;\n  color: white;\n}\n\n.wizard-add-entity .badge.tax.is {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-entity .badge.tax.ir {\n  background: #10B981;\n  color: white;\n}\n\n.wizard-add-entity .entity-details {\n  font-size: 12px;\n  color: #64748B;\n}\n\n/* Exercices Grid */\n.wizard-add-entity .exercices-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.wizard-add-entity .exercice-card {\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .exercice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n}\n\n.wizard-add-entity .ex-label {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .ex-dates {\n  font-size: 10px;\n  opacity: 0.9;\n}\n\n.wizard-add-entity .year-badge {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 6px;\n}\n\n.wizard-add-entity .year-badge.first {\n  background: rgba(255,255,255,0.3);\n  color: white;\n}\n\n.wizard-add-entity .year-badge.second {\n  background: rgba(255,255,255,0.2);\n  color: rgba(255,255,255,0.9);\n}\n\n/* Tags d'exonération */\n.wizard-add-entity .tag-exo {\n  display: inline-block;\n  padding: 1px 5px;\n  margin-left: 6px;\n  background: #DCFCE7;\n  color: #16A34A;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .tag-reduc {\n  display: inline-block;\n  padding: 1px 5px;\n  margin-left: 6px;\n  background: #FEF3C7;\n  color: #D97706;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .exercice-body {\n  padding: 12px 14px;\n}\n\n.wizard-add-entity .pl-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 0;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.wizard-add-entity .pl-row.indent {\n  padding-left: 12px;\n  font-size: 11px;\n}\n\n.wizard-add-entity .pl-row .neg {\n  color: #DC2626;\n}\n\n.wizard-add-entity .pl-row.sub-total {\n  border-top: 1px dashed #E2E8F0;\n  padding-top: 6px;\n  margin-top: 4px;\n}\n\n.wizard-add-entity .pl-row.total {\n  border-top: 1px solid #E2E8F0;\n  padding-top: 8px;\n  margin-top: 6px;\n}\n\n.wizard-add-entity .pl-row.total strong {\n  font-size: 14px;\n  color: #D97706;\n}\n\n.wizard-add-entity .exercice-footer {\n  padding: 8px 14px;\n  background: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .empty-summary {\n  padding: 40px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n/* Summary Sections */\n.wizard-add-entity .summary-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .summary-section h4 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #F1F5F9;\n  padding-bottom: 8px;\n}\n\n.wizard-add-entity .summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.wizard-add-entity .summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wizard-add-entity .summary-item.wide {\n  grid-column: span 2;\n}\n\n.wizard-add-entity .summary-label {\n  font-size: 11px;\n  color: #94A3B8;\n  font-weight: 500;\n}\n\n.wizard-add-entity .summary-value {\n  font-size: 14px;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .summary-value.highlight {\n  color: #059669;\n  font-size: 16px;\n}\n\n.wizard-add-entity .summary-value.negative {\n  color: #DC2626;\n}\n\n.wizard-add-entity .summary-value.total {\n  color: #D97706;\n  font-size: 16px;\n}\n\n/* Manager badge in summary */\n.wizard-add-entity .badge.manager {\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 700;\n  border-radius: 4px;\n}\n\n.wizard-add-entity .badge.manager.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .badge.manager.as {\n  background: #D1FAE5;\n  color: #047857;\n}\n\n.wizard-add-entity .badge.manager.none {\n  background: #F1F5F9;\n  color: #94A3B8;\n}\n\n/* Mode badge */\n.wizard-add-entity .badge.mode {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .badge.mode.simplified {\n  background: #E0E7FF;\n  color: #4338CA;\n}\n\n.wizard-add-entity .badge.mode.detailed {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n/* Option badge */\n.wizard-add-entity .badge.option {\n  padding: 4px 10px;\n  background: #ECFDF5;\n  color: #059669;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.wizard-add-entity .summary-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* Sources summary list */\n.wizard-add-entity .sources-summary-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-add-entity .source-summary-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n}\n\n.wizard-add-entity .source-summary-item .source-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .source-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wizard-add-entity .source-info strong {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .source-dates {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .source-exercices {\n  font-size: 10px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .no-sources-warning {\n  padding: 16px;\n  background: #FEF3C7;\n  border-radius: 8px;\n  color: #D97706;\n  font-size: 12px;\n  text-align: center;\n}\n\n/* Exercices preview section */\n.wizard-add-entity .summary-section.exercices-preview h4 {\n  color: #D97706;\n}\n\n/* Summary action button */\n.wizard-add-entity .summary-action {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.wizard-add-entity .create-entity-btn {\n  padding: 14px 40px;\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.wizard-add-entity .create-entity-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n.wizard-add-entity .create-entity-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* ===================== WIZARD FOOTER ===================== */\n\n.wizard-add-entity .wizard-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n  background: white;\n  border-top: 1px solid #E2E8F0;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .nav-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  background: #F1F5F9;\n  color: #64748B;\n}\n\n.wizard-add-entity .nav-btn:hover:not(:disabled) {\n  background: #E2E8F0;\n}\n\n.wizard-add-entity .nav-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.wizard-add-entity .nav-btn.primary {\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n}\n\n.wizard-add-entity .nav-btn.primary:hover:not(:disabled) {\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);\n  transform: translateY(-1px);\n}\n\n.wizard-add-entity .step-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .step-warning {\n  font-size: 11px;\n  color: #D97706;\n  background: #FEF3C7;\n  padding: 4px 12px;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.wizard-add-entity .step-dots {\n  display: flex;\n  gap: 6px;\n}\n\n.wizard-add-entity .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #E2E8F0;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .dot.active {\n  background: #F59E0B;\n  transform: scale(1.3);\n}\n\n.wizard-add-entity .dot.done {\n  background: #10B981;\n}\n\n/* ===================== RESPONSIVE ===================== */\n\n@media (max-width: 900px) {\n  .wizard-add-entity .form-row-flex {\n    flex-direction: column;\n  }\n\n  .wizard-add-entity .manager-remu-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wizard-add-entity .exercices-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .wizard-add-entity .entity-topbar {\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 12px;\n  }\n\n  .wizard-add-entity .steps-indicator {\n    order: -1;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .wizard-add-entity .source-header {\n    flex-wrap: wrap;\n  }\n\n  .wizard-add-entity .source-date {\n    width: 100%;\n  }\n\n  .wizard-add-entity .legal-form-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ===================== ADDITIONAL STYLES FOR WIZARD ===================== */\n\n/* Field hint */\n.wizard-add-entity .field-hint {\n  display: block;\n  font-size: 11px;\n  color: #94A3B8;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n/* Source button with description */\n.wizard-add-entity .add-source-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n}\n\n.wizard-add-entity .add-source-btn .btn-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.wizard-add-entity .add-source-btn .btn-content strong {\n  font-size: 13px;\n}\n\n.wizard-add-entity .add-source-btn .btn-content small {\n  font-size: 10px;\n  color: #94A3B8;\n  font-weight: normal;\n}\n\n/* Charges column in table */\n.wizard-add-entity .exercices-table .charges-col {\n  text-align: right;\n}\n\n.wizard-add-entity .exercices-table .charge-value {\n  color: #DC2626;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Action column */\n.wizard-add-entity .exercices-table .action-col {\n  text-align: center;\n  width: 70px;\n}\n\n/* Detail button - gear icon */\n.wizard-add-entity .td-detail {\n  width: 40px;\n  text-align: center;\n}\n\n.wizard-add-entity .detail-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .detail-btn:hover {\n  background: #E2E8F0;\n  border-color: #CBD5E1;\n}\n\n.wizard-add-entity .detail-btn.has-detail {\n  background: #DBEAFE;\n  border-color: #3B82F6;\n  color: #2563EB;\n}\n\n/* ===================== ACRE STYLES ===================== */\n\n/* ACRE badge */\n.wizard-add-entity .acre-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  background: #DCFCE7;\n  color: #16A34A;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n/* ACRE option */\n.wizard-add-entity .acre-option {\n  margin-top: 12px;\n  padding: 10px;\n  background: #F0FDF4;\n  border-radius: 6px;\n  border: 1px solid #BBF7D0;\n}\n\n.wizard-add-entity .acre-option .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .acre-option .option-hint {\n  font-size: 11px;\n  color: #16A34A;\n  font-style: italic;\n}\n\n/* ===================== EMPLOYEES STYLES ===================== */\n\n/* Employees section */\n.wizard-add-entity .employees-toggle {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .radio-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employees-details {\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  margin-top: 8px;\n}\n\n.wizard-add-entity .employees-calc {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #E2E8F0;\n  font-size: 13px;\n}\n\n.wizard-add-entity .employees-calc strong {\n  color: #D97706;\n}\n\n/* ===================== CHARGES OBLIGATOIRES ===================== */\n\n/* Charges obligatoires */\n.wizard-add-entity .charges-obligatoires .info-tag {\n  font-size: 10px;\n  color: #94A3B8;\n  font-weight: normal;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .obligatory-charges-info {\n  background: #F1F5F9;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.wizard-add-entity .charge-info-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.wizard-add-entity .charge-info-row .charge-label {\n  flex: 1;\n  font-size: 13px;\n}\n\n.wizard-add-entity .charge-info-row .charge-value {\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .charge-info-row .charge-note {\n  font-size: 11px;\n  color: #16A34A;\n  font-style: italic;\n}\n\n/* ===================== FY CUSTOM WRAPPER ===================== */\n\n.wizard-add-entity .fy-custom-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.wizard-add-entity .fy-selected-value {\n  padding: 4px 8px;\n  background: #FEF3C7;\n  color: #D97706;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* ===================== HIGHLIGHT DYNAMIQUE ===================== */\n\n/* Titre actif (pour sections à sélection) - flèche + jaune sur le titre uniquement */\n.wizard-add-entity .title-active {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px 4px 8px;\n  background: #FEF3C7;\n  border-radius: 6px;\n  color: #D97706 !important;\n  font-weight: 700 !important;\n}\n\n.wizard-add-entity .title-active::before {\n  content: '→';\n  font-size: 16px;\n  color: #F59E0B;\n  animation: bounce-arrow 1s ease-in-out infinite;\n}\n\n/* Highlight dynamique - champ input actif (nom, date, capital) - JAUNE FORT */\n.wizard-add-entity .field-active {\n  position: relative;\n  background: #FEF3C7 !important;\n  border-radius: 8px;\n  padding: 12px;\n  margin: -12px;\n  margin-bottom: 0;\n}\n\n.wizard-add-entity .field-active::before {\n  content: '→';\n  position: absolute;\n  left: -20px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  color: #F59E0B;\n  font-weight: bold;\n  animation: bounce-arrow 1s ease-in-out infinite;\n}\n\n.wizard-add-entity .field-active label,\n.wizard-add-entity .field-active h4 {\n  color: #D97706 !important;\n  font-weight: 700 !important;\n}\n\n.wizard-add-entity .field-active input,\n.wizard-add-entity .field-active select {\n  border-color: #F59E0B !important;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.3) !important;\n  background: white !important;\n}\n\n/* Animation flèche */\n@keyframes bounce-arrow {\n  0%, 100% { transform: translateY(-50%) translateX(0); }\n  50% { transform: translateY(-50%) translateX(5px); }\n}\n\n/* Champ input rempli - JAUNE LÉGER pour montrer qu'il est rempli */\n.wizard-add-entity .field-filled {\n  position: relative;\n}\n\n.wizard-add-entity .field-filled::after {\n  content: '✓';\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  font-size: 14px;\n  color: #16A34A;\n  font-weight: bold;\n}\n\n.wizard-add-entity .field-filled label,\n.wizard-add-entity .field-filled h4 {\n  color: #92400E;\n}\n\n.wizard-add-entity .field-filled input,\n.wizard-add-entity .field-filled select {\n  background: #FEF9C3;\n  border-color: #FCD34D;\n}\n\n/* ===================== FY CUSTOM INPUT ===================== */\n\n.wizard-add-entity .fy-format-hint {\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n/* ===================== MANAGERS TABLE (Step 2) ===================== */\n\n.wizard-add-entity .managers-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .managers-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.wizard-add-entity .managers-table th {\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  text-align: left;\n  border-bottom: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .managers-table td {\n  padding: 10px;\n  border-bottom: 1px solid #F1F5F9;\n  vertical-align: middle;\n}\n\n.wizard-add-entity .managers-table .td-role {\n  min-width: 100px;\n}\n\n.wizard-add-entity .managers-table .role-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .managers-table .select-months {\n  width: 60px;\n  padding: 6px 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: center;\n}\n\n.wizard-add-entity .managers-table .input-percent {\n  width: 50px;\n  text-align: center;\n}\n\n.wizard-add-entity .managers-table .td-status {\n  min-width: 120px;\n}\n\n.wizard-add-entity .managers-table .status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .managers-table .status-badge.tns {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .managers-table .status-badge.as {\n  background: #D1FAE5;\n  color: #047857;\n}\n\n.wizard-add-entity .managers-table .td-actions {\n  width: 40px;\n  text-align: center;\n}\n\n.wizard-add-entity .btn-remove-manager {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #FEE2E2;\n  color: #DC2626;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .btn-remove-manager:hover {\n  background: #DC2626;\n  color: white;\n}\n\n.wizard-add-entity .btn-add-manager {\n  width: 100%;\n  padding: 10px;\n  margin-top: 10px;\n  border: 2px dashed #CBD5E1;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .btn-add-manager:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .btn-add-manager.modal-add {\n  margin-top: 12px;\n  width: 100%;\n  justify-content: center;\n}\n\n.wizard-add-entity .sarl-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 10px;\n  background: #EFF6FF;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .sarl-info .info-icon {\n  font-size: 14px;\n}\n\n/* Compact input suffix wrapper */\n.wizard-add-entity .input-suffix-wrapper.compact {\n  max-width: 130px;\n}\n\n.wizard-add-entity .input-suffix-wrapper.compact input {\n  padding: 6px 8px;\n  font-size: 13px;\n}\n\n.wizard-add-entity .input-suffix-wrapper.compact .suffix {\n  padding: 6px 8px;\n  font-size: 11px;\n}\n\n/* ===================== OPTIONS SECTION (Step 2) ===================== */\n\n.wizard-add-entity .options-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .options-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.wizard-add-entity .option-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n  min-width: 150px;\n}\n\n.wizard-add-entity .option-card:hover {\n  background: #F1F5F9;\n}\n\n.wizard-add-entity .option-card input[type=\"checkbox\"] {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n}\n\n.wizard-add-entity .option-card.tva-option {\n  cursor: default;\n}\n\n.wizard-add-entity .option-card .select-tva {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  margin-top: 4px;\n}\n\n/* ===================== ADVANCED OPTIONS SECTION ===================== */\n\n.wizard-add-entity .advanced-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n/* ===================== CHARGES SECTION (Step 2) ===================== */\n\n.wizard-add-entity .charges-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .charges-simplified,\n.wizard-add-entity .charges-detailed {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wizard-add-entity .charge-subsection {\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n}\n\n.wizard-add-entity .charge-subsection h5 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* ===================== EMPLOYEE PROFILES TABLE ===================== */\n\n.wizard-add-entity .employee-profiles-table {\n  margin-top: 12px;\n  overflow-x: auto;\n}\n\n.wizard-add-entity .employee-profiles-table table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .employee-profiles-table th {\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  text-align: left;\n  background: #F1F5F9;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .employee-profiles-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #F1F5F9;\n  vertical-align: middle;\n}\n\n.wizard-add-entity .employee-profiles-table .input-profile-name {\n  width: 100%;\n  min-width: 100px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .employee-profiles-table .input-date {\n  width: 110px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.wizard-add-entity .employee-profiles-table .input-headcount {\n  width: 50px;\n  padding: 6px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.wizard-add-entity .employee-profiles-table .prorata-cell {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.wizard-add-entity .employee-profiles-table .prorata-value {\n  display: inline-block;\n  padding: 4px 8px;\n  background: #EFF6FF;\n  color: #1E40AF;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.wizard-add-entity .employee-profiles-table .ongoing-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #16A34A;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employee-profiles-table .ongoing-label input {\n  width: 14px;\n  height: 14px;\n}\n\n.wizard-add-entity .employee-profiles-table .end-date-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-ongoing {\n  width: 24px;\n  height: 24px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  background: #F8FAFC;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-ongoing:hover {\n  background: #D1FAE5;\n  border-color: #16A34A;\n  color: #16A34A;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-remove-profile {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #FEE2E2;\n  color: #DC2626;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-remove-profile:hover {\n  background: #DC2626;\n  color: white;\n}\n\n.wizard-add-entity .employee-profiles-table .row-add td {\n  padding: 8px;\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-add-profile {\n  width: 100%;\n  padding: 8px;\n  border: 2px dashed #CBD5E1;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employee-profiles-table .btn-add-profile:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n/* Step hints */\n.wizard-add-entity .step-hints {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .hint-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .hint-item.hint-action {\n  background: #EFF6FF;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .hint-item.hint-warning {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .hint-icon {\n  font-size: 14px;\n}\n\n/* Exercice badge */\n.wizard-add-entity .exercice-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  margin-left: 6px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .exercice-badge.ex-1 {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.wizard-add-entity .exercice-badge.ex-2 {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .exercice-badge.ex-3 {\n  background: #E0E7FF;\n  color: #4338CA;\n}\n\n/* Highlight input for CA */\n.wizard-add-entity .highlight-input {\n  border-color: #F59E0B !important;\n  background: #FFFBEB !important;\n}\n\n.wizard-add-entity .highlight-input input {\n  background: transparent;\n}\n\n/* Needs CA row indicator */\n.wizard-add-entity .exercices-table tr.needs-ca {\n  background: #FFFBEB;\n}\n\n/* Empty hint */\n.wizard-add-entity .empty-hint {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #D97706;\n}\n\n/* Source hint */\n.wizard-add-entity .source-hint {\n  padding: 12px 14px;\n  background: #F8FAFC;\n  font-size: 12px;\n  color: #64748B;\n  font-style: italic;\n}\n\n/* ===================== SUMMARY MULTI-MANAGERS ===================== */\n\n.wizard-add-entity .summary-manager-row {\n  margin-bottom: 8px;\n}\n\n.wizard-add-entity .manager-separator {\n  border: none;\n  border-top: 1px dashed #E2E8F0;\n  margin: 12px 0;\n}\n\n.wizard-add-entity .summary-option-tag {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .summary-label .badge {\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n/* JEI tag styling */\n.wizard-add-entity .tag-jei {\n  display: inline-block;\n  padding: 1px 5px;\n  margin-left: 6px;\n  background: #E0E7FF;\n  color: #4338CA;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n/* ===================== NEW STEP 3: REVENUS (PRODUITS/CHARGES) ===================== */\n\n/* Header avec dates */\n.wizard-add-entity .ca-dates-header {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 10px 14px;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.wizard-add-entity .ca-dates-header.needs-end-date {\n  border: 2px solid #F59E0B;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .ca-dates-header .date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.wizard-add-entity .ca-dates-header .date-field.highlight {\n  position: relative;\n}\n\n.wizard-add-entity .ca-dates-header .date-field label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n}\n\n.wizard-add-entity .ca-dates-header .date-field label .required {\n  color: #F59E0B;\n  font-weight: 700;\n}\n\n.wizard-add-entity .ca-dates-header .date-field .field-hint {\n  font-size: 10px;\n  color: #D97706;\n  font-style: italic;\n}\n\n.wizard-add-entity .source-date.pulse {\n  animation: pulse-border 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-border {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }\n  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }\n}\n\n.wizard-add-entity .empty-sources.waiting {\n  background: #FFFBEB;\n  border: 1px dashed #F59E0B;\n}\n\n.wizard-add-entity .empty-sources .arrow-up {\n  font-size: 24px;\n  color: #F59E0B;\n  display: block;\n  margin-bottom: 8px;\n  animation: bounce 1s ease-in-out infinite;\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n\n.wizard-add-entity .exercices-count-badge {\n  padding: 5px 10px;\n  background: #F59E0B;\n  color: white;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: auto;\n}\n\n/* ===================== FORMAT PRODUITS / CHARGES ===================== */\n\n.wizard-add-entity .exercices-pc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-entity .exercice-pc-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\n/* Header exercice */\n.wizard-add-entity .pc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-bottom: 1px solid #F59E0B;\n}\n\n.wizard-add-entity .pc-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .pc-title strong {\n  font-size: 13px;\n  color: #92400E;\n}\n\n.wizard-add-entity .pc-periode {\n  font-size: 11px;\n  color: #B45309;\n}\n\n.wizard-add-entity .badge-year {\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .badge-year.first {\n  background: #D97706;\n  color: white;\n}\n\n.wizard-add-entity .badge-year.second {\n  background: #F59E0B;\n  color: white;\n}\n\n.wizard-add-entity .badge-opt {\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n  background: #92400E;\n  color: white;\n}\n\n.wizard-add-entity .badge-opt.jei {\n  background: #7C3AED;\n}\n\n.wizard-add-entity .view-toggle {\n  padding: 4px 10px;\n  border: 1px solid #D97706;\n  border-radius: 4px;\n  background: white;\n  color: #D97706;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .view-toggle:hover {\n  background: #D97706;\n  color: white;\n}\n\n/* Corps Produits/Charges */\n.wizard-add-entity .pc-body {\n  padding: 8px;\n}\n\n.wizard-add-entity .pc-section {\n  margin-bottom: 6px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .pc-section:last-child {\n  margin-bottom: 0;\n}\n\n.wizard-add-entity .pc-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .pc-section.produits .pc-section-header {\n  background: #F0FDF4;\n  border-color: #86EFAC;\n}\n\n.wizard-add-entity .pc-section.charges .pc-section-header {\n  background: #FEF3C7;\n  border-color: #FCD34D;\n}\n\n.wizard-add-entity .pc-section.resultat .pc-section-header {\n  background: #EFF6FF;\n  border-color: #93C5FD;\n}\n\n.wizard-add-entity .pc-section.resultat.negative .pc-section-header {\n  background: #FEF2F2;\n  border-color: #FCA5A5;\n}\n\n.wizard-add-entity .pc-icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .pc-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  flex: 1;\n}\n\n.wizard-add-entity .pc-total {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-entity .pc-total.neg {\n  color: #B45309;\n}\n\n.wizard-add-entity .pc-section.resultat.negative .pc-total {\n  color: #DC2626;\n}\n\n.wizard-add-entity .pc-settings {\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 4px;\n  background: rgba(0,0,0,0.05);\n  color: #64748B;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pc-settings:hover {\n  background: rgba(0,0,0,0.1);\n  color: #1E293B;\n}\n\n/* Détails */\n.wizard-add-entity .pc-details {\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n  background: white;\n}\n\n.wizard-add-entity .pc-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n}\n\n.wizard-add-entity .pc-line.secondary {\n  padding-left: 12px;\n}\n\n.wizard-add-entity .pc-line-label {\n  font-size: 12px;\n  color: #64748B;\n  flex: 1;\n}\n\n.wizard-add-entity .pc-line-label-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  color: #64748B;\n  padding: 2px 4px;\n  margin: -2px -4px;\n}\n\n.wizard-add-entity .pc-line-label-input:focus {\n  outline: none;\n  background: #F8FAFC;\n  border-radius: 3px;\n}\n\n.wizard-add-entity .pc-line-input {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  padding: 3px 6px;\n}\n\n.wizard-add-entity .pc-line-input input {\n  width: 70px;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  padding: 0;\n}\n\n.wizard-add-entity .pc-line-input input:focus {\n  outline: none;\n}\n\n.wizard-add-entity .pc-line-input span {\n  font-size: 10px;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .pc-line-value {\n  font-size: 12px;\n  font-weight: 500;\n  color: #B45309;\n  min-width: 80px;\n  text-align: right;\n}\n\n.wizard-add-entity .pc-line.readonly {\n  opacity: 0.8;\n}\n\n.wizard-add-entity .pc-tag {\n  display: inline-block;\n  padding: 1px 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .pc-tag.exo {\n  background: #D1FAE5;\n  color: #059669;\n}\n\n.wizard-add-entity .pc-tag.reduc {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .pc-remove {\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 3px;\n  background: #FEE2E2;\n  color: #DC2626;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pc-remove:hover {\n  background: #FECACA;\n}\n\n.wizard-add-entity .pc-add-btn {\n  display: block;\n  width: 100%;\n  padding: 5px;\n  margin-top: 4px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 4px;\n  background: transparent;\n  color: #64748B;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pc-add-btn:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n/* Input inline en mode simplifié */\n.wizard-add-entity .pc-inline-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n}\n\n.wizard-add-entity .pc-inline-input input {\n  width: 100px;\n  padding: 4px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .pc-inline-input input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .pc-inline-input span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* ===================== STEP 3 COMPACT FORMAT ===================== */\n\n/* Résumé hypothèses Step 2 */\n.wizard-add-entity .step2-summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .step2-summary .summary-label {\n  font-size: 11px;\n  color: #64748B;\n  font-weight: 600;\n}\n\n.wizard-add-entity .step2-summary .summary-item {\n  font-size: 11px;\n  color: #374151;\n}\n\n.wizard-add-entity .step2-summary .summary-item strong {\n  color: #1E293B;\n}\n\n.wizard-add-entity .step2-summary .summary-item em {\n  color: #94A3B8;\n  font-style: normal;\n  margin-left: 2px;\n}\n\n.wizard-add-entity .step2-summary .summary-tag {\n  padding: 2px 6px;\n  background: #FEF3C7;\n  color: #D97706;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .step2-summary .summary-tag.jei {\n  background: #EDE9FE;\n  color: #7C3AED;\n}\n\n.wizard-add-entity .step2-summary .summary-tag.tva {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .step2-summary .status-badge {\n  display: inline-block;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n.wizard-add-entity .step2-summary .status-badge.tns {\n  background: #FEE2E2;\n  color: #B91C1C;\n}\n\n.wizard-add-entity .step2-summary .status-badge.as {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n/* Mode toggle button */\n.wizard-add-entity .mode-toggle-btn {\n  padding: 4px 10px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  background: white;\n  color: #64748B;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .mode-toggle-btn:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n}\n\n.wizard-add-entity .mode-toggle-btn.detailed {\n  background: #FEF3C7;\n  border-color: #F59E0B;\n  color: #D97706;\n}\n\n/* Mode Selector Cards (Simplifié / Détaillé) */\n.wizard-add-entity .mode-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.wizard-add-entity .mode-selector-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n}\n\n.wizard-add-entity .mode-selector-cards {\n  display: flex;\n  gap: 6px;\n}\n\n.wizard-add-entity .mode-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 8px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n}\n\n.wizard-add-entity .mode-card:hover {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .mode-card.selected {\n  border-color: #F59E0B;\n  background: #FEF3C7;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);\n}\n\n.wizard-add-entity .mode-card-icon {\n  font-size: 16px;\n}\n\n.wizard-add-entity .mode-card-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.wizard-add-entity .mode-card.selected .mode-card-label {\n  color: #B45309;\n}\n\n/* Liste exercices compacte - grid layout horizontal */\n.wizard-add-entity .exercices-compact-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  align-items: start;\n}\n\n/* Responsive: 2 columns on medium screens, 1 on small */\n@media (max-width: 1200px) {\n  .wizard-add-entity .exercices-compact-list {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .wizard-add-entity .exercices-compact-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n.wizard-add-entity .exercice-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n  overflow: hidden;\n}\n\n.wizard-add-entity .exercice-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-bottom: 1px solid #F59E0B;\n}\n\n.wizard-add-entity .exercice-header strong {\n  font-size: 13px;\n  color: #92400E;\n}\n\n.wizard-add-entity .exercice-header .periode {\n  font-size: 10px;\n  color: #B45309;\n}\n\n.wizard-add-entity .exercice-header .tag {\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .exercice-header .tag.y1 {\n  background: #D97706;\n  color: white;\n}\n\n.wizard-add-entity .exercice-header .tag.y2 {\n  background: #F59E0B;\n  color: white;\n}\n\n/* Corps exercice */\n.wizard-add-entity .exercice-body {\n  padding: 8px;\n}\n\n/* ============================================\n   SECTION ROWS - Produits, Charges, Résultat\n   ============================================ */\n\n.wizard-add-entity .section-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 450px;\n  padding: 7px 14px;\n  border-radius: 5px;\n  margin-bottom: 3px;\n}\n\n/* PRODUITS - Vert pâle (entrées +) */\n.wizard-add-entity .section-row.produits {\n  background: #ECFDF5;\n  border: 1px solid #A7F3D0;\n}\n\n.wizard-add-entity .section-row.produits .section-label {\n  color: #065F46;\n}\n\n.wizard-add-entity .section-row.produits .section-value {\n  color: #059669;\n}\n\n/* CHARGES - Rose pâle (sorties -) */\n.wizard-add-entity .section-row.charges {\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  margin-top: 6px;\n}\n\n.wizard-add-entity .section-row.charges .section-label {\n  color: #991B1B;\n}\n\n.wizard-add-entity .section-row.charges .section-value {\n  color: #DC2626;\n}\n\n.wizard-add-entity .section-row.charges.clickable {\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.wizard-add-entity .section-row.charges.clickable:hover {\n  background: #FEE2E2;\n  border-color: #F87171;\n}\n\n.wizard-add-entity .section-row.charges .expand-hint {\n  font-size: 10px;\n  font-weight: 400;\n  color: #9CA3AF;\n  margin-left: 8px;\n}\n\n/* RÉSULTAT AVANT IS - Gris neutre */\n.wizard-add-entity .section-row.resultat-avant-is {\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  margin-top: 6px;\n}\n\n/* IS - Ambre pâle (seul jaune = taxe) */\n.wizard-add-entity .section-row.is-row {\n  background: #FEF9C3;\n  border: 1px solid #FDE047;\n  padding: 8px 12px;\n}\n\n.wizard-add-entity .section-row.is-row .is-rate {\n  font-size: 10px;\n  color: #A16207;\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.wizard-add-entity .section-row.is-row .section-value {\n  color: #A16207;\n}\n\n/* RÉSULTAT NET - Fort contraste */\n.wizard-add-entity .section-row.resultat {\n  margin-top: 6px;\n}\n\n.wizard-add-entity .section-row.resultat.pos {\n  background: #D1FAE5;\n  border: 2px solid #059669;\n}\n\n.wizard-add-entity .section-row.resultat.pos .section-value {\n  color: #059669;\n}\n\n.wizard-add-entity .section-row.resultat.neg {\n  background: #FEE2E2;\n  border: 2px solid #DC2626;\n}\n\n.wizard-add-entity .section-row.resultat.neg .section-value {\n  color: #DC2626;\n}\n\n/* ============================================\n   SECTION LABELS & VALUES\n   ============================================ */\n\n.wizard-add-entity .section-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .section-label .icon {\n  width: 16px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 14px;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .section-label .pcg-num {\n  display: inline-block;\n  min-width: 24px;\n  text-align: right;\n  font-family: 'SF Mono', Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .section-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1E293B;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.wizard-add-entity .section-value.neg {\n  color: #DC2626;\n}\n\n.wizard-add-entity .section-value.pos {\n  color: #059669;\n}\n\n/* ============================================\n   LINE ROWS - Sous-lignes détail\n   ============================================ */\n\n.wizard-add-entity .line-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 430px;\n  padding: 5px 14px 5px 20px;\n  background: #FAFAFA;\n  border-left: 3px solid transparent;\n  margin-left: 20px;\n  margin-bottom: 2px;\n  border-radius: 4px;\n}\n\n.wizard-add-entity .line-row.ca {\n  border-left-color: #10B981;\n  background: #F0FDF4;\n}\n\n.wizard-add-entity .line-row.charge-line {\n  border-left-color: #F87171;\n  background: #FEF2F2;\n}\n\n.wizard-add-entity .line-row.sub {\n  padding-left: 36px;\n}\n\n.wizard-add-entity .line-row.readonly {\n  opacity: 0.7;\n}\n\n.wizard-add-entity .line-label {\n  font-size: 13px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .line-label .pcg-num {\n  display: inline-block;\n  min-width: 36px;\n  text-align: right;\n  font-family: 'SF Mono', Monaco, Consolas, monospace;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6B7280;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .line-label .label-input {\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: 13px;\n  color: #374151;\n  padding: 3px 6px;\n  width: 140px;\n  border-radius: 4px;\n}\n\n.wizard-add-entity .line-label .label-input:hover {\n  border-color: #E2E8F0;\n  background: white;\n}\n\n.wizard-add-entity .line-label .label-input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  background: white;\n}\n\n.wizard-add-entity .line-label .mini-tag {\n  padding: 2px 5px;\n  background: #D1FAE5;\n  color: #047857;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.wizard-add-entity .line-label .mini-tag.exo {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .line-label .mini-tag.reduc {\n  background: #FEF3C7;\n  color: #B45309;\n}\n\n.wizard-add-entity .line-label .mini-tag.cvae {\n  background: #EDE9FE;\n  color: #6D28D9;\n}\n\n.wizard-add-entity .line-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .line-input input {\n  width: 80px;\n  padding: 5px 8px;\n  border: 1px solid #D1D5DB;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n  background: white;\n}\n\n.wizard-add-entity .line-input input:hover {\n  border-color: #9CA3AF;\n}\n\n.wizard-add-entity .line-input input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-entity .line-input span {\n  font-size: 12px;\n  color: #6B7280;\n  font-weight: 500;\n}\n\n.wizard-add-entity .line-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.wizard-add-entity .line-value.neg {\n  color: #DC2626;\n}\n\n/* Line value with button (charge lines) */\n.wizard-add-entity .line-value-with-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .line-value-with-btn .neg {\n  font-size: 13px;\n  font-weight: 600;\n  color: #DC2626;\n}\n\n/* Mini buttons */\n.wizard-add-entity .mini-btn {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  background: white;\n  color: #6B7280;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .mini-btn:hover {\n  background: #F1F5F9;\n  border-color: #CBD5E1;\n}\n\n.wizard-add-entity .mini-btn.info {\n  color: #3B82F6;\n  border-color: #BFDBFE;\n}\n\n.wizard-add-entity .mini-btn.info:hover {\n  background: #EFF6FF;\n  border-color: #3B82F6;\n}\n\n.wizard-add-entity .mini-btn.del {\n  background: #FEF2F2;\n  border-color: #FECACA;\n  color: #DC2626;\n}\n\n.wizard-add-entity .mini-btn.del:hover {\n  background: #FEE2E2;\n  border-color: #F87171;\n}\n\n.wizard-add-entity .mini-btn.config {\n  margin-left: 4px;\n}\n\n/* Add row */\n.wizard-add-entity .add-row {\n  display: flex;\n  gap: 6px;\n  padding: 4px 8px 4px 20px;\n}\n\n.wizard-add-entity .add-row.bottom {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 0 0 8px 8px;\n  border-top: 1px dashed #E2E8F0;\n  justify-content: center;\n}\n\n.wizard-add-entity .add-row button {\n  padding: 2px 8px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 3px;\n  background: transparent;\n  color: #64748B;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .add-row button:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n/* PCG Number - Default badge style (for tables, modals etc.)\n   Note: section-label and line-label have their own pcg-num styles\n   defined earlier for proper vertical alignment in exercice cards */\n.wizard-add-entity .pcg-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 16px;\n  padding: 0 4px;\n  background: #E0E7FF;\n  color: #4338CA;\n  font-size: 9px;\n  font-weight: 700;\n  border-radius: 3px;\n  margin-right: 4px;\n}\n\n/* Charge line clickable */\n.wizard-add-entity .line-row.charge-line {\n  background: transparent;\n  border-radius: 3px;\n  transition: background 0.15s;\n}\n\n.wizard-add-entity .line-row.charge-line.clickable {\n  cursor: pointer;\n}\n\n.wizard-add-entity .line-row.charge-line.clickable:hover {\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .line-row.charge-line .line-label {\n  font-size: 11px;\n  color: #374151;\n}\n\n.wizard-add-entity .line-row.charge-line .line-value {\n  font-size: 11px;\n  font-weight: 600;\n  color: #B45309;\n}\n\n/* Mini tags for CFE */\n.wizard-add-entity .mini-tag {\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 8px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.wizard-add-entity .mini-tag.exo {\n  background: #D1FAE5;\n  color: #059669;\n}\n\n.wizard-add-entity .mini-tag.reduc {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .mini-tag.jei {\n  background: #DBEAFE;\n  color: #2563EB;\n}\n\n.wizard-add-entity .mini-tag.cvae {\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n/* ===================== CHARGE DETAIL MODALS ===================== */\n\n.wizard-add-entity .charges-var-modal.wide {\n  max-width: 720px;\n}\n\n/* ============================== */\n/* MODAL - MODE TOGGLE            */\n/* ============================== */\n\n.wizard-add-entity .mode-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .mode-toggle-row .mode-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-entity .mode-toggle {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  background: #F1F5F9;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .mode-toggle button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  background: transparent;\n  color: #64748B;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .mode-toggle button.active {\n  background: white;\n  color: #1E293B;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n/* ============================== */\n/* SIMPLE GRID (Simplifié)        */\n/* ============================== */\n\n.wizard-add-entity .simple-grid {\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .simple-grid .grid-row {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 16px;\n  padding: 12px 16px;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.wizard-add-entity .simple-grid .grid-row:not(.header):hover {\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .simple-grid .grid-row.header {\n  background: #F8FAFC;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  padding: 8px 16px;\n  cursor: default;\n}\n\n.wizard-add-entity .simple-grid .grid-row.selected {\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .simple-grid .grid-row + .grid-row {\n  border-top: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .simple-grid .col-type {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #334155;\n}\n\n.wizard-add-entity .simple-grid .col-type input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #F59E0B;\n}\n\n.wizard-add-entity .simple-grid .col-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .simple-grid .col-value input {\n  width: 100px;\n  padding: 8px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .simple-grid .col-value input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .simple-grid .col-value input:disabled {\n  background: #F8FAFC;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .simple-grid .col-value .unit {\n  font-size: 12px;\n  color: #64748B;\n  min-width: 35px;\n}\n\n/* ============================== */\n/* CHARGES TABLE (Détaillé)       */\n/* ============================== */\n\n.wizard-add-entity .charges-table {\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .charges-table .table-header {\n  display: grid;\n  grid-template-columns: 28px 1fr 70px 100px;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .charges-table .table-body {\n  /* No max-height - avoid double scrollbar */\n}\n\n.wizard-add-entity .charges-table .table-row {\n  display: grid;\n  grid-template-columns: 28px 1fr 70px 100px;\n  gap: 8px;\n  padding: 8px 12px;\n  align-items: center;\n  border-top: 1px solid #F1F5F9;\n  transition: background 0.1s;\n}\n\n.wizard-add-entity .charges-table .table-row:hover {\n  background: #FAFBFC;\n}\n\n.wizard-add-entity .charges-table .table-row.enabled {\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .charges-table .col-check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #F59E0B;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charges-table .col-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.wizard-add-entity .charges-table .col-label .icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .charges-table .col-amount input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .charges-table .col-amount input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .charges-table .col-amount input:disabled {\n  background: #F8FAFC;\n  color: #CBD5E1;\n}\n\n.wizard-add-entity .charges-table .col-type select {\n  width: 100%;\n  padding: 6px 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charges-table .col-type select:disabled {\n  background: #F8FAFC;\n  color: #CBD5E1;\n}\n\n/* ============================== */\n/* TOOLTIP COMPONENT - PORTAL     */\n/* ============================== */\n\n/* Trigger inline */\n.tooltip-trigger {\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n}\n\n/* Portal tooltip - rendu dans body */\n.tooltip-portal {\n  pointer-events: none;\n}\n\n.tooltip-content-portal {\n  background: #1E293B;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.5;\n  white-space: normal;\n  width: 220px;\n  max-width: 280px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  text-align: left;\n  animation: tooltipPortalFadeIn 0.15s ease;\n}\n\n.tooltip-content-portal::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #1E293B;\n}\n\n@keyframes tooltipPortalFadeIn {\n  from { opacity: 0; transform: translate(-50%, calc(-100% + 5px)); }\n  to { opacity: 1; transform: translate(-50%, -100%); }\n}\n\n/* Help icon simple (sans pseudo-elements) */\n.wizard-add-entity .help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  border-radius: 50%;\n  background: #E2E8F0;\n  color: #64748B;\n  font-size: 10px;\n  cursor: help;\n  margin-left: 4px;\n}\n\n.wizard-add-entity .help-icon:hover {\n  background: #F59E0B;\n  color: white;\n}\n\n/* ============================== */\n/* MODAL 63 IMPOTS - GRID STYLE   */\n/* ============================== */\n\n.wizard-add-entity .impots-table .table-header {\n  grid-template-columns: 140px 1fr 180px 90px;\n}\n\n.wizard-add-entity .impots-table .table-row.impot-row {\n  display: grid;\n  grid-template-columns: 140px 1fr 180px 90px;\n  gap: 12px;\n  padding: 12px;\n  align-items: start;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .impots-table .table-row.impot-row.disabled {\n  opacity: 0.5;\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .impots-table .table-row.impot-row.is-row {\n  background: #FEF3C7;\n  border-color: #FCD34D;\n}\n\n.wizard-add-entity .impots-table .is-amount {\n  color: #B45309;\n}\n\n.wizard-add-entity .impots-table .col-impot-label {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wizard-add-entity .impots-table .col-impot-label strong {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .impots-table .impot-subtitle {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .input-with-suffix span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .hint {\n  font-size: 9px;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .stacked-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .info-line {\n  font-size: 10px;\n  color: #64748B;\n}\n\n.wizard-add-entity .impots-table .col-impot-hypothese .not-applicable {\n  font-size: 10px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .impots-table .col-impot-calcul {\n  text-align: center;\n}\n\n.wizard-add-entity .impots-table .calcul-formula {\n  display: inline-block;\n  padding: 4px 8px;\n  background: #F1F5F9;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.wizard-add-entity .impots-table .calcul-formula.positive {\n  background: #DCFCE7;\n  color: #166534;\n}\n\n.wizard-add-entity .impots-table .calcul-formula.muted {\n  background: #F8FAFC;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .impots-table .col-impot-montant {\n  text-align: right;\n}\n\n.wizard-add-entity .impots-table .col-impot-montant strong {\n  font-size: 14px;\n  color: #1E293B;\n}\n\n/* Hypothesis inputs for CFE/CVAE */\n.wizard-add-entity .impots-table .hypothesis-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-add-entity .impots-table .input-row {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.wizard-add-entity .impots-table .input-row label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-entity .impots-table .input-row .input-with-suffix input {\n  width: 70px;\n}\n\n/* Calcul stack for multi-line formulas */\n.wizard-add-entity .impots-table .calcul-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wizard-add-entity .impots-table .calcul-note {\n  font-size: 9px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* Info line muted */\n.wizard-add-entity .impots-table .info-line.muted {\n  color: #94A3B8;\n  font-size: 9px;\n}\n\n/* Location tag in modal hint */\n.wizard-add-entity .location-tag {\n  margin-left: 8px;\n  padding: 2px 8px;\n  background: #E0F2FE;\n  color: #0369A1;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n/* Impots rules help */\n.wizard-add-entity .impot-rules-help {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .impot-rules-help .rule-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 11px;\n  color: #475569;\n}\n\n.wizard-add-entity .impot-rules-help .rule-icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .impot-rules-help .rule-item strong {\n  color: #1E293B;\n}\n\n/* Status tag with tooltip */\n.wizard-add-entity .status-tag[title] {\n  cursor: help;\n  position: relative;\n}\n\n.wizard-add-entity .status-tag[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1E293B;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 400;\n  white-space: nowrap;\n  z-index: 9999;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.wizard-add-entity .status-tag[title]:hover::before {\n  content: '';\n  position: absolute;\n  bottom: calc(100% + 2px);\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1E293B;\n  z-index: 10000;\n}\n\n/* Calculated field styling - make it visually distinct */\n.wizard-add-entity .calculated-value {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #F1F5F9;\n  padding: 6px 10px;\n  border-radius: 4px;\n  border: 1px dashed #CBD5E1;\n}\n\n.wizard-add-entity .calculated-value::before {\n  content: '=';\n  font-size: 10px;\n  color: #94A3B8;\n  font-weight: 600;\n}\n\n.wizard-add-entity .calculated-value strong {\n  color: #475569;\n}\n\n/* Col charges and cout are calculated */\n.wizard-add-entity .col-personnel-charges,\n.wizard-add-entity .col-personnel-cout,\n.wizard-add-entity .col-impot-montant {\n  position: relative;\n}\n\n.wizard-add-entity .col-personnel-charges .charges-value,\n.wizard-add-entity .col-personnel-cout strong,\n.wizard-add-entity .col-impot-montant strong {\n  background: #F8FAFC;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px dashed #E2E8F0;\n}\n\n.wizard-add-entity .col-personnel-charges .charges-value::before {\n  content: '⟵ ';\n  font-size: 9px;\n  color: #94A3B8;\n}\n\n/* Modal legend for editable vs calculated */\n.wizard-add-entity .modal-legend {\n  display: flex;\n  gap: 20px;\n  padding: 10px 14px;\n  background: #FEFCE8;\n  border: 1px solid #FEF08A;\n  border-radius: 6px;\n  margin-top: 16px;\n}\n\n.wizard-add-entity .modal-legend .legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  color: #78716C;\n}\n\n.wizard-add-entity .modal-legend .legend-input {\n  width: 40px;\n  height: 20px;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 3px;\n}\n\n.wizard-add-entity .modal-legend .legend-calc {\n  width: 40px;\n  height: 20px;\n  background: #F8FAFC;\n  border: 1px dashed #CBD5E1;\n  border-radius: 3px;\n}\n\n/* ============================== */\n/* MODAL 64 PERSONNEL - GRID STYLE*/\n/* ============================== */\n\n.wizard-add-entity .personnel-section {\n  margin-bottom: 20px;\n}\n\n.wizard-add-entity .personnel-section .section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.wizard-add-entity .personnel-section .section-header h5 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .toggle-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.wizard-add-entity .toggle-checkbox input {\n  width: 14px;\n  height: 14px;\n  accent-color: #F59E0B;\n}\n\n/* Personnel table grid */\n.wizard-add-entity .personnel-table .table-header {\n  grid-template-columns: 1fr 70px 110px 50px 110px 90px 36px;\n}\n\n.wizard-add-entity .personnel-table .table-row.personnel-row {\n  display: grid;\n  grid-template-columns: 1fr 70px 110px 50px 110px 90px 36px;\n  gap: 8px;\n  padding: 10px 12px;\n  align-items: center;\n  border-top: 1px solid #F1F5F9;\n}\n\n/* ===================== MANAGERS GRID - Professional Layout ===================== */\n\n/* Managers grid container - fit content, don't stretch */\n.wizard-add-entity .managers-grid {\n  display: inline-block;\n  min-width: 650px;\n  max-width: 800px;\n}\n\n/* Managers grid - without SARL parts column (7 cols + actions) */\n/* Fonction | Statut | Brut mensuel | Mois | Début rémuné | Charges | Coût annuel | Actions */\n.wizard-add-entity .managers-grid .table-header {\n  display: grid;\n  grid-template-columns: 85px 48px 100px 50px 90px 90px 85px 26px;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.wizard-add-entity .managers-grid .table-row.personnel-row {\n  display: grid;\n  grid-template-columns: 85px 48px 100px 50px 90px 90px 85px 26px;\n  gap: 8px;\n  padding: 10px 12px;\n  align-items: center;\n  border-top: 1px solid #F1F5F9;\n}\n\n/* Managers grid - with SARL parts column (8 cols + actions) */\n/* Fonction | Statut | Brut mensuel | Mois | Début rémuné | % parts | Charges | Coût annuel | Actions */\n.wizard-add-entity .managers-grid.with-parts .table-header {\n  grid-template-columns: 75px 46px 85px 44px 85px 52px 78px 78px 24px;\n}\n\n.wizard-add-entity .managers-grid.with-parts .table-row.personnel-row {\n  grid-template-columns: 75px 46px 85px 44px 85px 52px 78px 78px 24px;\n}\n\n/* Managers grid - Add button row */\n.wizard-add-entity .managers-grid .table-row.add-row {\n  display: block;\n  padding: 6px 12px 8px;\n  border-top: 1px dashed #E2E8F0;\n  background: transparent;\n}\n\n.wizard-add-entity .managers-grid .add-cell {\n  text-align: left;\n}\n\n.wizard-add-entity .managers-grid .btn-add-manager {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 12px;\n  margin: 0;\n  width: auto;\n  border: 1px dashed #CBD5E1;\n  border-radius: 4px;\n  background: transparent;\n  font-size: 12px;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .managers-grid .btn-add-manager:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .managers-grid .btn-add-manager::before {\n  content: '+';\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Managers grid - Column styling */\n.wizard-add-entity .managers-grid .col-personnel-role {\n  display: flex;\n  align-items: center;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-role .role-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-status {\n  display: flex;\n  justify-content: center;\n}\n\n.wizard-add-entity .managers-grid .status-tag {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.wizard-add-entity .managers-grid .status-tag.tns {\n  background: #FEF3C7;\n  color: #B45309;\n}\n\n.wizard-add-entity .managers-grid .status-tag.as {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-brut .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-brut input {\n  width: 70px;\n  padding: 5px 6px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-brut input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.wizard-add-entity .managers-grid .col-personnel-brut span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-months {\n  display: flex;\n  justify-content: center;\n}\n\n.wizard-add-entity .managers-grid .select-months {\n  width: 48px;\n  padding: 5px 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: center;\n  background: white;\n  cursor: pointer;\n}\n\n.wizard-add-entity .managers-grid .select-months:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-salary-start {\n  display: flex;\n  justify-content: center;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-salary-start input {\n  width: 100%;\n  max-width: 85px;\n  padding: 5px 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-salary-start input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.wizard-add-entity .managers-grid .col-personnel-salary-start input.locked,\n.wizard-add-entity .managers-grid .col-personnel-salary-start input:disabled {\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: not-allowed;\n  border-color: #CBD5E1;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-parts {\n  display: flex;\n  justify-content: center;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-parts .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-parts input {\n  width: 36px;\n  padding: 5px 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-parts input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-parts span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-charges {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n}\n\n.wizard-add-entity .managers-grid .charges-value {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #DC2626;\n  font-weight: 500;\n}\n\n.wizard-add-entity .managers-grid .charges-rate {\n  font-size: 9px;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .managers-grid .non-remunere {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .managers-grid .tag-reduction {\n  display: inline-block;\n  padding: 1px 4px;\n  background: #DCFCE7;\n  color: #166534;\n  font-size: 8px;\n  font-weight: 600;\n  border-radius: 2px;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-cout {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-cout strong {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .managers-grid .col-personnel-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.wizard-add-entity .managers-grid .btn-remove {\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 4px;\n  background: #FEE2E2;\n  color: #DC2626;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .managers-grid .btn-remove:hover {\n  background: #FECACA;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-parts {\n  text-align: center;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-parts .input-with-suffix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-parts input {\n  width: 40px;\n  padding: 4px 6px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-parts input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-parts span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n/* ===================== EMPLOYEES GRID - Professional Layout ===================== */\n\n/* Employees grid container */\n.wizard-add-entity .employees-grid {\n  display: inline-block;\n  min-width: 620px;\n  max-width: 800px;\n}\n\n/* Employees grid - detailed mode (8 cols + actions) */\n/* Profil | Brut | Mois | Nb | Début | Fin | Charges | Coût | Actions */\n.wizard-add-entity .employees-grid .table-header {\n  display: grid;\n  grid-template-columns: minmax(90px, 140px) 90px 48px 40px 90px 90px 85px 90px 28px;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.wizard-add-entity .employees-grid .table-row.personnel-row {\n  display: grid;\n  grid-template-columns: minmax(90px, 140px) 90px 48px 40px 90px 90px 85px 90px 28px;\n  gap: 6px;\n  padding: 10px 12px;\n  align-items: center;\n  border-top: 1px solid #F1F5F9;\n}\n\n/* Employees grid - Add button row */\n.wizard-add-entity .employees-grid .table-row.add-row {\n  display: block;\n  padding: 6px 12px 8px;\n  border-top: 1px dashed #E2E8F0;\n}\n\n.wizard-add-entity .employees-grid .add-cell {\n  text-align: left;\n}\n\n.wizard-add-entity .employees-grid .btn-add-profile {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 12px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 4px;\n  background: transparent;\n  font-size: 12px;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .employees-grid .btn-add-profile:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .employees-grid .btn-add-profile::before {\n  content: '+';\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.wizard-add-entity .employees-grid .col-emp-name .input-name {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .employees-grid .col-emp-name .input-name:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .employees-grid .col-emp-brut .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .employees-grid .col-emp-brut input {\n  width: 65px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .employees-grid .col-emp-brut input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .employees-grid .col-emp-brut span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .employees-grid .col-emp-start,\n.wizard-add-entity .employees-grid .col-emp-end {\n  display: flex;\n  align-items: center;\n}\n\n.wizard-add-entity .employees-grid .input-date {\n  width: 100%;\n  padding: 5px 6px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.wizard-add-entity .employees-grid .input-date:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .employees-grid .ongoing-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employees-grid .ongoing-label input {\n  width: 14px;\n  height: 14px;\n  accent-color: #F59E0B;\n}\n\n.wizard-add-entity .employees-grid .end-date-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .employees-grid .btn-ongoing {\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .employees-grid .btn-ongoing:hover {\n  background: #F1F5F9;\n  border-color: #F59E0B;\n  color: #F59E0B;\n}\n\n.wizard-add-entity .employees-grid .col-emp-count {\n  text-align: center;\n}\n\n.wizard-add-entity .employees-grid .col-emp-prorata {\n  text-align: center;\n}\n\n.wizard-add-entity .employees-grid .prorata-value {\n  font-size: 11px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-entity .employees-grid .col-emp-charges {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.wizard-add-entity .employees-grid .col-emp-cout {\n  text-align: right;\n}\n\n.wizard-add-entity .employees-grid .col-emp-cout strong {\n  font-size: 12px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .employees-grid .col-emp-actions {\n  text-align: center;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-role .role-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-status {\n  text-align: center;\n}\n\n.wizard-add-entity .personnel-table .status-tag {\n  display: inline-block;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.wizard-add-entity .personnel-table .status-tag.tns {\n  background: #FEF3C7;\n  color: #B45309;\n}\n\n.wizard-add-entity .personnel-table .status-tag.as {\n  background: #DBEAFE;\n  color: #1D4ED8;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-brut .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-brut input {\n  width: 75px;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-brut input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.wizard-add-entity .personnel-table .col-personnel-brut span {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .personnel-table .months-input,\n.wizard-add-entity .personnel-table .count-input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.wizard-add-entity .personnel-table .months-input:focus,\n.wizard-add-entity .personnel-table .count-input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-charges {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.wizard-add-entity .personnel-table .charges-value {\n  font-size: 12px;\n  color: #DC2626;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .personnel-table .charges-rate {\n  font-size: 9px;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .personnel-table .non-remunere {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .personnel-table .tag-reduction {\n  display: inline-block;\n  padding: 1px 4px;\n  background: #DCFCE7;\n  color: #166534;\n  font-size: 8px;\n  font-weight: 600;\n  border-radius: 3px;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-cout {\n  text-align: right;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-cout strong {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-count {\n  text-align: center;\n}\n\n/* Header controls - toggle + mode buttons */\n.wizard-add-entity .personnel-section .header-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Mode toggle compact for inline use */\n.wizard-add-entity .mode-toggle.compact {\n  display: flex;\n  gap: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .mode-toggle.compact button {\n  padding: 4px 10px;\n  font-size: 10px;\n  border: none;\n  background: #F8FAFC;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.wizard-add-entity .mode-toggle.compact button:hover {\n  background: #F1F5F9;\n}\n\n.wizard-add-entity .mode-toggle.compact button.active {\n  background: #F59E0B;\n  color: white;\n  font-weight: 600;\n}\n\n/* Detailed personnel table grid */\n.wizard-add-entity .personnel-table.detailed .table-header {\n  grid-template-columns: 1fr 110px 50px 60px 100px 100px 36px;\n}\n\n.wizard-add-entity .personnel-table.detailed .table-row.personnel-row {\n  grid-template-columns: 1fr 110px 50px 60px 100px 100px 36px;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-name {\n  min-width: 0;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-name .input-name {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-name .input-name:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);\n}\n\n.wizard-add-entity .personnel-table .col-personnel-name .input-name::placeholder {\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .personnel-table .col-personnel-actions {\n  text-align: center;\n}\n\n.wizard-add-entity .personnel-table .btn-remove {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #FEE2E2;\n  color: #DC2626;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  transition: all 0.15s ease;\n}\n\n.wizard-add-entity .personnel-table .btn-remove:hover {\n  background: #FECACA;\n}\n\n.wizard-add-entity .personnel-table .empty-row {\n  display: block !important;\n  text-align: center;\n  padding: 16px 12px;\n}\n\n.wizard-add-entity .personnel-table .empty-message {\n  color: #94A3B8;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.wizard-add-entity .personnel-table .add-row {\n  display: block !important;\n  padding: 8px 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .personnel-table .add-cell {\n  text-align: center;\n}\n\n.wizard-add-entity .btn-add-employee {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border: 1px dashed #CBD5E1;\n  background: transparent;\n  color: #64748B;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.wizard-add-entity .btn-add-employee:hover {\n  border-color: #F59E0B;\n  color: #F59E0B;\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .no-data.muted {\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* ============================== */\n/* MODAL TOTAL                    */\n/* ============================== */\n\n.wizard-add-entity .modal-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #FEF2F2;\n  border-radius: 8px;\n  border: 1px solid #FECACA;\n}\n\n.wizard-add-entity .modal-total span {\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-entity .modal-total strong {\n  font-size: 15px;\n  color: #DC2626;\n}\n\n.wizard-add-entity .charges-var-modal .modal-header .pcg-badge {\n  background: linear-gradient(135deg, #6366F1, #4F46E5);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);\n}\n\n.wizard-add-entity .charge-detail-section {\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #F8FAFC;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .charge-detail-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.wizard-add-entity .charge-detail-section h5 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  margin: 0 0 12px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #E2E8F0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .charge-detail-section.muted {\n  opacity: 0.6;\n  background: #FAFBFC;\n}\n\n.wizard-add-entity .charge-detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n}\n\n.wizard-add-entity .charge-detail-table th {\n  text-align: left;\n  padding: 6px 8px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.wizard-add-entity .charge-detail-table td {\n  padding: 6px 8px;\n  border-bottom: 1px solid #F1F5F9;\n  color: #374151;\n}\n\n.wizard-add-entity .charge-detail-table td.neg {\n  color: #B45309;\n}\n\n.wizard-add-entity .charge-detail-table td.total {\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-entity .charge-detail-table td.no-data {\n  text-align: center;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .charge-summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .charge-summary-row strong {\n  color: #1E293B;\n}\n\n.wizard-add-entity p.no-data {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n  padding: 8px;\n  text-align: center;\n}\n\n/* CFE Info */\n.wizard-add-entity .cfe-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wizard-add-entity .cfe-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .cfe-row.exoneration {\n  background: #D1FAE5;\n}\n\n.wizard-add-entity .cfe-row.reduction {\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .cfe-row.total {\n  background: #E0E7FF;\n  font-weight: 600;\n}\n\n.wizard-add-entity .cfe-row strong.positive {\n  color: #059669;\n}\n\n.wizard-add-entity p.info-text {\n  font-size: 10px;\n  color: #64748B;\n  margin: 12px 0 0 0;\n  line-height: 1.4;\n}\n\n.wizard-add-entity .modal-footer .footer-hint {\n  font-size: 10px;\n  color: #94A3B8;\n}\n\n/* ===================== FORMAT PCG (Plan Comptable Général) ===================== */\n\n/* Toggle global mode */\n.wizard-add-entity .global-mode-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 12px;\n  border: 1px solid #D97706;\n  border-radius: 6px;\n  background: white;\n  color: #D97706;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  position: relative;\n}\n\n.wizard-add-entity .global-mode-toggle:hover {\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .global-mode-toggle.detailed {\n  background: #FEF3C7;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .global-mode-toggle .override-dot {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background: #F59E0B;\n  border-radius: 50%;\n  border: 2px solid white;\n}\n\n/* Liste exercices PCG */\n.wizard-add-entity .exercices-pcg-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wizard-add-entity .exercice-pcg-card {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\n/* Header exercice PCG */\n.wizard-add-entity .pcg-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-bottom: 2px solid #F59E0B;\n}\n\n.wizard-add-entity .pcg-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .pcg-title strong {\n  font-size: 14px;\n  color: #92400E;\n}\n\n.wizard-add-entity .pcg-periode {\n  font-size: 11px;\n  color: #B45309;\n  background: rgba(255,255,255,0.5);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n/* Corps PCG */\n.wizard-add-entity .pcg-body {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Classe comptable (6 ou 7) */\n.wizard-add-entity .pcg-classe {\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .pcg-classe-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .pcg-classe.produits .pcg-classe-header {\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  border-bottom: 1px solid #86EFAC;\n}\n\n.wizard-add-entity .pcg-classe.charges .pcg-classe-header {\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-bottom: 1px solid #FCD34D;\n}\n\n.wizard-add-entity .pcg-classe-num {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748B;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n\n.wizard-add-entity .pcg-classe.produits .pcg-classe-num {\n  color: #059669;\n}\n\n.wizard-add-entity .pcg-classe.charges .pcg-classe-num {\n  color: #D97706;\n}\n\n.wizard-add-entity .pcg-classe-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  flex: 1;\n}\n\n.wizard-add-entity .pcg-classe-total {\n  font-size: 14px;\n  font-weight: 700;\n  color: #059669;\n}\n\n.wizard-add-entity .pcg-classe-total.neg {\n  color: #D97706;\n}\n\n.wizard-add-entity .pcg-detail-btn {\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 6px;\n  background: rgba(255,255,255,0.7);\n  color: #64748B;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-detail-btn:hover {\n  background: white;\n  color: #1E293B;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Compte PCG (60, 61-62, 63, 64, 70...) */\n.wizard-add-entity .pcg-compte {\n  border-top: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .pcg-compte:first-of-type {\n  border-top: none;\n}\n\n.wizard-add-entity .pcg-compte-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #FAFAFA;\n}\n\n.wizard-add-entity .pcg-compte.readonly .pcg-compte-header {\n  padding: 6px 12px;\n}\n\n.wizard-add-entity .pcg-compte-num {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94A3B8;\n  background: white;\n  padding: 2px 5px;\n  border-radius: 3px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .pcg-compte-label {\n  font-size: 12px;\n  color: #64748B;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .pcg-compte-total {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-entity .pcg-compte.readonly .pcg-compte-total {\n  color: #B45309;\n}\n\n/* Tags exonération/réduction */\n.wizard-add-entity .pcg-tag {\n  display: inline-block;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .pcg-tag.exo {\n  background: #D1FAE5;\n  color: #059669;\n}\n\n.wizard-add-entity .pcg-tag.reduc {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n/* Détails compte */\n.wizard-add-entity .pcg-compte-details {\n  padding: 8px 12px;\n  background: white;\n  border-top: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .pcg-ligne {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 0;\n}\n\n.wizard-add-entity .pcg-ligne.secondaire {\n  padding-left: 16px;\n  border-left: 2px solid #E2E8F0;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .pcg-ligne-label-input {\n  flex: 1;\n  min-width: 120px;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  color: #374151;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-ligne-label-input::placeholder {\n  color: #9CA3AF;\n  font-style: italic;\n}\n\n.wizard-add-entity .pcg-ligne-label-input:hover {\n  background: #F8FAFC;\n}\n\n.wizard-add-entity .pcg-ligne-label-input:focus {\n  outline: none;\n  background: #FEF3C7;\n}\n\n.wizard-add-entity .pcg-ligne-input {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 5px;\n  padding: 4px 8px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-ligne-input:focus-within {\n  border-color: #F59E0B;\n  background: white;\n}\n\n.wizard-add-entity .pcg-ligne-input input {\n  width: 80px;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  color: #1E293B;\n}\n\n.wizard-add-entity .pcg-ligne-input input:focus {\n  outline: none;\n}\n\n.wizard-add-entity .pcg-ligne-input span {\n  font-size: 10px;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .pcg-ligne-label {\n  font-size: 12px;\n  color: #64748B;\n  flex: 1;\n}\n\n.wizard-add-entity .pcg-ligne-value {\n  font-size: 12px;\n  font-weight: 500;\n  color: #B45309;\n  min-width: 80px;\n  text-align: right;\n}\n\n.wizard-add-entity .pcg-ligne.readonly {\n  opacity: 0.85;\n}\n\n/* Boutons actions */\n.wizard-add-entity .pcg-config-btn {\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: pointer;\n  font-size: 11px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-config-btn:hover {\n  background: #E2E8F0;\n  color: #1E293B;\n}\n\n.wizard-add-entity .pcg-remove-btn {\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 4px;\n  background: #FEE2E2;\n  color: #DC2626;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-remove-btn:hover {\n  background: #FECACA;\n}\n\n.wizard-add-entity .pcg-add-btn {\n  display: block;\n  width: 100%;\n  padding: 6px;\n  margin-top: 6px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 5px;\n  background: transparent;\n  color: #64748B;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-add-btn:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n/* Mode simplifié */\n.wizard-add-entity .pcg-compte-simple {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 12px;\n  background: white;\n}\n\n.wizard-add-entity .pcg-compte-simple input {\n  flex: 1;\n  max-width: 150px;\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .pcg-compte-simple input:focus {\n  outline: none;\n  border-color: #F59E0B;\n}\n\n.wizard-add-entity .pcg-compte-simple span {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.wizard-add-entity .pcg-compte-summary {\n  padding: 6px 12px;\n  background: white;\n}\n\n.wizard-add-entity .pcg-summary-hint {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-style: italic;\n}\n\n/* Résultat */\n.wizard-add-entity .pcg-resultat {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);\n  border-radius: 8px;\n  border: 1px solid #93C5FD;\n}\n\n.wizard-add-entity .pcg-resultat.negative {\n  background: linear-gradient(135deg, #FEF2F2 0%, #FECACA 100%);\n  border-color: #FCA5A5;\n}\n\n.wizard-add-entity .pcg-resultat.positive {\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  border-color: #86EFAC;\n}\n\n.wizard-add-entity .pcg-resultat-label {\n  font-size: 16px;\n  font-weight: 700;\n  color: #64748B;\n}\n\n.wizard-add-entity .pcg-resultat-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  flex: 1;\n}\n\n.wizard-add-entity .pcg-resultat-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-entity .pcg-resultat.negative .pcg-resultat-value {\n  color: #DC2626;\n}\n\n.wizard-add-entity .pcg-resultat.positive .pcg-resultat-value {\n  color: #059669;\n}\n\n/* Grid table des exercices */\n.wizard-add-entity .exercices-grid-table {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n.wizard-add-entity .exercices-grid-table .exercices-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.wizard-add-entity .exercices-grid-table thead tr {\n  background: #F1F5F9;\n}\n\n.wizard-add-entity .exercices-grid-table th {\n  padding: 10px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  text-align: left;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .exercices-grid-table th.col-amount,\n.wizard-add-entity .exercices-grid-table th.col-charges {\n  text-align: right;\n  width: 130px;\n}\n\n.wizard-add-entity .exercices-grid-table th.col-actions {\n  width: 100px;\n  text-align: right;\n}\n\n/* Ligne exercice principale */\n.wizard-add-entity .exercice-row {\n  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .exercice-row:hover {\n  background: #E2E8F0;\n}\n\n.wizard-add-entity .exercice-row td {\n  padding: 12px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .exercice-row .expand-icon {\n  display: inline-block;\n  width: 16px;\n  font-size: 10px;\n  color: #94A3B8;\n  margin-right: 8px;\n}\n\n.wizard-add-entity .exercice-row strong {\n  font-size: 14px;\n  color: #1E293B;\n}\n\n.wizard-add-entity .exercice-row .periode-small {\n  font-size: 11px;\n  color: #94A3B8;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .exercice-row .year-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  margin-left: 8px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .year-badge.first {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.wizard-add-entity .year-badge.second {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .exercice-row .option-tag {\n  display: inline-block;\n  padding: 2px 6px;\n  margin-left: 6px;\n  border-radius: 4px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .option-tag.acre {\n  background: #D1FAE5;\n  color: #059669;\n}\n\n.wizard-add-entity .option-tag.jei {\n  background: #E0E7FF;\n  color: #4338CA;\n}\n\n.wizard-add-entity .exercice-row .col-amount {\n  text-align: right;\n}\n\n.wizard-add-entity .exercice-row .col-amount strong {\n  font-size: 13px;\n}\n\n.wizard-add-entity .exercice-row .charge-total {\n  font-size: 12px;\n  color: #DC2626;\n}\n\n.wizard-add-entity .exercice-row .col-charges {\n  text-align: right;\n}\n\n.wizard-add-entity .resultat-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .resultat-badge.positive {\n  background: #DCFCE7;\n  color: #16A34A;\n}\n\n.wizard-add-entity .resultat-badge.negative {\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n/* Sous-lignes */\n.wizard-add-entity .subrow {\n  background: white;\n}\n\n.wizard-add-entity .subrow td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.wizard-add-entity .subrow-indent {\n  display: inline-block;\n  width: 24px;\n}\n\n.wizard-add-entity .subrow-icon {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.wizard-add-entity .subrow-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.wizard-add-entity .subrow-detail {\n  font-size: 10px;\n  color: #94A3B8;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .subrow-detail.charges-var {\n  color: #DC2626;\n}\n\n.wizard-add-entity .subrow-detail .tag-exo {\n  display: inline-block;\n  padding: 1px 5px;\n  margin-left: 4px;\n  background: #D1FAE5;\n  color: #059669;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 600;\n}\n\n/* Ligne charges globales */\n.wizard-add-entity .charges-globales-row {\n  background: #FFFBEB;\n}\n\n.wizard-add-entity .charges-globales-row td {\n  border-left: 3px solid #F59E0B;\n}\n\n/* Ligne CA principal */\n.wizard-add-entity .ca-principal-row {\n  background: #EFF6FF;\n}\n\n.wizard-add-entity .ca-principal-row td {\n  border-left: 3px solid #3B82F6;\n}\n\n/* Ligne CA secondaire */\n.wizard-add-entity .ca-secondaire-row {\n  background: #FAFAFA;\n}\n\n.wizard-add-entity .ca-secondaire-row td {\n  border-left: 3px solid #94A3B8;\n}\n\n.wizard-add-entity .inline-label-input {\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  padding: 2px 4px;\n  margin: -2px -4px;\n  width: 160px;\n}\n\n.wizard-add-entity .inline-label-input:focus {\n  outline: none;\n  background: white;\n  border-radius: 4px;\n  box-shadow: 0 0 0 2px #3B82F6;\n}\n\n/* Colonnes montant/charges */\n.wizard-add-entity .subrow .col-amount {\n  text-align: right;\n}\n\n.wizard-add-entity .subrow .col-charges {\n  text-align: right;\n}\n\n.wizard-add-entity .subrow .charge-value {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.wizard-add-entity .subrow .charge-value.negative {\n  color: #DC2626;\n}\n\n/* Actions */\n.wizard-add-entity .subrow .col-actions {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.wizard-add-entity .subrow .detail-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .subrow .detail-btn:hover {\n  background: #E2E8F0;\n  color: #1E293B;\n}\n\n.wizard-add-entity .subrow .detail-btn.has-config {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.wizard-add-entity .subrow .remove-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 4px;\n  background: #FEE2E2;\n  color: #DC2626;\n  cursor: pointer;\n  font-size: 14px;\n  margin-left: 4px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .subrow .remove-btn:hover {\n  background: #FECACA;\n}\n\n/* Ligne ajouter */\n.wizard-add-entity .add-row td {\n  padding: 8px 12px 12px;\n  border-bottom: none;\n}\n\n.wizard-add-entity .add-subrow-btn {\n  display: block;\n  width: calc(100% - 24px);\n  margin-left: 24px;\n  padding: 8px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748B;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .add-subrow-btn:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n/* Charges variables modal */\n.wizard-add-entity .charges-var-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 1000;\n  padding: 40px 20px;\n  overflow-y: auto;\n  animation: fadeIn 0.2s ease;\n}\n\n.wizard-add-entity .charges-var-modal {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 600px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: modalSlideIn 0.25s ease;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 80px);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.wizard-add-entity .charges-var-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: linear-gradient(to bottom, #FAFBFC, #F8FAFC);\n  border-radius: 16px 16px 0 0;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .charges-var-modal .modal-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .charges-var-modal .modal-header .close-btn {\n  background: #F1F5F9;\n  border: none;\n  font-size: 18px;\n  color: #64748B;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.wizard-add-entity .charges-var-modal .modal-header .close-btn:hover {\n  background: #E2E8F0;\n  color: #334155;\n}\n\n.wizard-add-entity .charges-var-modal .modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.wizard-add-entity .charges-var-modal .modal-hint {\n  font-size: 13px;\n  color: #64748B;\n  margin: 0 0 20px;\n  line-height: 1.5;\n  padding: 12px 14px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  border-left: 3px solid #F59E0B;\n}\n\n.wizard-add-entity .charges-var-config {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.wizard-add-entity .config-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.wizard-add-entity .config-row label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  min-width: 60px;\n}\n\n.wizard-add-entity .config-row select {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n}\n\n.wizard-add-entity .config-row .input-with-suffix {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .config-row .input-with-suffix input {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  font-size: 14px;\n}\n\n.wizard-add-entity .config-row .input-with-suffix input:focus {\n  outline: none;\n}\n\n.wizard-add-entity .config-row .input-with-suffix span {\n  padding: 8px 12px;\n  background: #F1F5F9;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.wizard-add-entity .preview-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 12px;\n  background: #F1F5F9;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.wizard-add-entity .preview-row span {\n  color: #64748B;\n}\n\n.wizard-add-entity .preview-row strong {\n  color: #DC2626;\n}\n\n.wizard-add-entity .charges-var-modal .modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #FAFBFC;\n  border-radius: 0 0 16px 16px;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .charges-var-modal .modal-footer .footer-hint {\n  font-size: 11px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n.wizard-add-entity .charges-var-modal .btn-save {\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #F59E0B, #D97706);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);\n}\n\n.wizard-add-entity .charges-var-modal .btn-save:hover {\n  background: linear-gradient(135deg, #D97706, #B45309);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);\n}\n\n.wizard-add-entity .charges-var-modal .footer-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.wizard-add-entity .charges-var-modal .btn-cancel {\n  padding: 10px 24px;\n  background: #F1F5F9;\n  color: #475569;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-entity .charges-var-modal .btn-cancel:hover {\n  background: #E2E8F0;\n  border-color: #CBD5E1;\n}\n\n/* ===================== STEP 3 IMPROVEMENTS ===================== */\n\n/* Products add row - positioned after products, before charges */\n.wizard-add-entity .add-row.products-add {\n  padding: 4px 12px 8px;\n  margin: 0;\n  justify-content: flex-start;\n  gap: 4px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #FAFBFC;\n}\n\n.wizard-add-entity .add-row.products-add button {\n  padding: 2px 6px;\n  font-size: 9px;\n}\n\n/* Expand hint for clickable sections in simplified mode */\n.wizard-add-entity .expand-hint {\n  font-size: 9px;\n  color: #94A3B8;\n  font-weight: 400;\n  margin-left: 8px;\n  font-style: italic;\n}\n\n.wizard-add-entity .section-row.clickable {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.wizard-add-entity .section-row.clickable:hover {\n  background: #F1F5F9;\n}\n\n/* Secondary button in modals */\n.wizard-add-entity .charges-var-modal .btn-secondary {\n  padding: 8px 16px;\n  background: transparent;\n  color: #64748B;\n  border: 1px solid #CBD5E1;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-right: 10px;\n}\n\n.wizard-add-entity .charges-var-modal .btn-secondary:hover {\n  background: #F1F5F9;\n  border-color: #94A3B8;\n  color: #334155;\n}\n\n/* Modal footer with multiple buttons */\n.wizard-add-entity .charges-var-modal .modal-footer {\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Summary table in charge modal */\n.wizard-add-entity .charge-detail-table.summary {\n  width: 100%;\n  margin: 16px 0;\n}\n\n.wizard-add-entity .charge-detail-table.summary th:first-child,\n.wizard-add-entity .charge-detail-table.summary td:first-child {\n  width: 80px;\n}\n\n/* Formula column in table */\n.wizard-add-entity .charge-detail-table td.formula {\n  color: #94A3B8;\n  font-size: 11px;\n  font-style: italic;\n}\n\n/* Highlight rows */\n.wizard-add-entity .charge-detail-table tr.highlight {\n  background: #F0FDF4;\n}\n\n.wizard-add-entity .charge-detail-table tr.highlight.positive td {\n  color: #059669;\n}\n\n/* Muted section */\n.wizard-add-entity .charge-detail-section.muted {\n  opacity: 0.6;\n}\n\n.wizard-add-entity .charge-detail-section.muted h5 {\n  color: #94A3B8;\n}\n\n/* Info text */\n.wizard-add-entity .info-text {\n  font-size: 11px;\n  color: #64748B;\n  margin: 12px 0 0;\n  padding: 8px;\n  background: #F8FAFC;\n  border-radius: 4px;\n  border-left: 2px solid #CBD5E1;\n}\n\n/* Line value with button */\n.wizard-add-entity .line-value-with-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .line-value-with-btn .neg {\n  color: #DC2626;\n}\n\n.wizard-add-entity .mini-btn.info {\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 1px solid #CBD5E1;\n  border-radius: 50%;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .mini-btn.info:hover {\n  background: #F59E0B;\n  border-color: #F59E0B;\n  color: white;\n}\n\n/* Charges config row in modal */\n.wizard-add-entity .charges-config-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.wizard-add-entity .charges-config-row .config-label {\n  flex: 1;\n  font-size: 12px;\n  color: #334155;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs select {\n  padding: 4px 6px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs input {\n  width: 60px;\n  padding: 4px 6px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs .suffix {\n  font-size: 11px;\n  color: #64748B;\n  min-width: 14px;\n}\n\n.wizard-add-entity .charges-config-row .config-result {\n  font-size: 12px;\n  font-weight: 600;\n  color: #DC2626;\n  min-width: 80px;\n  text-align: right;\n}\n\n/* Charge total row */\n.wizard-add-entity .charge-total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  margin-top: 20px;\n  background: linear-gradient(135deg, #FEF2F2, #FEE2E2);\n  border-radius: 10px;\n  border: 1px solid #FECACA;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.08);\n}\n\n.wizard-add-entity .charge-total-row span {\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-entity .charge-total-row strong {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.wizard-add-entity .charge-total-row strong.neg {\n  color: #DC2626;\n}\n\n/* Reset button for overrides */\n.wizard-add-entity .reset-btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .reset-btn:hover {\n  background: #FEF2F2;\n  border-color: #FECACA;\n  color: #DC2626;\n}\n\n/* Override hint */\n.wizard-add-entity .override-hint {\n  font-size: 10px;\n  color: #94A3B8;\n  margin-top: 4px;\n  padding-left: 12px;\n  font-style: italic;\n}\n\n/* Compact table */\n.wizard-add-entity .charge-detail-table.compact {\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n\n.wizard-add-entity .charge-detail-table.compact th,\n.wizard-add-entity .charge-detail-table.compact td {\n  padding: 4px 8px;\n}\n\n/* Compact charge summary row */\n.wizard-add-entity .charge-summary-row.compact {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #F8FAFC;\n  border-radius: 4px;\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n\n.wizard-add-entity .charge-summary-row.compact strong {\n  color: #334155;\n}\n\n/* Editable override inputs */\n.wizard-add-entity .charges-config-row.editable {\n  background: #FFFBEB;\n  border: 1px solid #FCD34D;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs input.editable-override {\n  width: 100px;\n  background: white;\n  border: 2px solid #F59E0B;\n}\n\n.wizard-add-entity .charges-config-row .config-inputs input.editable-override:focus {\n  outline: none;\n  border-color: #D97706;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.wizard-add-entity .charges-config-row .config-inputs input.editable-override::placeholder {\n  color: #9CA3AF;\n  font-size: 10px;\n}\n\n/* Auto hint badge */\n.wizard-add-entity .auto-hint {\n  font-size: 9px;\n  color: #059669;\n  background: #D1FAE5;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n/* Edit hint text */\n.wizard-add-entity .edit-hint {\n  font-size: 10px;\n  color: #6B7280;\n  margin-top: 6px;\n  padding: 6px 8px;\n  background: #F9FAFB;\n  border-radius: 4px;\n  font-style: italic;\n}\n\n/* ============================== */\n/* MODAL EDITING STYLES           */\n/* ============================== */\n\n/* CFE Base Edit (Modal 63) */\n.wizard-add-entity .cfe-base-edit {\n  padding: 12px;\n  background: #FEF3C7;\n  border: 1px solid #FCD34D;\n  border-radius: 6px;\n  margin-bottom: 16px;\n}\n\n.wizard-add-entity .cfe-base-edit label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #92400E;\n  margin-bottom: 8px;\n}\n\n.wizard-add-entity .cfe-base-edit .input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .cfe-base-edit .input-row input {\n  width: 120px;\n  padding: 8px 12px;\n  border: 2px solid #F59E0B;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.wizard-add-entity .cfe-base-edit .input-row input:focus {\n  outline: none;\n  border-color: #D97706;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.wizard-add-entity .cfe-base-edit .suffix {\n  font-size: 14px;\n  color: #92400E;\n  font-weight: 500;\n}\n\n.wizard-add-entity .cfe-base-edit .field-hint {\n  font-size: 10px;\n  color: #B45309;\n  margin-top: 6px;\n}\n\n/* CFE Calculation display */\n.wizard-add-entity .cfe-calculation {\n  padding: 12px;\n  background: #F0FDF4;\n  border: 1px solid #86EFAC;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .cfe-calculation h6 {\n  font-size: 11px;\n  font-weight: 600;\n  color: #166534;\n  margin: 0 0 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Charge Lines Edit (Modal 61-62) */\n.wizard-add-entity .charge-lines-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-add-entity .charge-line-edit {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 10px;\n  background: #F8FAFC;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .charge-line-edit.enabled {\n  background: #FFFBEB;\n  border-color: #FCD34D;\n}\n\n.wizard-add-entity .charge-line-edit.disabled {\n  opacity: 0.6;\n}\n\n.wizard-add-entity .charge-line-edit .charge-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charge-line-edit .charge-toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .charge-line-edit .charge-icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .charge-line-edit .charge-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-entity .charge-line-edit .charge-value-edit {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .charge-line-edit .charge-value-edit input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: right;\n}\n\n.wizard-add-entity .charge-line-edit .charge-value-edit input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);\n}\n\n.wizard-add-entity .charge-line-edit .charge-value-edit select {\n  padding: 6px 8px;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n  cursor: pointer;\n}\n\n/* Simplified charge edit (Modal 61-62 simplified) */\n.wizard-add-entity .simplified-charge-edit {\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .simplified-charge-edit .radio-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  cursor: pointer;\n  font-size: 13px;\n  color: #334155;\n}\n\n.wizard-add-entity .simplified-charge-edit .radio-option input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n}\n\n.wizard-add-entity .simplified-charge-edit .input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0 8px 24px;\n}\n\n.wizard-add-entity .simplified-charge-edit .input-row input {\n  width: 100px;\n  padding: 8px 10px;\n  border: 2px solid #F59E0B;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: right;\n}\n\n.wizard-add-entity .simplified-charge-edit .input-row input:focus {\n  outline: none;\n  border-color: #D97706;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.wizard-add-entity .simplified-charge-edit .input-row .suffix {\n  font-size: 12px;\n  color: #64748B;\n}\n\n/* ============================== */\n/* MODAL 64 - PERSONNEL           */\n/* ============================== */\n\n/* Manager list container */\n.wizard-add-entity .managers-edit-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Manager edit card */\n.wizard-add-entity .manager-edit-row {\n  background: white;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n  overflow: hidden;\n}\n\n.wizard-add-entity .manager-edit-row .manager-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: linear-gradient(135deg, #FFFBEB, #FEF3C7);\n  border-bottom: 1px solid #FCD34D;\n}\n\n.wizard-add-entity .manager-edit-row .manager-role {\n  font-size: 13px;\n  font-weight: 600;\n  color: #92400E;\n}\n\n.wizard-add-entity .manager-edit-row .status-badge {\n  font-size: 10px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-entity .manager-edit-row .status-badge.tns {\n  background: #DBEAFE;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .manager-edit-row .status-badge.as {\n  background: #F3E8FF;\n  color: #7C3AED;\n}\n\n.wizard-add-entity .manager-edit-row .manager-inputs {\n  display: flex;\n  gap: 16px;\n  padding: 14px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .manager-edit-row .input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wizard-add-entity .manager-edit-row .input-group label {\n  font-size: 10px;\n  font-weight: 500;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-entity .manager-edit-row .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .manager-edit-row .input-with-suffix input {\n  width: 100px;\n  padding: 8px 10px;\n  border: 2px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: right;\n  transition: border-color 0.15s;\n}\n\n.wizard-add-entity .manager-edit-row .input-with-suffix input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n.wizard-add-entity .manager-edit-row .input-with-suffix span {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-entity .manager-edit-row .input-group input.small {\n  width: 60px;\n  padding: 8px 10px;\n  border: 2px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.wizard-add-entity .manager-edit-row .input-group input.small:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n.wizard-add-entity .manager-edit-row .manager-calc {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .manager-edit-row .calc-detail {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .manager-edit-row .tag-acre {\n  font-size: 9px;\n  padding: 2px 6px;\n  background: #D1FAE5;\n  color: #059669;\n  border-radius: 3px;\n  font-weight: 600;\n}\n\n.wizard-add-entity .manager-edit-row .manager-calc strong {\n  font-size: 13px;\n  color: #DC2626;\n  margin-left: auto;\n}\n\n/* ============================== */\n/* EMPLOYEES SECTION (Modal 64)   */\n/* ============================== */\n\n.wizard-add-entity .employees-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wizard-add-entity .employees-edit .checkbox-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.wizard-add-entity .employees-edit .checkbox-option:hover {\n  background: #F1F5F9;\n}\n\n.wizard-add-entity .employees-edit .checkbox-option input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.wizard-add-entity .employees-edit .checkbox-option span {\n  font-size: 13px;\n  color: #334155;\n}\n\n.wizard-add-entity .employees-edit .employees-inputs {\n  display: flex;\n  gap: 16px;\n  padding: 14px;\n  background: #EFF6FF;\n  border: 1px solid #93C5FD;\n  border-radius: 8px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .employees-edit .input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wizard-add-entity .employees-edit .input-group label {\n  font-size: 10px;\n  font-weight: 500;\n  color: #1E40AF;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-entity .employees-edit .input-with-suffix {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .employees-edit .input-with-suffix input {\n  width: 100px;\n  padding: 8px 10px;\n  border: 2px solid #93C5FD;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: right;\n  background: white;\n}\n\n.wizard-add-entity .employees-edit .input-with-suffix input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-entity .employees-edit .input-with-suffix span {\n  font-size: 12px;\n  color: #1E40AF;\n  font-weight: 500;\n}\n\n.wizard-add-entity .employees-edit .input-group input.small {\n  width: 60px;\n  padding: 8px 10px;\n  border: 2px solid #93C5FD;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-entity .employees-edit .input-group input.small:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-entity .employees-edit .employees-calc {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #DBEAFE;\n  border-radius: 6px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .employees-edit .calc-formula {\n  font-size: 11px;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .employees-edit .employees-calc strong {\n  font-size: 13px;\n  color: #1E40AF;\n  margin-left: auto;\n}\n\n/* Legacy styles - keeping for compatibility */\n.wizard-add-entity .employees-edit .field-group input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid #93C5FD;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n  background: white;\n}\n\n.wizard-add-entity .employees-edit .field-group input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.wizard-add-entity .employees-edit .field-group .suffix {\n  font-size: 11px;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .employees-edit .employees-calculated {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px dashed #93C5FD;\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .employees-edit .employees-calculated strong {\n  color: #DC2626;\n}\n\n/* Editable amount fields */\n.wizard-add-entity .editable-amount {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .editable-amount .amount-input {\n  width: 80px;\n  padding: 4px 6px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n  background: #FFF;\n}\n\n.wizard-add-entity .editable-amount .amount-input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n}\n\n.wizard-add-entity .editable-amount .amount-input:disabled {\n  background: #F1F5F9;\n  color: #94A3B8;\n}\n\n.wizard-add-entity .editable-amount .currency {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-entity .editable-amount .btn-reset {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  background: #FEF3C7;\n  color: #D97706;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-add-entity .editable-amount .btn-reset:hover {\n  background: #FDE68A;\n}\n\n.wizard-add-entity .calc-indicator {\n  display: block;\n  font-size: 9px;\n  color: #94A3B8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 2px;\n}\n\n/* CA info in CFE */\n.wizard-add-entity .impot-ca-info {\n  display: block;\n  font-size: 10px;\n  color: #666;\n  margin-top: 2px;\n}\n\n/* ===================== CHARGES SUMMARY TABLE ===================== */\n\n.wizard-add-entity .charges-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.wizard-add-entity .charges-summary-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.wizard-add-entity .charges-summary-table td:first-child {\n  color: #374151;\n}\n\n.wizard-add-entity .charges-summary-table td:last-child {\n  text-align: right;\n  font-weight: 500;\n}\n\n.wizard-add-entity .charges-summary-table td.neg {\n  color: #DC2626;\n}\n\n.wizard-add-entity .charges-summary-table .total-row td {\n  border-top: 2px solid #374151;\n  border-bottom: none;\n  padding-top: 12px;\n}\n\n/* ===================== FULLPAGE EDIT MODE - COMPACT LAYOUT ===================== */\n\n/* Make rows more compact - no space-between, use max-width */\n.wizard-add-entity.fullpage .exercice-card {\n  max-width: 600px;\n}\n\n.wizard-add-entity.fullpage .section-row,\n.wizard-add-entity.fullpage .line-row {\n  justify-content: flex-start;\n  gap: 12px;\n}\n\n.wizard-add-entity.fullpage .section-label,\n.wizard-add-entity.fullpage .line-label {\n  min-width: 140px;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity.fullpage .section-value,\n.wizard-add-entity.fullpage .line-input,\n.wizard-add-entity.fullpage .line-value-with-btn {\n  min-width: 100px;\n  text-align: right;\n}\n\n/* ===================== RESPONSIVE EDIT MODE ===================== */\n\n@media (max-width: 768px) {\n  .wizard-add-entity.fullpage {\n    left: 8px;\n    right: 8px;\n    top: 120px;\n    bottom: 8px;\n  }\n\n  .wizard-add-entity.fullpage .exercices-compact-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ===================== DIVIDEND SETTINGS INLINE (Step 1) ===================== */\n\n.wizard-add-entity .dividend-settings-inline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);\n  border: 1px solid #fcd34d;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .dividend-inline-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #92400e;\n  white-space: nowrap;\n}\n\n.wizard-add-entity .dividend-inline-fields {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-entity .dividend-inline-field {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .dividend-inline-field .field-prefix,\n.wizard-add-entity .dividend-inline-field .field-suffix {\n  font-size: 12px;\n  color: #78350f;\n}\n\n.wizard-add-entity .dividend-pct-input,\n.wizard-add-entity .dividend-delay-input {\n  width: 50px;\n  padding: 4px 6px;\n  border: 1px solid #d97706;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-entity .dividend-pct-input:focus,\n.wizard-add-entity .dividend-delay-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n}\n\n.wizard-add-entity .dividend-field .suffix {\n  padding: 6px 10px;\n  background: #fef3c7;\n  color: #92400e;\n  font-size: 12px;\n  font-weight: 500;\n  border-left: 1px solid #d97706;\n}\n\n/* ===================== DIVIDEND ROW IN EXERCICE CARD ===================== */\n\n.wizard-add-entity .dividendes-row {\n  background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);\n  border-radius: 6px;\n  margin-top: 8px;\n  padding: 8px 12px;\n}\n\n.wizard-add-entity .dividendes-row.overridden {\n  border-left: 3px solid #f59e0b;\n}\n\n.wizard-add-entity .dividendes-row .section-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .dividendes-row .icon {\n  font-size: 14px;\n}\n\n.wizard-add-entity .dividendes-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #92400e;\n}\n\n.wizard-add-entity .dividend-pct-input-inline {\n  width: 45px;\n  padding: 2px 4px;\n  border: 1px solid #d97706;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: center;\n  background: white;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .dividend-pct-suffix {\n  font-size: 11px;\n  color: #78350f;\n  margin-left: 2px;\n}\n\n.wizard-add-entity .dividend-value {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.wizard-add-entity .dividend-amount {\n  font-weight: 600;\n  color: #92400e;\n  font-size: 13px;\n}\n\n.wizard-add-entity .dividend-date {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .dividend-date-input {\n  width: 130px;\n  padding: 2px 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n}\n\n.wizard-add-entity .dividend-date-input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n.wizard-add-entity .dividend-date-default {\n  font-size: 11px;\n  color: #78350f;\n  font-style: italic;\n}\n\n/* Hide date input when default is shown */\n.wizard-add-entity .dividend-date-input[value=\"\"] {\n  width: 24px;\n  border: none;\n  background: transparent;\n}\n\n.wizard-add-entity .dividend-date-input[value=\"\"]::-webkit-calendar-picker-indicator {\n  opacity: 0.4;\n}\n\n/* ===================== AFFECTATION DU RÉSULTAT ===================== */\n\n/* Séparateur pointillé */\n.wizard-add-entity .affectation-separator {\n  border-top: 2px dashed #CBD5E1;\n  margin: 10px 0 8px 0;\n}\n\n/* Ligne Affectation - Zone de configuration */\n.wizard-add-entity .section-row.affectation-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);\n  border: 1px solid #CBD5E1;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: 6px 8px 3px 8px;\n}\n\n.wizard-add-entity .section-row.affectation-row.overridden {\n  border-left: 4px solid #3B82F6;\n}\n\n.wizard-add-entity .affectation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.wizard-add-entity .affectation-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .affectation-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.wizard-add-entity .affectation-config {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 8px 10px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .config-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-entity .config-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-entity .config-suffix {\n  font-size: 14px;\n  color: #1E293B;\n  font-weight: 700;\n}\n\n.wizard-add-entity .config-default {\n  font-size: 12px;\n  color: #64748B;\n  font-style: italic;\n}\n\n.wizard-add-entity .affectation-date-input {\n  width: 115px;\n  padding: 5px 8px;\n  border: 1px solid #D1D5DB;\n  border-radius: 5px;\n  font-size: 13px;\n  background: white;\n}\n\n.wizard-add-entity .affectation-date-input:hover {\n  border-color: #9CA3AF;\n}\n\n.wizard-add-entity .affectation-date-input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-entity .affectation-date-input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n/* Hide date input when default is shown - show only calendar icon */\n.wizard-add-entity .affectation-date-input[value=\"\"] {\n  width: 28px;\n  padding: 5px;\n  border: 1px dashed #D1D5DB;\n  background: #FAFAFA;\n}\n\n.wizard-add-entity .affectation-pct-input {\n  width: 55px;\n  padding: 5px 8px;\n  border: 2px solid #3B82F6;\n  border-radius: 5px;\n  font-size: 15px;\n  text-align: center;\n  background: #EFF6FF;\n  font-weight: 700;\n  color: #1E40AF;\n}\n\n.wizard-add-entity .affectation-pct-input:hover {\n  background: #DBEAFE;\n}\n\n.wizard-add-entity .affectation-pct-input:focus {\n  outline: none;\n  border-color: #2563EB;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n.wizard-add-entity .affectation-detail-btn {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px solid #CBD5E1;\n  background: white;\n  color: #64748B;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  transition: all 0.15s;\n}\n\n.wizard-add-entity .affectation-detail-btn:hover {\n  background: #EFF6FF;\n  border-color: #3B82F6;\n  color: #3B82F6;\n  transform: scale(1.1);\n}\n\n/* Ligne Dividendes résultat */\n.wizard-add-entity .section-row.dividendes-result-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  border: 1px solid #A7F3D0;\n  border-left: 4px solid #10B981;\n  border-radius: 6px;\n  padding: 8px 14px;\n  margin: 4px 8px 4px 20px;\n  gap: 16px;\n}\n\n.wizard-add-entity .dividendes-result-row .section-label {\n  color: #047857;\n  font-weight: 600;\n  font-size: 14px;\n  gap: 8px;\n}\n\n.wizard-add-entity .dividendes-result-row .section-value {\n  color: #047857;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.wizard-add-entity .tax-year-badge {\n  font-size: 11px;\n  padding: 3px 8px;\n  background: #DBEAFE;\n  color: #1D4ED8;\n  border-radius: 10px;\n  margin-left: 6px;\n  font-weight: 600;\n}\n\n/* Ligne Report à nouveau */\n.wizard-add-entity .section-row.report-nouveau-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-left: 3px solid #94A3B8;\n  border-radius: 5px;\n  padding: 6px 14px;\n  margin: 0 8px 0 20px;\n  gap: 16px;\n}\n\n.wizard-add-entity .report-nouveau-row .section-label {\n  color: #64748B;\n  font-weight: 500;\n  font-size: 13px;\n  gap: 6px;\n}\n\n.wizard-add-entity .report-nouveau-row .section-value {\n  color: #475569;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.wizard-add-entity .report-hint {\n  font-size: 10px;\n  color: #94A3B8;\n  margin-left: 6px;\n  font-style: italic;\n}\n\n/* ===================== MODAL AFFECTATION DÉTAIL ===================== */\n\n.wizard-add-entity .affectation-detail-modal {\n  max-width: 450px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.wizard-add-entity .affectation-detail-modal .modal-header {\n  background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);\n  padding: 16px 20px;\n}\n\n.wizard-add-entity .affectation-detail-modal .modal-header h4 {\n  font-size: 16px;\n  color: white;\n  margin: 0;\n}\n\n.wizard-add-entity .affectation-detail-modal .modal-header .close-btn {\n  color: white;\n  opacity: 0.8;\n}\n\n.wizard-add-entity .affectation-detail-modal .modal-header .close-btn:hover {\n  opacity: 1;\n}\n\n.wizard-add-entity .affectation-detail-modal .modal-body {\n  padding: 20px;\n}\n\n.wizard-add-entity .affectation-section {\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-entity .affectation-section:last-of-type {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.wizard-add-entity .affectation-section h5 {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1E293B;\n  margin: 0 0 12px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-entity .section-hint {\n  font-size: 13px;\n  color: #64748B;\n  margin: -8px 0 12px 0;\n  font-style: italic;\n}\n\n.wizard-add-entity .affectation-detail-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  padding: 8px 12px;\n  gap: 16px;\n  background: white;\n  border-radius: 6px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.indent {\n  padding-left: 24px;\n  background: #FAFAFA;\n  border-left: 2px solid #E2E8F0;\n  margin-left: 8px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.total {\n  background: linear-gradient(135deg, #F1F5F9 0%, #E2E8F0 100%);\n  border: 1px solid #CBD5E1;\n  margin-top: 4px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.total .detail-label {\n  font-weight: 700;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green {\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  border: 1px solid #A7F3D0;\n  border-left: 4px solid #10B981;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green .detail-label {\n  color: #047857;\n  font-weight: 600;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.highlight-green .detail-value {\n  color: #047857;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-row.sub-hint {\n  padding: 4px 12px 4px 24px;\n  background: transparent;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-label {\n  font-size: 14px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-label-small {\n  font-size: 12px;\n  color: #64748B;\n  font-style: italic;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1E293B;\n  text-align: right;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-value.neg {\n  color: #DC2626;\n}\n\n.wizard-add-entity .affectation-detail-grid .detail-value.pos {\n  color: #059669;\n}\n\n.wizard-add-entity .affectation-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);\n  border: 1px solid #BFDBFE;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.wizard-add-entity .affectation-note .note-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.wizard-add-entity .affectation-note span:last-child {\n  font-size: 13px;\n  color: #1E40AF;\n  line-height: 1.5;\n}\n\n/* ==================== IS WARNING MODAL ==================== */\n.is-warning-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.is-warning-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 520px;\n  width: 90%;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from { \n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.is-warning-modal .warning-icon {\n  font-size: 48px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.is-warning-modal h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #DC2626;\n  text-align: center;\n  margin: 0 0 16px 0;\n}\n\n.is-warning-modal p {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0 0 12px 0;\n}\n\n.is-warning-modal .warning-detail {\n  color: #6B7280;\n}\n\n.is-warning-modal .warning-list {\n  margin: 12px 0 20px 0;\n  padding-left: 24px;\n}\n\n.is-warning-modal .warning-list li {\n  font-size: 13px;\n  color: #6B7280;\n  margin-bottom: 6px;\n  line-height: 1.5;\n}\n\n.is-warning-modal .warning-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  border-radius: 10px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.is-warning-modal .warning-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  accent-color: #DC2626;\n  cursor: pointer;\n}\n\n.is-warning-modal .warning-checkbox span {\n  font-size: 14px;\n  font-weight: 500;\n  color: #991B1B;\n  line-height: 1.4;\n}\n\n.is-warning-modal .warning-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.is-warning-modal .btn-cancel {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6B7280;\n  background: #F3F4F6;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.is-warning-modal .btn-cancel:hover {\n  background: #E5E7EB;\n  color: #374151;\n}\n\n.is-warning-modal .btn-confirm {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  background: #DC2626;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.is-warning-modal .btn-confirm:hover:not(:disabled) {\n  background: #B91C1C;\n}\n\n.is-warning-modal .btn-confirm:disabled {\n  background: #FCA5A5;\n  cursor: not-allowed;\n}\n\n/* Lock indicator for IS selected on SCI/SNC */\n.wizard-add-entity .regime-option.locked::after {\n  content: '🔒';\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  font-size: 12px;\n}\n\n.wizard-add-entity .regime-option.locked {\n  position: relative;\n  border-color: #F59E0B !important;\n  background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
